// Patch: Exibir ETA Prevista e Chegada Real corretamente para viagens finalizadas
// ...
// <td>
//   {row.ds_status === 'FINALIZADO' || row.STATUS === 'FINALIZADO' ? (
//     <>
//       <div>
//         Previsto: {formatarDataHora(row.DT_ETA_PREVISTA || row.dt_eta_prevista || row.ETA_PREVISTA || row.eta_prevista)}
//       </div>
//       <div style={{ color: '#16a34a', fontWeight: 500 }}>
//         Real: {formatarDataHora(row.DT_CHEGADA_REAL_SJP || row.dt_chegada_real_sjp || row.CHEGADA_REAL_SJP || row.chegada_real_sjp)}
//       </div>
//     </>
//   ) : (
//     <div>-</div>
//   )}
import './ControlTowerModule.css';

import React, { useRef, useState, useEffect } from 'react';
import MiniMap from '../../components/MiniMap';
import { CircleMarker, MapContainer, Popup, TileLayer, useMap } from 'react-leaflet';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CreatableSelect from 'react-select/creatable';
import './ControlTowerModule.css';

// Função para formatar apenas horário (HH:mm) aceitando string, HH:mm:ss e decimal do Excel
const formatarHorario = (dataHora: any): string => {
	if (dataHora == null || dataHora === '') return '-';
    const pad = (n: string | number) => String(n).padStart(2, '0');

	if (typeof dataHora === 'number' && Number.isFinite(dataHora)) {
		const normalized = ((dataHora % 1) + 1) % 1;
		const totalSeconds = Math.round(normalized * 24 * 60 * 60);
		const hours = Math.floor(totalSeconds / 3600) % 24;
		const minutes = Math.floor((totalSeconds % 3600) / 60);
		return `${pad(hours)}:${pad(minutes)}`;
	}

	const raw = String(dataHora).trim().replace(',', '.');

	// Decimal em string vindo do Excel (ex: "0.0138888888")
	if (/^-?\d+(\.\d+)?$/.test(raw)) {
		const asNumber = Number(raw);
		if (Number.isFinite(asNumber)) return formatarHorario(asNumber);
	}

    // Formato "yyyy-MM-dd HH:mm:ss" ou "yyyy-MM-dd HH:mm"
	const match1 = raw.match(/\s(\d{1,2}):(\d{2})(?::(\d{2}))?/);
    if (match1) {
        return `${pad(match1[1])}:${pad(match1[2])}`;
    }

    // Formato ISO com T: "2026-02-18T09:19:24"
	const match2 = raw.match(/T(\d{1,2}):(\d{2})/);
    if (match2) {
        return `${pad(match2[1])}:${pad(match2[2])}`;
    }

	// Se já estiver no formato HH:mm ou HH:mm:ss
	const match3 = raw.match(/^(\d{1,2}):(\d{2})(?::\d{2})?/);
    if (match3) {
        return `${pad(match3[1])}:${pad(match3[2])}`;
    }

	return raw;
};

					const formatarEtaPrevista = (baseDate: Date): string => {
						const dd = String(baseDate.getDate()).padStart(2, '0');
						const mm = String(baseDate.getMonth() + 1).padStart(2, '0');
						const yyyy = baseDate.getFullYear();
						const hh = String(baseDate.getHours()).padStart(2, '0');
						const min = String(baseDate.getMinutes()).padStart(2, '0');
						return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
					};

// Função para formatar data e hora ISO ou string para 'dd/MM/yyyy HH:mm'
// Extrai partes da data diretamente da string para evitar problemas de fuso horário
const formatarDataHora = (dataHora: string): string => {
    if (!dataHora) return '-';
    const pad = (n: string | number) => String(n).padStart(2, '0');

    // Já está no formato brasileiro dd/MM/yyyy
    if (/^\d{2}\/\d{2}\/\d{4}/.test(dataHora)) {
        return dataHora;
    }

    // Formato ISO: "2026-02-18T00:00:00.000Z 6:20" ou "2026-02-18T00:00:00.000Z"
    // Extrai a parte da data diretamente da string sem conversão de fuso
    const isoMatch = dataHora.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
        const ano = isoMatch[1];
        const mes = isoMatch[2];
        const dia = isoMatch[3];
        // Hora vem separada por espaço depois da parte ISO (ex: "6:20")
        const horaMatch = dataHora.match(/\s(\d{1,2}):(\d{2})$/);
        if (horaMatch) {
            return `${dia}/${mes}/${ano} ${pad(horaMatch[1])}:${pad(horaMatch[2])}`;
        }
        return `${dia}/${mes}/${ano}`;
    }

    // Formato "yyyy-MM-dd HH:mm" ou "yyyy-MM-dd"
    const simpleMatch = dataHora.match(/^(\d{4})-(\d{2})-(\d{2})(?:\s(\d{1,2}):(\d{2}))?/);
    if (simpleMatch) {
        const [, ano, mes, dia, h, m] = simpleMatch;
        if (h && m) return `${dia}/${mes}/${ano} ${pad(h)}:${pad(m)}`;
        return `${dia}/${mes}/${ano}`;
    }

    return dataHora;
};

// Calcula a previsão de chegada: data + janela (hora) + transitHoras
// Extrai data via regex para evitar problema de fuso horário
const calcularPrevChegada = (data: string, janela: string, transitHoras: number = 20): string => {
    if (!data || !janela) return '-';
    const pad = (n: number) => String(n).padStart(2, '0');

    // Extrair ano/mês/dia direto da string (evita shift de fuso)
    const dataMatch = data.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (!dataMatch) return '-';
    const [, ano, mes, dia] = dataMatch;

    // Extrair hora e minuto da janela (ex: '6:20')
    const janelaMatch = janela.match(/(\d{1,2}):(\d{2})/);
    if (!janelaMatch) return '-';
    const hJanela = parseInt(janelaMatch[1]);
    const mJanela = parseInt(janelaMatch[2]);

    // Construir data usando UTC para evitar conversão de fuso
    const partida = new Date(Date.UTC(Number(ano), Number(mes) - 1, Number(dia), hJanela, mJanela, 0));
    partida.setUTCHours(partida.getUTCHours() + transitHoras);

    return `${pad(partida.getUTCDate())}/${pad(partida.getUTCMonth() + 1)}/${partida.getUTCFullYear()} ${pad(partida.getUTCHours())}:${pad(partida.getUTCMinutes())}`;
};

const getPlacaValue = (value: any): string => value?.nm_placa || value?.placa || value?.placaCavalo || '';

const normalizePlaca = (value: any): string =>
	String(value || '')
		.toUpperCase()
		.replace(/[^A-Z0-9]/g, '')
		.trim();

const toCoordNumber = (value: any): number | undefined => {
	if (value === undefined || value === null || value === '') return undefined;
	if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;

	const normalized = String(value).trim().replace(',', '.');
	const parsed = Number(normalized);
	return Number.isFinite(parsed) ? parsed : undefined;
};

const extrairLatLngDoTexto = (valor: any): { lat: number; lng: number } | null => {
	if (!valor) return null;
	const texto = String(valor);
	const match = texto.match(/(-?\d{1,2}(?:[\.,]\d+)?)[,\s]+(-?\d{1,3}(?:[\.,]\d+)?)/);
	if (!match) return null;

	const lat = Number(match[1].replace(',', '.'));
	const lng = Number(match[2].replace(',', '.'));

	if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
	if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;

	return { lat, lng };
};

const ProgramacaoMapAutoFit: React.FC<{ points: Array<{ lat: number; lng: number }> }> = ({ points }) => {
	const map = useMap();

	useEffect(() => {
		if (!points.length) return;

		if (points.length === 1) {
			map.setView([points[0].lat, points[0].lng], 12);
			return;
		}

		const bounds = points.map((p) => [p.lat, p.lng] as [number, number]);
		map.fitBounds(bounds, { padding: [30, 30] });
	}, [map, points]);

	return null;
};

interface Viagem {
	origem: string;
	prevInicio: string;
	inicioReal: string;
	cva?: string;
	veiculo: {
		placaCavalo: string;
		placaCarreta: string;
		tipoCarreta: string;
		id: string;
		rastreador: string;
		tipo: string;
		modelo: string;
	};
	motorista: {
		nome: string;
		tipo: string;
		telefone: string;
	};
	progresso: {
		realizado: number;
		total: number;
		posicao: string; // endereço completo
		restante: number;
		rota: string;
		status: string;
		temp: any;
		tempoParado?: string;
		cidade: string;
		lat?: number;
		lng?: number;
		destinoNome: string; // nome do destino baseado no sentido
	};
	destino: {
		nome: string;
		prevFim: string; // Prev. Chegada calculada (janela + transit time)
		transit: string;
		totalPrev: string;
		chegada: string; // Chegada real registrada
	};
}

const mockViagens: Viagem[] = [
	{
		origem: 'Volks Anchieta',
		prevInicio: '25/07/2024 21:00',
		inicioReal: '24/07/2024 00:00',
		veiculo: {
			placaCavalo: 'FKS1A74',
			placaCarreta: 'ABC1B23',
			tipoCarreta: 'Reta',
			id: '1231',
			rastreador: '6031788',
			tipo: 'Cavalo 6x4',
			modelo: 'Constellation 24.280',
		},
		motorista: {
			nome: 'RAFAEL PAULO DA CONCEICAO SOARES',
			tipo: 'Free',
			telefone: '(11) 99999-9999',
		},
		progresso: {
			realizado: 560,
			total: 581,
			posicao: '10/07/2024 14:52',
			cidade: 'Curitiba',
			restante: 21,
			rota: 'Volkswagen SBC x Volkswagen SJP',
			status: 'Parado Ligado',
			temp: null,
			tempoParado: '00:32',
			destinoNome: 'Volkswagen SJP',
		},
		destino: {
			nome: 'Volks SJP',
			prevFim: '26/07/2024 17:00',
			transit: '1 dia, 15h, 44 min.',
			totalPrev: '20h',
			chegada: '-',
		},
	},
	// ...adicione mais objetos para simular outras viagens
	{
		origem: 'Volks Anchieta',
		prevInicio: '18/02/2026 18:40',
		inicioReal: '-',
		veiculo: {
			placaCavalo: '-',
			placaCarreta: '-',
			tipoCarreta: '-',
			id: '-',
			rastreador: '-',
			tipo: '-',
			modelo: '-',
		},
		motorista: {
			nome: '-',
			tipo: 'Free',
			telefone: '-',
		},
		progresso: {
			realizado: 0,
			total: 581,
			posicao: '-',
			cidade: '-',
			restante: 581,
			rota: 'Volkswagen SBC x Volkswagen SJP',
			status: 'Aguardando veículo',
			temp: null,
			tempoParado: '-',
			destinoNome: 'Volkswagen SJP',
		},
		destino: {
			nome: 'Volks SJP',
			prevFim: '18/02/2026 18:40',
			transit: '-',
			totalPrev: '10h',
			chegada: '-',
		},
	}
	];

		const excelColumns = [
			'STATUS', 'DATA', 'JANELA', 'VIRA DO CVA', 'CVA', 'FKS', 'CONTRATO', 'VALE PEDAGIO', 'CTE/MANIFESTO', 'CAVALO', 'CARRETA', 'CHEGADA', 'SAÍDA'
		];

		const WINDOW_SCHEDULE_STORAGE_KEY = 'controltower.windowSchedules.v1';

	const ControlTowerModule: React.FC = () => {
		// Estado para os status das linhas padrão
		const [rowStatuses, setRowStatuses] = useState<string[]>([]);
		// Novo estado para busca por CVA
		const [buscaCVA, setBuscaCVA] = useState('');
		const [viagemSelecionada, setViagemSelecionada] = useState<Viagem | null>(null);
		const [abaDetalhe, setAbaDetalhe] = useState<'detalhes' | 'posicoes' | 'eventos' | 'mensagens' | 'produtividade' | 'temperatura' | 'alertas'>('detalhes');
		const [viewMode, setViewMode] = useState<'viagem' | 'transito' | 'programacao' | 'sugestoes' | 'geral'>('viagem');
		const [importedRows, setImportedRows] = useState<any[]>([]);
		const [programacaoRows, setProgramacaoRows] = useState<any[]>([]);
		const [nextDayRows, setNextDayRows] = useState<any[]>([]);
	const [previousDayProgramacaoRows, setPreviousDayProgramacaoRows] = useState<any[]>([]);
		const [pendingRows, setPendingRows] = useState<any[]|null>(null);
		const [showConfirm, setShowConfirm] = useState(false);
		const [isSaving, setIsSaving] = useState(false);
		const [selectedDate, setSelectedDate] = useState<Date | null>(() => {
	    // Sempre inicia com a data de hoje
	    const today = new Date();
	    today.setHours(0,0,0,0);
	    return today;
	});
		const [loadingRows, setLoadingRows] = useState(false);
	const [isSyncingNucciManual, setIsSyncingNucciManual] = useState(false);
	const [availableDates, setAvailableDates] = useState<string[]>([]);
	const [saveStatus, setSaveStatus] = useState<{rowIdx: number, status: 'saving' | 'success' | 'error'} | null>(null);
	const [veiculosSugeridos, setVeiculosSugeridos] = useState<{[key: number]: string}>({});
	const [veiculosVolks, setVeiculosVolks] = useState<any[]>([]);
	const [carretasDisponiveis, setCarretasDisponiveis] = useState<any[]>([]);
	const [hoveredCavalo, setHoveredCavalo] = useState<string|null>(null);
	const [cavaloCoords, setCavaloCoords] = useState<{lat: number, lng: number}|null>(null);
	const [veiculosMonitoramento, setVeiculosMonitoramento] = useState<any[]>([]);
	const [showProximosRowIdx, setShowProximosRowIdx] = useState<number | null>(null);
	const [windowSchedules, setWindowSchedules] = useState<Record<string, string[]>>({});
	const [showWindowModal, setShowWindowModal] = useState(false);
	const [showCanceledRows, setShowCanceledRows] = useState(true);
	const [showSugestoesModal, setShowSugestoesModal] = useState(false);
	const [savingSugestoes, setSavingSugestoes] = useState(false);
	const [filtroSugestoesModal, setFiltroSugestoesModal] = useState<'voltando' | 'patio' | 'transito'>('voltando');
	const [sugestoesPreview, setSugestoesPreview] = useState<Array<{ rowIdx: number; horario: string; placa: string; km: number; statusVeiculo: string; localVeiculo: string }>>([]);
	const [sugestoesOpcoes, setSugestoesOpcoes] = useState<Array<{ placa: string; km: number; statusVeiculo: string; localVeiculo: string; categoria: 'voltando' | 'patio' | 'transito' }>>([]);
	const [veiculosCategoriaPage, setVeiculosCategoriaPage] = useState(1);
	const [programacaoSugestoesPage, setProgramacaoSugestoesPage] = useState(1);
	const [programacaoFiltroJanela, setProgramacaoFiltroJanela] = useState('todos');
	const [programacaoFiltroStatus, setProgramacaoFiltroStatus] = useState('todos');
	const [programacaoFiltroFks, setProgramacaoFiltroFks] = useState('todos');
	const [copyLocalFeedback, setCopyLocalFeedback] = useState('Clique no Local do veículo para copiar o lat/long.');
	const [windowFormDate, setWindowFormDate] = useState('');
	const [windowFormTimes, setWindowFormTimes] = useState('');
	const [isSavingWindowSchedule, setIsSavingWindowSchedule] = useState(false);
	const [isLoadingWindowsFromNucci, setIsLoadingWindowsFromNucci] = useState(false);
	const [approvingWindowKey, setApprovingWindowKey] = useState<string | null>(null);
	const [approvedWindowKeys, setApprovedWindowKeys] = useState<Set<string>>(new Set());
	const [selectedProgramacaoRows, setSelectedProgramacaoRows] = useState<Set<string>>(new Set());
	const [isApprovingSelected, setIsApprovingSelected] = useState(false);
	const [trajetoriaPontos, setTrajetoriaPontos] = useState<Array<{ lat: number; lng: number; timestamp?: string }>>([]);
	const [loadingTrajetoria, setLoadingTrajetoria] = useState(false);
	const [transitoAllRows, setTransitoAllRows] = useState<any[]>([]);
	const [loadingTransito, setLoadingTransito] = useState(false);
	const [sentidoTransito, setSentidoTransito] = useState<'todos' | 'ida' | 'volta'>('todos');
	const [transitoQuickFilter, setTransitoQuickFilter] = useState<'todos' | 'no-prazo' | 'atencao' | 'atrasada'>('todos');
	const [transitoStatusFilter, setTransitoStatusFilter] = useState('todos');
	const [transitoSituacaoFilter, setTransitoSituacaoFilter] = useState('todos');
	const [transitoLocalizacaoFilter, setTransitoLocalizacaoFilter] = useState('todos');
	const [transitoPage, setTransitoPage] = useState(1);
	const menuPortalTarget = typeof document !== 'undefined' ? document.body : null;

	const dateToKey = (date: Date | null): string => (date ? date.toISOString().split('T')[0] : '');

	const normalizeJanela = (value: any): string => {
		if (value == null) return '';
		const raw = String(value).trim();
		const match = raw.match(/^(\d{1,2}):(\d{2})$/) || raw.match(/(\d{1,2}):(\d{2})/);
		if (!match) return '';
		const h = parseInt(match[1], 10);
		const m = parseInt(match[2], 10);
		if (Number.isNaN(h) || Number.isNaN(m) || h < 0 || h > 23 || m < 0 || m > 59) return '';
		return `${h}:${String(m).padStart(2, '0')}`;
	};

	const janelaToMinutes = (janela: string): number => {
		const match = janela.match(/^(\d{1,2}):(\d{2})$/);
		if (!match) return Number.MAX_SAFE_INTEGER;
		return parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
	};

	const parseWindowTimes = (rawTimes: string): string[] => {
		const normalized = rawTimes
			.split(/\r?\n|,|;/)
			.map(item => normalizeJanela(item))
			.filter(Boolean);

		return Array.from(new Set(normalized)).sort((a, b) => janelaToMinutes(a) - janelaToMinutes(b));
	};

	const getConfiguredHorarios = (dateStr: string): string[] => {
		if (!dateStr) return [];
		const values = windowSchedules[dateStr] || [];
		return Array.from(new Set(values.map(v => normalizeJanela(v)).filter(Boolean)))
			.sort((a, b) => janelaToMinutes(a) - janelaToMinutes(b));
	};

	const fetchWindowsFromNucci = async (dateStr: string): Promise<string[]> => {
		if (!dateStr) return [];
		try {
			setIsLoadingWindowsFromNucci(true);
			const response = await fetch(`/api/controltower/programacao/buscar-janelas?data=${dateStr}`);
			if (!response.ok) {
				console.warn('Não foi possível buscar janelas do Nucci:', response.statusText);
				return [];
			}
			const data = await response.json();
			// Retornar array com formato: "HH:mm - CVA: XXXXX"
			return (data.janelas || []).map((j: any) => j.displayText).filter(Boolean);
		} catch (err) {
			console.error('Erro ao buscar janelas do Nucci:', err);
			return [];
		} finally {
			setIsLoadingWindowsFromNucci(false);
		}
	};

	const openWindowConfigModal = () => {
		const selectedDateKey = dateToKey(selectedDate) || new Date().toISOString().split('T')[0];
		setWindowFormDate(selectedDateKey);
		setShowWindowModal(true);
		
		// Buscar janelas do Nucci para a data selecionada
		fetchWindowsFromNucci(selectedDateKey).then(janelasDoBanco => {
			if (janelasDoBanco && janelasDoBanco.length > 0) {
				// Se encontrou janelas no Nucci, usar essas; caso contrário, usar as configuradas localmente
				setWindowFormTimes(janelasDoBanco.join('\n'));
			} else {
				// Fallback para janelas já configuradas
				setWindowFormTimes((getConfiguredHorarios(selectedDateKey) || []).join('\n'));
			}
		});
	};

	const handleWindowDateChange = (nextDate: string) => {
		setWindowFormDate(nextDate);
		
		// Buscar janelas do Nucci para a nova data
		fetchWindowsFromNucci(nextDate).then(janelasDoBanco => {
			if (janelasDoBanco && janelasDoBanco.length > 0) {
				// Se encontrou janelas no Nucci, usar essas
				setWindowFormTimes(janelasDoBanco.join('\n'));
			} else {
				// Fallback para janelas já configuradas
				setWindowFormTimes((getConfiguredHorarios(nextDate) || []).join('\n'));
			}
		});
	};

	const handleSaveWindowSchedule = async () => {
		if (!windowFormDate) {
			alert('Selecione uma data para cadastrar as janelas.');
			return;
		}

		const horarios = parseWindowTimes(windowFormTimes);
		if (horarios.length === 0) {
			alert('Informe pelo menos um horário válido no formato HH:mm.');
			return;
		}

		setIsSavingWindowSchedule(true);
		try {
			for (const linhaCompleta of windowFormTimes.split(/\r?\n/).filter(l => l.trim())) {
				// Extrair horário e CVA da linha (formato: "06:20 - CVA: 1234")
				const cvaMatch = linhaCompleta.match(/CVA:\s*(.+?)(\s|$)/);
				const cva = cvaMatch ? cvaMatch[1].trim() : '';
				
				// Extrair horário
				const horarioMatch = linhaCompleta.match(/^(\d{1,2}):(\d{2})/);
				if (!horarioMatch) continue;
				
				const horario = `${String(horarioMatch[1]).padStart(2, '0')}:${horarioMatch[2]}`;

				const response = await fetch('/api/controltower/programacao/salvar', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						field: 'FKS',
						value: '',
						date: windowFormDate,
						horario,
						cva
					})
				});

				if (!response.ok) {
					const errorBody = await response.text();
					throw new Error(`Falha ao salvar janela ${horario}: ${errorBody || response.statusText}`);
				}
			}

			setWindowSchedules(prev => ({ ...prev, [windowFormDate]: horarios }));

			// Sempre recarregar os dados da data salva, independente da data selecionada
			const rowsAtualizadas = await fetchProgramacaoRowsForTable(windowFormDate);
			setProgramacaoRows(rowsAtualizadas);

			// Se a data do formulário for diferente da data selecionada, sincronizar
			const selectedDateKey = dateToKey(selectedDate);
			if (windowFormDate !== selectedDateKey) {
				const [ano, mes, dia] = windowFormDate.split('-').map(Number);
				setSelectedDate(new Date(ano, mes - 1, dia));
			}

			setShowWindowModal(false);
			
			// Mudar para visão Programação para mostrar as janelas configuradas
			setViewMode('sugestoes');
		} catch (err) {
			console.error('Erro ao salvar janelas no banco:', err);
			alert('Não foi possível salvar as janelas no banco de dados.');
		} finally {
			setIsSavingWindowSchedule(false);
		}
	};

	const handleClearWindowSchedule = () => {
		if (!windowFormDate) return;
		setWindowSchedules(prev => {
			const copy = { ...prev };
			delete copy[windowFormDate];
			return copy;
		});
		setWindowFormTimes('');
	};

	useEffect(() => {
		try {
			const raw = localStorage.getItem(WINDOW_SCHEDULE_STORAGE_KEY);
			if (!raw) return;
			const parsed = JSON.parse(raw);
			if (parsed && typeof parsed === 'object') {
				setWindowSchedules(parsed);
			}
		} catch (err) {
			console.error('Erro ao carregar janelas salvas:', err);
		}
	}, []);

	useEffect(() => {
		try {
			localStorage.setItem(WINDOW_SCHEDULE_STORAGE_KEY, JSON.stringify(windowSchedules));
		} catch (err) {
			console.error('Erro ao salvar janelas localmente:', err);
		}
	}, [windowSchedules]);

	useEffect(() => {
		const selectedDateKey = dateToKey(selectedDate);
		const count = getConfiguredHorarios(selectedDateKey).length;
		setRowStatuses(Array(Math.max(count, 1)).fill('Aguardando veículo'));
	}, [selectedDate, windowSchedules]);

	// Coordenadas das localizações
	const COORDS_VW_SBC = { lat: -23.6868, lng: -46.5651 }; // Volkswagen Anchieta - São Bernardo do Campo, SP
	const COORDS_VW_SJP = { lat: -25.5318, lng: -49.2085 }; // Volkswagen SJP - São José dos Pinhais, PR
	const DISTANCIA_TOTAL_ROTA = 581; // km

	// Função para calcular distância entre dois pontos (Haversine)
	const calcularDistancia = (lat1: number, lng1: number, lat2: number, lng2: number): number => {
		const R = 6371; // Raio da Terra em km
		const dLat = (lat2 - lat1) * Math.PI / 180;
		const dLng = (lng2 - lng1) * Math.PI / 180;
		const a = 
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
			Math.sin(dLng / 2) * Math.sin(dLng / 2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		return R * c;
	};

	// Função para formatar tempo parado em minutos para formato legível
	const formatarTempoParado = (minutos: number | undefined): string => {
		if (!minutos || minutos === 0) return '0 min';
		
		const horas = Math.floor(minutos / 60);
		const mins = minutos % 60;
		
		if (horas > 0) {
			return mins > 0 ? `${horas}h ${mins}min` : `${horas}h`;
		}
		return `${mins}min`;
	};

	// Função para extrair cidade do endereço
	const extrairCidade = (endereco: string): string => {
		if (!endereco || endereco === '-') return '-';
		
		// Formato típico: "Rua, Bairro, Cidade, Região Imediata, RMBS, Região Geográfica, Estado, Região"
		const partes = endereco.split(',').map(p => p.trim());
		
		// Procurar pela cidade (geralmente a 3ª parte em endereços brasileiros detalhados)
		if (partes.length >= 3) {
			// Tentar a terceira posição (índice 2) que geralmente é a cidade
			const cidadeCandidato = partes[2]?.trim();
			if (cidadeCandidato && 
				!cidadeCandidato.toLowerCase().includes('região') && 
				!cidadeCandidato.toLowerCase().includes('rmbs') &&
				cidadeCandidato.length > 2 && 
				!/^\d+$/.test(cidadeCandidato)) {
				return cidadeCandidato;
			}
			
			// Se não funcionou, tentar a penúltima parte
			const penultima = partes[partes.length - 2]?.trim();
			if (penultima && 
				!penultima.toLowerCase().includes('região') &&
				penultima.length > 2 && 
				!/^\d+$/.test(penultima) &&
				penultima.length < 30) {
				return penultima;
			}
		}
		
		// Se só tem 2 partes, a primeira geralmente é a cidade
		if (partes.length === 2) {
			return partes[0];
		}
		
		// Se não conseguir extrair, retorna o endereço original (limitado a 50 caracteres)
		return endereco.length > 50 ? endereco.substring(0, 50) + '...' : endereco;
	};

	// Buscar carretas disponíveis ao montar
	useEffect(() => {
		async function fetchCarretas() {
			try {
				const resp = await fetch('/api/diario-veiculos/carretas');
				const carretas = await resp.json();
				setCarretasDisponiveis(carretas);
			} catch (err) {
				console.error('Erro ao buscar carretas:', err);
				setCarretasDisponiveis([]);
			}
		}
		fetchCarretas();
	}, []);

	// Buscar veículos Volks ao montar
	useEffect(() => {
		async function fetchVeiculosVolks() {
			try {
				const resp = await fetch('/api/monitoramento/veiculos');
				const veiculos = await resp.json();
				console.log('Veículos recebidos para dropdown:', veiculos.length, veiculos);
				let veiculosFiltrados = veiculos.filter((v: any) => {
					const op = v.operacao || v.ds_operacao || '';
					return typeof op === 'string' && op.toLowerCase().includes('volks');
				});
				if (veiculosFiltrados.length === 0) {
					console.warn('[ControlTower] Nenhum veículo Volks identificado por operação. Usando lista completa como fallback.');
					veiculosFiltrados = veiculos;
				}
				console.log('Veículos Volks filtrados para dropdown:', veiculosFiltrados.length, veiculosFiltrados);
				setVeiculosVolks(veiculosFiltrados);
			} catch (err) {
				console.error('Erro ao buscar veículos Volks:', err);
				setVeiculosVolks([]);
			}
		}
		fetchVeiculosVolks();
	}, []);

	// Buscar dados do monitoramento em tempo real
	useEffect(() => {
		const fetchVeiculosMonitoramento = async () => {
			try {
				const resp = await fetch('/api/monitoramento/veiculos');
				const veiculos = await resp.json();
				setVeiculosMonitoramento(veiculos);
				
				// Log para debug dos veículos e tempos parados
				console.log(`[MONITORAMENTO] ${veiculos.length} veículos carregados`);
				const veiculosComTempoParado = veiculos.filter((v: any) => v.tempoParado && v.tempoParado > 0);
				if (veiculosComTempoParado.length > 0) {
					console.log('[MONITORAMENTO] Veículos com tempo parado:', veiculosComTempoParado.map((v: any) => ({
						placa: v.placa || v.nm_placa,
						tempoParado: v.tempoParado,
						status: v.status
					})));
				}
			} catch (err) {
				console.error('Erro ao buscar dados do monitoramento:', err);
			}
		};

		// Busca inicial
		fetchVeiculosMonitoramento();

		// Atualizar a cada 30 segundos
		const interval = setInterval(fetchVeiculosMonitoramento, 30000);

		return () => clearInterval(interval);
	}, []);

	const [loadingSugestoes, setLoadingSugestoes] = useState(false);
	const fileInputRef = useRef<HTMLInputElement>(null);

	// Função para buscar coordenadas do cavalo selecionado
	const buscarCoordsCavalo = (placa: string) => {
		console.log('� Buscando coords para placa:', placa);
		const placaNormalizada = normalizePlaca(placa);
		const v = veiculosVolks.find((v: any) => {
			const p = getPlacaValue(v);
			return normalizePlaca(p) === placaNormalizada;
		});
		
		if (v) {
			console.log('🚗 Veículo encontrado:', v.placa);
			console.log('📍 Objeto localização:', v.localizacao);
			
			const lat = toCoordNumber(v.latitude ?? v.lat ?? v.localizacao?.lat ?? v.localizacao?.latitude);
			const lng = toCoordNumber(v.longitude ?? v.lng ?? v.localizacao?.lng ?? v.localizacao?.longitude);
			
			if (lat !== undefined && lng !== undefined) {
				const coords = {
					lat,
					lng
				};
				console.log('✅ Coordenadas definidas:', coords);
				setCavaloCoords(coords);
			} else {
				console.log('❌ Sem coordenadas para', placa, { latitude: v.latitude, longitude: v.longitude, lat: v.lat, lng: v.lng, localizacao: v.localizacao });
				setCavaloCoords(null);
			}
		} else {
			console.log('❌ Veículo não encontrado:', placa);
			setCavaloCoords(null);
		}
	};

	const parseBrDateTime = (value?: string): Date | null => {
		if (!value) return null;
		const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s(\d{1,2}):(\d{2}))?/);
		if (!match) return null;
		const dia = Number(match[1]);
		const mes = Number(match[2]);
		const ano = Number(match[3]);
		const hora = Number(match[4] || 0);
		const minuto = Number(match[5] || 0);
		const parsed = new Date(ano, mes - 1, dia, hora, minuto, 0, 0);
		return Number.isNaN(parsed.getTime()) ? null : parsed;
	};

	const formatDateForApi = (value: Date): string => {
		const ano = value.getFullYear();
		const mes = String(value.getMonth() + 1).padStart(2, '0');
		const dia = String(value.getDate()).padStart(2, '0');
		const hora = String(value.getHours()).padStart(2, '0');
		const minuto = String(value.getMinutes()).padStart(2, '0');
		return `${ano}-${mes}-${dia}T${hora}:${minuto}`;
	};

	const mergeDateAndTime = (dateLabel?: string, timeLabel?: string): Date | null => {
		if (!dateLabel || !timeLabel || timeLabel === '-') return null;

		const baseDate = parseBrDateTime(dateLabel);
		if (!baseDate) return null;

		const timeMatch = String(timeLabel).match(/(\d{1,2}):(\d{2})/);
		if (!timeMatch) return parseBrDateTime(timeLabel);

		const merged = new Date(baseDate);
		merged.setHours(Number(timeMatch[1]), Number(timeMatch[2]), 0, 0);
		return Number.isNaN(merged.getTime()) ? null : merged;
	};

	useEffect(() => {
		const fetchTrajetoriaViagem = async () => {
			if (!viagemSelecionada || abaDetalhe !== 'posicoes') {
				setTrajetoriaPontos([]);
				return;
			}

			const placa = (viagemSelecionada.veiculo.placaCavalo || '').trim();
			if (!placa) {
				setTrajetoriaPontos([]);
				return;
			}

			setLoadingTrajetoria(true);
			try {
				const inicioPrevisto = parseBrDateTime(viagemSelecionada.prevInicio);
				const inicioReal = mergeDateAndTime(viagemSelecionada.prevInicio, viagemSelecionada.inicioReal);
				const inicioViagem = inicioReal || inicioPrevisto;
				const chegadaReal = mergeDateAndTime(viagemSelecionada.prevInicio, viagemSelecionada.destino.chegada);
				if (chegadaReal && inicioViagem && chegadaReal < inicioViagem) {
					chegadaReal.setDate(chegadaReal.getDate() + 1);
				}

				const inicioConsulta = inicioViagem ? new Date(inicioViagem.getTime() - (20 * 60 * 1000)) : new Date(Date.now() - (6 * 60 * 60 * 1000));
				const fimConsulta = chegadaReal || new Date();
				const query = new URLSearchParams({
					placa,
					dataInicio: formatDateForApi(inicioConsulta),
					dataFim: formatDateForApi(fimConsulta)
				});
				const resp = await fetch(`/api/levantamento-posicoes/posicoes?${query.toString()}`);
				const data = await resp.json();
				const rows = Array.isArray(data) ? data : [];

				const pontosBase = rows
					.map((item: any) => {
						const lat = toCoordNumber(item.nr_latitude ?? item.latitude ?? item.lat);
						const lng = toCoordNumber(item.nr_longitude ?? item.longitude ?? item.lng);
						if (lat === undefined || lng === undefined) return null;

						const timestamp = item.dt_registro || item.timestamp || null;
						return {
							lat,
							lng,
							timestamp: timestamp ? String(timestamp) : undefined
						};
					})
					.filter((item: any) => {
						if (!item || !item.timestamp) return true;
						const pointDate = new Date(item.timestamp);
						if (Number.isNaN(pointDate.getTime())) return true;
						if (pointDate < inicioConsulta) return false;
						if (pointDate > fimConsulta) return false;
						return true;
					})
					.filter(Boolean) as Array<{ lat: number; lng: number; timestamp?: string }>;

				// Remove pontos consecutivos duplicados para manter a trilha limpa.
				const pontosUnicos = pontosBase.filter((ponto, idx, arr) => {
					if (idx === 0) return true;
					const anterior = arr[idx - 1];
					return !(Math.abs(ponto.lat - anterior.lat) < 0.00001 && Math.abs(ponto.lng - anterior.lng) < 0.00001);
				});

				setTrajetoriaPontos(pontosUnicos);
			} catch (err) {
				console.error('Erro ao carregar trajetória da viagem:', err);
				setTrajetoriaPontos([]);
			} finally {
				setLoadingTrajetoria(false);
			}
		};

		fetchTrajetoriaViagem();
	}, [viagemSelecionada, abaDetalhe, veiculosMonitoramento]);
	// Busca os dados da data selecionada (para ambas as visões: programação e monitoramento)
	useEffect(() => {
		if (selectedDate) {
			const dateStr = selectedDate.toISOString().split('T')[0];
			console.log('[DEBUG API] useEffect disparado - selectedDate:', dateStr, 'viewMode:', viewMode);
			// Limpar dados antigos antes de buscar
			setImportedRows([]);
			setProgramacaoRows([]);
			fetchRowsByDate(dateStr);
			fetchProgramacaoRowsByDate(dateStr);

			const nextDate = new Date(selectedDate);
			nextDate.setDate(nextDate.getDate() + 1);
			const nextDateStr = nextDate.toISOString().split('T')[0];
			fetchRowsForTable(nextDateStr).then(rows => setNextDayRows(rows));

			const prevDate = new Date(selectedDate);
			prevDate.setDate(prevDate.getDate() - 1);
			const prevDateStr = prevDate.toISOString().split('T')[0];
			fetchProgramacaoRowsForTable(prevDateStr).then(rows => setPreviousDayProgramacaoRows(rows));
		} else {
			setNextDayRows([]);
			setPreviousDayProgramacaoRows([]);
		}
	}, [selectedDate]);

	// Atualização periódica da grade para refletir mudanças automáticas de status vindas do backend.
	useEffect(() => {
		if (!selectedDate) return;
		if (viewMode !== 'programacao' && viewMode !== 'viagem' && viewMode !== 'geral') return;

		let active = true;
		const dateStr = selectedDate.toISOString().split('T')[0];

		const refreshRows = async () => {
			try {
				const rows = await fetchRowsForTable(dateStr);
				if (!active) return;
				setImportedRows(rows);
			} catch (err) {
				if (!active) return;
				console.error('Erro ao atualizar dados da programação automaticamente:', err);
			}
		};

		const interval = setInterval(refreshRows, 15000);

		return () => {
			active = false;
			clearInterval(interval);
		};
	}, [selectedDate, viewMode]);

		// Buscar todos os registros em trânsito (sem filtro de data) ao entrar no modo
		useEffect(() => {
			if (viewMode !== 'transito') return;
			setLoadingTransito(true);
			setTransitoPage(1);
			fetch('/api/controltower/listar-transito')
				.then(r => r.json())
				.then(data => setTransitoAllRows(data.rows || []))
				.catch(() => setTransitoAllRows([]))
				.finally(() => setLoadingTransito(false));
		}, [viewMode]);

		useEffect(() => {
			if (viewMode !== 'transito') return;
			setTransitoPage(1);
		}, [viewMode, sentidoTransito, transitoQuickFilter, transitoStatusFilter, transitoSituacaoFilter, transitoLocalizacaoFilter, buscaCVA]);

		const salvarTransitoUpdate = async (rowId: number, payload: Record<string, any>, patch: Record<string, any>) => {
			await fetch(`/api/controltower/transito-update/${rowId}`, {
				method: 'PUT',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(payload)
			});

			setTransitoAllRows(prev => prev.map((row: any) => (
				row['_id'] === rowId ? { ...row, ...patch } : row
			)));
		};

		// Auto-salvar dt_saida_planta quando detectada via monitoramento (polígono Anchieta)
		useEffect(() => {
			if (viewMode !== 'transito' || transitoAllRows.length === 0 || veiculosMonitoramento.length === 0) return;
			transitoAllRows.forEach((row: any) => {
				if (row['DT_SAIDA_PLANTA']) return; // já registrado no DB
				const rowId = row['_id'];
				if (!rowId) return;
				const placa = String(row['CAVALO'] || row['cavalo'] || '');
				if (!placa) return;
				const placaNorm = normalizePlaca(placa);
				const vm = veiculosMonitoramento.find((v: any) => normalizePlaca(getPlacaValue(v)) === placaNorm);
				if (!vm) return;
				if (!saiuDaPlantaAnchieta(vm)) return;
				const horaSaida = vm.horarioSaidaUltimoPoligono;
				if (!horaSaida) return;
				// Salvar no banco e atualizar estado local
				salvarTransitoUpdate(rowId, { dt_saida_planta: horaSaida }, { DT_SAIDA_PLANTA: horaSaida });
			});
		}, [transitoAllRows, veiculosMonitoramento, viewMode]);

		// Buscar datas disponíveis ao montar o componente
		useEffect(() => {
			async function fetchAvailableDates() {				try {
					const res = await fetch('/api/controltower/datas-disponiveis');
					const data = await res.json();
					// Garantir que as datas são strings válidas no formato yyyy-MM-dd
					const validDates = (data.datas || []).filter((d: any) => {
						if (typeof d === 'string') return /^\d{4}-\d{2}-\d{2}/.test(d);
						return false;
					});
					setAvailableDates(validDates);
				} catch (err) {
					console.error('Erro ao buscar datas disponíveis:', err);
				}
			}
			fetchAvailableDates();
		}, []);
	const normalizarTexto = (value: any): string =>
		String(value || '')
			.trim()
			.toLowerCase()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '');

	const isPoligonoAnchieta = (value: any): boolean => {
		const nome = normalizarTexto(value);
		return nome.includes('volks anchieta') || nome.includes('anchieta');
	};

	const isSubpoligonoAnchieta = (value: any): boolean => {
		const nome = normalizarTexto(value);
		return nome.includes('ala13') || nome.includes('ala 13') || nome.includes('bolsao') || nome.includes('patio') || nome.includes('doca');
	};

	const isPoligonoPrincipalAnchieta = (value: any): boolean =>
		isPoligonoAnchieta(value) && !isSubpoligonoAnchieta(value);

	const saiuDaPlantaAnchieta = (vm: any): boolean => {
		const poligonoAtual = vm?.poligono || vm?.nm_poligono_atual || vm?.poligonoAtual || '';
		const ultimoPoligono = vm?.ultimoPoligono || vm?.ultimo_poligono || '';
		return !isPoligonoAnchieta(poligonoAtual) && isPoligonoPrincipalAnchieta(ultimoPoligono);
	};

	const calcularSugestoesVeiculos = async (): Promise<{
		sugestoes: Array<{ rowIdx: number; horario: string; placa: string; km: number; statusVeiculo: string; localVeiculo: string }>;
		opcoes: Array<{ placa: string; km: number; statusVeiculo: string; localVeiculo: string; categoria: 'voltando' | 'patio' | 'transito' }>;
	}> => {
		if (!selectedDate) return { sugestoes: [], opcoes: [] };

		const resp = await fetch('/api/monitoramento/veiculos');
		const veiculos = await resp.json();
		console.log('[SUGESTAO MODAL] Total de veículos recebidos:', veiculos.length);

		const isVoltando = (vm: any) => {
			const sentido = normalizarTexto(vm.sentidoRota || vm.ds_sentido_rota);
			return sentido === 'volta' || sentido.includes('volt');
		};

		const isVolks = (vm: any) => {
			const op = normalizarTexto(vm.operacao || vm.ds_operacao);
			return op.includes('volks');
		};

		const hasProblemaRastreador = (vm: any) => {
			if (vm?.problemaRastreador === true || vm?.problema_rastreador === true) return true;

			const statusCode = normalizarTexto(vm.status || vm.ds_status || vm.status_monitoramento);
			if (statusCode === 'problema_rastreador' || statusCode.includes('problema_rastreador')) return true;

			const ultimaCom = vm.ultimaComunicacao || vm.ultimaComunicacaoOmnilink || vm.dt_ultima_comunicacao;
			if (ultimaCom) {
				const dt = new Date(ultimaCom);
				if (!Number.isNaN(dt.getTime())) {
					const diasSemComunicacao = (Date.now() - dt.getTime()) / (1000 * 60 * 60 * 24);
					if (diasSemComunicacao >= 5) return true;
				}
			}

			const rastreador = normalizarTexto(vm.rastreador || vm.ds_rastreador || vm.tipo_rastreador || vm.status_rastreador);
			const status = normalizarTexto(vm.status || vm.ds_status || vm.status_monitoramento);
			const alerta = normalizarTexto(vm.alerta || vm.alertaRastreador || vm.observacao || vm.observacoes || vm.motivo);

			const texto = `${rastreador} ${status} ${alerta}`;
			if (!texto) return false;

			const padroesProblema = [
				'problema rastreador',
				'rastreador com problema',
				'sem rastreador',
				'sem sinal',
				'sinal perdido',
				'rastreador offline',
				'gps offline',
				'rastreador inoperante',
				'rastreador indisponivel',
				'defeito rastreador'
			];

			return padroesProblema.some((padrao) => texto.includes(padrao));
		};

		let candidatos = veiculos.filter((vm: any) => isVoltando(vm) && isVolks(vm));
		if (candidatos.length === 0) {
			candidatos = veiculos.filter((vm: any) => isVoltando(vm));
		}

		const totalAntesRastreador = candidatos.length;
		candidatos = candidatos.filter((vm: any) => !hasProblemaRastreador(vm));
		console.log('[SUGESTAO MODAL] Removidos por problema de rastreador:', totalAntesRastreador - candidatos.length);

		const parseTempoParadoMin = (value: any): number | null => {
			if (value == null || value === '') return null;
			if (typeof value === 'number' && !Number.isNaN(value)) return value;
			if (typeof value === 'string') {
				const txt = value.trim();
				const hhmm = txt.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
				if (hhmm) {
					const h = parseInt(hhmm[1], 10);
					const m = parseInt(hhmm[2], 10);
					if (!Number.isNaN(h) && !Number.isNaN(m)) return (h * 60) + m;
				}
				const onlyNumber = Number(txt.replace(',', '.'));
				if (!Number.isNaN(onlyNumber)) return onlyNumber;
			}
			return null;
		};

		const formatarStatusVeiculo = (statusRaw: any, tempoParadoRaw: any): string => {
			const statusNorm = normalizarTexto(statusRaw);
			const tempoMin = parseTempoParadoMin(tempoParadoRaw);

			if (statusNorm.includes('movimento') || statusNorm === 'em_movimento') return 'Em movimento';
			if (statusNorm.includes('parado')) {
				if (tempoMin && tempoMin > 0) return `Parado (${formatarTempoParado(tempoMin)})`;
				return 'Parado';
			}
			if (statusNorm.includes('fora_de_rota') || statusNorm.includes('fora de rota')) return 'Fora de rota';
			if (statusNorm.includes('problema_rastreador') || statusNorm.includes('problema rastreador')) return 'Problema rastreador';
			if (statusNorm.includes('desconhecido')) return 'Desconhecido';
			return statusRaw ? String(statusRaw) : 'Desconhecido';
		};

		const formatarLocalVeiculo = (vm: any): string => {
			const textoValido = (v: any): string => {
				const txt = String(v ?? '').trim();
				const norm = normalizarTexto(txt);
				if (!txt) return '';
				if (['-', '--', '—'].includes(txt)) return '';
				if (['null', 'undefined', 'na', 'n/a', 'nao informado', 'não informado'].includes(norm)) return '';
				return txt;
			};

			const poligono = textoValido(
				vm?.poligono || vm?.nm_poligono_atual || vm?.ultimoPoligono || vm?.ultimo_poligono || vm?.poligonoAtual
			);

			const rawLat = vm?.latitude ?? vm?.lat ?? vm?.localizacao?.lat ?? vm?.localizacao?.latitude;
			const rawLng = vm?.longitude ?? vm?.lng ?? vm?.localizacao?.lng ?? vm?.localizacao?.longitude;
			const lat = rawLat != null ? Number(rawLat) : null;
			const lng = rawLng != null ? Number(rawLng) : null;
			if (lat != null && lng != null && !Number.isNaN(lat) && !Number.isNaN(lng)) {
				const latLng = `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
				return poligono ? `${poligono} (${latLng})` : latLng;
			}

			if (poligono) return poligono;

			const endereco = textoValido(
				vm?.localizacao?.endereco ||
				vm?.endereco ||
				vm?.ds_endereco ||
				vm?.enderecoCompleto ||
				vm?.endereco_formatado ||
				vm?.localizacaoAtual ||
				vm?.ultimaLocalizacao ||
				vm?.posicaoAtual?.endereco ||
				vm?.localizacao?.address
			);
			if (endereco) return endereco.length > 80 ? `${endereco.slice(0, 80)}...` : endereco;

			return 'Local não informado';
		};

		const candidatosComKm = candidatos
			.map((vm: any) => {
				const rawLat = vm.latitude ?? vm.lat ?? vm.localizacao?.lat ?? vm.localizacao?.latitude;
				const rawLng = vm.longitude ?? vm.lng ?? vm.localizacao?.lng ?? vm.localizacao?.longitude;
				const lat = rawLat != null ? Number(rawLat) : null;
				const lng = rawLng != null ? Number(rawLng) : null;
				if (lat == null || lng == null || Number.isNaN(lat) || Number.isNaN(lng)) return null;
				const placa = vm.nm_placa || vm.placa || vm.placaCavalo || '';
				if (!placa) return null;
				const km = Math.round(calcularDistancia(lat, lng, COORDS_VW_SBC.lat, COORDS_VW_SBC.lng));
				const statusVeiculo = formatarStatusVeiculo(vm.status || vm.ds_status || vm.status_monitoramento, vm.tempoParado ?? vm.nr_tempo_parado);
				const localVeiculo = formatarLocalVeiculo(vm);
				return { placa, km, statusVeiculo, localVeiculo };
			})
			.filter((v: any) => v != null)
			.sort((a: any, b: any) => a.km - b.km);

		if (candidatosComKm.length === 0) {
			throw new Error('Nenhum veículo voltando com coordenadas válidas foi encontrado.');
		}

		const linhas = getMergedRows(programacaoRows, true);
		const horariosConfigurados = getConfiguredHorarios(dateToKey(selectedDate));
		const linhasAlvo = (horariosConfigurados.length > 0
			? horariosConfigurados.map((horario, rowIdx) => ({ rowIdx, horario: normalizeJanela(horario) || horario }))
			: linhas
				.map((linha: any, rowIdx: number) => ({ rowIdx, horario: normalizeJanela(linha?.JANELA || linha?.janela || '') }))
				.filter((item: any) => !!item.horario)
		);

		if (linhasAlvo.length === 0) {
			throw new Error('Nenhuma janela foi encontrada na data selecionada.');
		}

		const placasJaUsadas = new Set<string>();
		linhas.forEach((linha: any) => {
			const cavalo = String(linha?.CAVALO || '').trim().toUpperCase();
			if (cavalo) placasJaUsadas.add(cavalo);
		});

		const sugestoes: Array<{ rowIdx: number; horario: string; placa: string; km: number; statusVeiculo: string; localVeiculo: string }> = [];
		let candidatoIdx = 0;

		linhasAlvo.forEach(({ horario, rowIdx }: any) => {
			const linha = linhas[rowIdx] || {};
			const status = normalizarTexto(linha.STATUS || 'Aguardando veículo');
			const cavaloAtual = String(linha.CAVALO || '').trim();
			if (!status.includes('aguardando') || cavaloAtual) return;

			while (candidatoIdx < candidatosComKm.length) {
				const candidato = candidatosComKm[candidatoIdx++];
				const placaUpper = String(candidato.placa).trim().toUpperCase();
				if (!placaUpper || placasJaUsadas.has(placaUpper)) continue;
				placasJaUsadas.add(placaUpper);
				sugestoes.push({ rowIdx, horario, placa: candidato.placa, km: candidato.km, statusVeiculo: candidato.statusVeiculo, localVeiculo: candidato.localVeiculo });
				break;
			}
		});

		const opcoesUnicas: Array<{ placa: string; km: number; statusVeiculo: string; localVeiculo: string; categoria: 'voltando' | 'patio' | 'transito' }> = [];
		const placasOpcoes = new Set<string>();

		// 1. Voltando: já filtrados acima
		candidatosComKm.forEach((item: any) => {
			const key = String(item.placa || '').trim().toUpperCase();
			if (!key || placasOpcoes.has(key)) return;
			placasOpcoes.add(key);
			opcoesUnicas.push({ placa: item.placa, km: item.km, statusVeiculo: item.statusVeiculo, localVeiculo: item.localVeiculo, categoria: 'voltando' });
		});

		// 2. Pátio FKS: qualquer veículo cujo polígono seja Patio FKS (sem problema rastreador)
		const isEmPatio = (vm: any): boolean => {
			const pol = normalizarTexto(vm?.poligono || vm?.nm_poligono_atual || vm?.ultimoPoligono || vm?.ultimo_poligono || vm?.poligonoAtual || '');
			return pol.includes('patio fks') || pol.includes('pátio fks') || pol.includes('pateo fks');
		};

		veiculos
			.filter((vm: any) => !hasProblemaRastreador(vm) && isEmPatio(vm))
			.forEach((vm: any) => {
				const placa = vm.nm_placa || vm.placa || vm.placaCavalo || '';
				if (!placa) return;
				const key = String(placa).trim().toUpperCase();
				if (placasOpcoes.has(key)) return;
				placasOpcoes.add(key);
				const rawLat = vm?.latitude ?? vm?.lat ?? vm?.localizacao?.lat ?? vm?.localizacao?.latitude;
				const rawLng = vm?.longitude ?? vm?.lng ?? vm?.localizacao?.lng ?? vm?.localizacao?.longitude;
				const lat = rawLat != null ? Number(rawLat) : null;
				const lng = rawLng != null ? Number(rawLng) : null;
				const km = (lat != null && lng != null && !Number.isNaN(lat) && !Number.isNaN(lng))
					? Math.round(calcularDistancia(lat, lng, COORDS_VW_SBC.lat, COORDS_VW_SBC.lng))
					: 0;
				const statusVeiculo = formatarStatusVeiculo(vm.status || vm.ds_status || vm.status_monitoramento, vm.tempoParado ?? vm.nr_tempo_parado);
				const localVeiculo = formatarLocalVeiculo(vm);
				opcoesUnicas.push({ placa, km, statusVeiculo, localVeiculo, categoria: 'patio' });
			});

		// 3. Em trânsito: veículos em movimento que não estão no pátio e não são voltando
		veiculos
			.filter((vm: any) => {
				if (hasProblemaRastreador(vm)) return false;
				if (isEmPatio(vm)) return false;
				if (isVoltando(vm)) return false;
				const statusNorm = normalizarTexto(vm.status || vm.ds_status || vm.status_monitoramento || '');
				return statusNorm.includes('movimento') || statusNorm === 'em_movimento';
			})
			.forEach((vm: any) => {
				const placa = vm.nm_placa || vm.placa || vm.placaCavalo || '';
				if (!placa) return;
				const key = String(placa).trim().toUpperCase();
				if (placasOpcoes.has(key)) return;
				placasOpcoes.add(key);
				const rawLat = vm?.latitude ?? vm?.lat ?? vm?.localizacao?.lat ?? vm?.localizacao?.latitude;
				const rawLng = vm?.longitude ?? vm?.lng ?? vm?.localizacao?.lng ?? vm?.localizacao?.longitude;
				const lat = rawLat != null ? Number(rawLat) : null;
				const lng = rawLng != null ? Number(rawLng) : null;
				const km = (lat != null && lng != null && !Number.isNaN(lat) && !Number.isNaN(lng))
					? Math.round(calcularDistancia(lat, lng, COORDS_VW_SBC.lat, COORDS_VW_SBC.lng))
					: 0;
				const statusVeiculo = formatarStatusVeiculo(vm.status || vm.ds_status || vm.status_monitoramento, vm.tempoParado ?? vm.nr_tempo_parado);
				const localVeiculo = formatarLocalVeiculo(vm);
				opcoesUnicas.push({ placa, km, statusVeiculo, localVeiculo, categoria: 'transito' });
			});

		return { sugestoes, opcoes: opcoesUnicas };
	};

	const carregarSugestoesVeiculos = async (opts?: { abrirModal?: boolean; mostrarAlertaSemDados?: boolean }): Promise<boolean> => {
		if (!selectedDate) return false;

		const abrirModal = opts?.abrirModal ?? false;
		const mostrarAlertaSemDados = opts?.mostrarAlertaSemDados ?? false;

		setLoadingSugestoes(true);
		try {
			const resultado = await calcularSugestoesVeiculos();
			const preview = resultado.sugestoes;
			if (preview.length === 0) {
				if (mostrarAlertaSemDados) {
					alert('Nenhuma linha aguardando veículo sem CAVALO foi encontrada para sugerir.');
				}
				setSugestoesPreview([]);
				setSugestoesOpcoes([]);
				setShowSugestoesModal(false);
				return false;
			}

			setSugestoesPreview(preview);
			setSugestoesOpcoes(resultado.opcoes);
			setFiltroSugestoesModal('voltando');
			setCopyLocalFeedback('Clique no Local do veículo para copiar o lat/long.');
			setShowSugestoesModal(abrirModal);
			return true;
		} catch (err: any) {
			console.error('Erro ao sugerir veículos:', err);
			if (mostrarAlertaSemDados) {
				alert(err?.message || 'Erro ao buscar veículos. Verifique se o módulo de monitoramento está ativo.');
			}
			return false;
		} finally {
			setLoadingSugestoes(false);
		}
	};

	// Abre modal com prévia das placas sugeridas pela regra
	const sugerirVeiculos = async () => {
		await carregarSugestoesVeiculos({ abrirModal: true, mostrarAlertaSemDados: true });
	};

	// Confirma no modal, aplica no grid e salva no backend
	const confirmarSugestoesVeiculos = async () => {
		if (!selectedDate || sugestoesPreview.length === 0) {
			setShowSugestoesModal(false);
			return;
		}

		setSavingSugestoes(true);
		try {
			const sugestoesMap: { [key: number]: string } = {};
			for (const item of sugestoesPreview) {
				sugestoesMap[item.rowIdx] = item.placa;
				await fetch('/api/controltower/salvar', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						field: 'CAVALO',
						value: item.placa,
						date: selectedDate.toISOString().split('T')[0],
						horario: item.horario
					})
				});
			}

			setVeiculosSugeridos(prev => ({ ...prev, ...sugestoesMap }));
			setSugestoesPreview([]);
			setSugestoesOpcoes([]);
			setShowSugestoesModal(false);
			alert(`${sugestoesPreview.length} veículos sugeridos e salvos com sucesso.`);
		} catch (err) {
			console.error('Erro ao confirmar sugestões:', err);
			alert('Erro ao salvar sugestões.');
		} finally {
			setSavingSugestoes(false);
		}
	};

	const extrairLatLong = (local: string): string | null => {
		if (!local) return null;
		const match = String(local).match(/(-?\d{1,2}\.\d+)\s*,\s*(-?\d{1,3}\.\d+)/);
		if (!match) return null;
		return `${match[1]}, ${match[2]}`;
	};

	const copiarLocalLatLong = async (local: string) => {
		const latLong = extrairLatLong(local);
		if (!latLong) {
			setCopyLocalFeedback('Este item não possui lat/long para copiar.');
			return;
		}

		try {
			if (navigator?.clipboard?.writeText) {
				await navigator.clipboard.writeText(latLong);
			} else {
				const area = document.createElement('textarea');
				area.value = latLong;
				area.style.position = 'fixed';
				area.style.left = '-9999px';
				document.body.appendChild(area);
				area.focus();
				area.select();
				document.execCommand('copy');
				document.body.removeChild(area);
			}
			setCopyLocalFeedback(`Lat/Long copiado: ${latLong}. Você pode colar onde quiser.`);
		} catch (err) {
			console.error('Erro ao copiar lat/long:', err);
			setCopyLocalFeedback('Não foi possível copiar agora. Tente novamente.');
		}
	};

		const handleAlterarPlacaSugestao = (previewIdx: number, novaPlaca: string) => {
			const opt = sugestoesOpcoes.find((o) => o.placa === novaPlaca);
			setSugestoesPreview((prev) =>
				prev.map((item, idx) =>
					idx === previewIdx
						? {
							...item,
							placa: novaPlaca,
							km: opt ? opt.km : item.km,
							statusVeiculo: opt ? opt.statusVeiculo : item.statusVeiculo,
							localVeiculo: opt ? opt.localVeiculo : item.localVeiculo
						}
						: item
				)
			);
		};
		// Buscar dados do backend ao filtrar data
		async function fetchRowsForTable(dateStr: string): Promise<any[]> {
			try {
				const res = await fetch(`/api/controltower/listar?data=${dateStr}`);
				const data = await res.json();
				const rowsValidos = (data.rows || []).filter((row: any) => {
					if (!row.DATA) return true;
					const rowDateStr = typeof row.DATA === 'string' && row.DATA.includes('T')
						? row.DATA.split('T')[0]
						: row.DATA;
					return rowDateStr === dateStr || !rowDateStr;
				});
				return rowsValidos;
			} catch (err) {
				console.error('Erro ao buscar dados:', err);
				return [];
			}
		}

		async function fetchProgramacaoRowsForTable(dateStr: string): Promise<any[]> {
			try {
				const res = await fetch(`/api/controltower/programacao/listar?data=${dateStr}`);
				const data = await res.json();
				const rowsValidos = (data.rows || []).filter((row: any) => {
					if (!row.DATA) return true;
					const rowDateStr = typeof row.DATA === 'string' && row.DATA.includes('T')
						? row.DATA.split('T')[0]
						: row.DATA;
					return rowDateStr === dateStr || !rowDateStr;
				});
				return rowsValidos;
			} catch (err) {
				console.error('Erro ao buscar dados da programação de viagens:', err);
				return [];
			}
		}

		async function fetchRowsByDate(dateStr: string) {
			console.log(`[DEBUG API] fetchRowsByDate chamada com data:`, dateStr);
			setLoadingRows(true);
			// Limpar dados antigos antes de buscar novos
			setImportedRows([]);
			try {
				console.log(`[DEBUG API] Fazendo fetch para:`, `/api/controltower/listar?data=${dateStr}`);
				const rowsValidos = await fetchRowsForTable(dateStr);
				console.log(`[DEBUG API] Rows válidos após filtro:`, rowsValidos.length);
				setImportedRows(rowsValidos);
			} catch (err) {
				console.error('Erro ao buscar dados:', err);
				setImportedRows([]);
			}
			setLoadingRows(false);
		}

		async function fetchProgramacaoRowsByDate(dateStr: string) {
			setLoadingRows(true);
			setProgramacaoRows([]);
			try {
				const rowsValidos = await fetchProgramacaoRowsForTable(dateStr);
				setProgramacaoRows(rowsValidos);

				// Identificar janelas aprovadas (que já existem no ControlTower)
				const ctRes = await fetch(`/api/controltower/listar?data=${dateStr}`);
				const ctData = await ctRes.json();
				const approvedKeys = new Set<string>();
				if (ctData.rows && Array.isArray(ctData.rows)) {
					ctData.rows.forEach((row: any) => {
						const statusNorm = String(row.STATUS || row.status || '').trim().toUpperCase();
						const hasProgramData = Boolean(
							String(row.CAVALO || '').trim() ||
							String(row.CARRETA || '').trim() ||
							String(row.FKS || '').trim()
						);
						if (row.JANELA && (statusNorm === 'PROGRAMADO' || statusNorm === 'AGENDADA' || hasProgramData)) {
							approvedKeys.add(`${dateStr}_${row.JANELA}`);
						}
					});
				}
				setApprovedWindowKeys(approvedKeys);
			} catch (err) {
				console.error('Erro ao buscar programação de viagens por data:', err);
				setProgramacaoRows([]);
				setApprovedWindowKeys(new Set());
			}
			setLoadingRows(false);
		}

		const handleDateChange = (date: Date | null) => {
		// Limpar dados antigos IMEDIATAMENTE ao trocar de data
		setImportedRows([]);
		setSelectedDate(date);
		if (date) {
			const dateStr = date.toISOString().split('T')[0];
			fetchRowsByDate(dateStr);
			fetchProgramacaoRowsByDate(dateStr);
		} else {
			// Se limpar a data, limpar os dados também
			setImportedRows([]);
			setProgramacaoRows([]);
		}
	};

	// Verificar se uma data tem dados disponíveis
	// A data de hoje está sempre disponível, mesmo sem dados
	const isDateAvailable = (date: Date): boolean => {
		const dateStr = date.toISOString().split('T')[0];
		
		// Pegar a data de hoje (sem horário)
		const today = new Date();
		const todayStr = today.toISOString().split('T')[0];

		// Sempre permitir hoje
		if (dateStr === todayStr) {
			return true;
		}

		// Permitir datas disponíveis normalmente
		if (availableDates.includes(dateStr)) {
			return true;
		}

		// Permitir apenas o dia anterior e o próximo dia em relação ao dia atual
		const prevDay = new Date(today);
		prevDay.setDate(today.getDate() - 1);
		const nextDay = new Date(today);
		nextDay.setDate(today.getDate() + 1);
		const prevStr = prevDay.toISOString().split('T')[0];
		const nextStr = nextDay.toISOString().split('T')[0];
		if (dateStr === prevStr || dateStr === nextStr) {
			return true;
		}
		return false;
	};

		// Converter strings de data para objetos Date de forma segura
		const getHighlightedDates = (): Date[] => {
			return availableDates.map(dateStr => {
				const [year, month, day] = dateStr.split('-').map(Number);
				return new Date(year, month - 1, day);
			}).filter(d => !isNaN(d.getTime()));
		};

		const handleImportClick = () => {
			if (fileInputRef.current) fileInputRef.current.value = '';
			fileInputRef.current?.click();
		};

		// Atualiza STATUS das linhas com base na posição atual do veículo no monitoramento
		const handleAtualizarStatusPorMonitoramento = async () => {
			if (veiculosMonitoramento.length === 0) {
				alert('Nenhum dado de monitoramento disponível. Aguarde o carregamento.');
				return;
			}
			const rows = getMergedRows();
			let atualizados = 0;

			const detectarNovoStatus = (vm: any): string | null => {
				const pol = normalizarTexto(
					vm?.poligono || vm?.nm_poligono_atual || vm?.ultimoPoligono || vm?.ultimo_poligono || vm?.poligonoAtual || ''
				);
				const statusMon = normalizarTexto(vm?.status || vm?.ds_status || vm?.status_monitoramento || '');
				const sentido = normalizarTexto(vm?.sentidoRota || vm?.ds_sentido_rota || vm?.sentido || '');
				const statusTransito = sentido.includes('volta') || sentido.includes('voltando')
					? 'EM TRANSITO SBC'
					: 'EM TRANSITO SJP';

				if (pol.includes('doca volks') || pol.includes('doca voks') || (pol.includes('doca') && pol.includes('sjp'))) return 'DOCA SJP';
				if (pol.includes('saguao volks sjp') || pol.includes('saguao voks sjp') || pol.includes('volks sjp') || pol.includes('voks sjp')) return 'BOLSÃO SJP';
				if (pol.includes('doca')) return 'DOCA';
				if (pol.includes('bolsao') || pol.includes('bolsão')) return 'BOLSÃO VW';
				if (statusMon.includes('movimento') || statusMon === 'em_movimento') return statusTransito;
				return null;
			};

			for (const row of rows) {
				const rowId = row._id;
				const cavalo = String(row.CAVALO || '').trim();
				const statusAtual = String(row.STATUS || '').trim().toUpperCase();
				const horario = String(row.JANELA || '').trim();

				// Não sobrescrever status finais/cancelados
				if (!cavalo || statusAtual === 'CANCELADA' || statusAtual === 'FINALIZADO') continue;

				const vm = veiculosMonitoramento.find((v: any) => normalizePlaca(getPlacaValue(v)) === normalizePlaca(cavalo));
				if (!vm) continue;

				const novoStatus = detectarNovoStatus(vm);
				if (!novoStatus || novoStatus.toUpperCase() === statusAtual) continue;

				const currentDateStr = selectedDate ? selectedDate.toISOString().split('T')[0] : '';
				try {
					const response = await fetch('/api/controltower/salvar', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({ id: rowId, field: 'STATUS', value: novoStatus, date: currentDateStr, horario })
					});
					if (response.ok) {
						setImportedRows(prev => {
							const idx = prev.findIndex(r => r._id === rowId);
							if (idx >= 0) {
								const updated = [...prev];
								updated[idx] = { ...updated[idx], STATUS: novoStatus };
								return updated;
							}
							return prev;
						});
						atualizados++;
					}
				} catch (err) {
					console.error('Erro ao atualizar status:', err);
				}
			}

			if (atualizados > 0) {
				alert(`✅ ${atualizados} status atualizado${atualizados > 1 ? 's' : ''} com base no monitoramento.`);
			} else {
				alert('Nenhum status novo detectado. Todos os veículos já estão atualizados ou sem dados de posição.');
			}
		};

		const handleSincronizarNucciManual = async () => {
			if (!selectedDate) {
				alert('Selecione uma data antes de atualizar os dados da Nucci.');
				return;
			}

			const dateStr = selectedDate.toISOString().split('T')[0];
			setIsSyncingNucciManual(true);

			try {
				const response = await fetch('/api/controltower/sincronizar-nucci', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ data: dateStr })
				});

				const payload = await response.json().catch(() => ({}));

				if (!response.ok) {
					throw new Error(payload?.error || 'Erro ao sincronizar dados com a Nucci.');
				}

				const rowsAtualizados = await fetchRowsForTable(dateStr);
				setImportedRows(rowsAtualizados);
				alert(payload?.message || 'Sincronização com a Nucci concluída.');
			} catch (err: any) {
				alert(err?.message || 'Erro ao sincronizar dados com a Nucci.');
			} finally {
				setIsSyncingNucciManual(false);
			}
		};

		const handleDownloadTemplate = () => {
			const headers = ['STATUS', 'DATA', 'JANELA', 'VIRA DO CVA', 'CVA', 'FKS', 'CONTRATO', 'VALE PEDAGIO', 'CTE/MANIFESTO', 'CAVALO', 'CARRETA', 'CHEGADA', 'SAÍDA'];

			const worksheet = XLSX.utils.aoa_to_sheet([headers]);
			worksheet['!cols'] = [
				{ wch: 20 }, { wch: 12 }, { wch: 10 }, { wch: 15 }, { wch: 14 }, { wch: 28 },
				{ wch: 14 }, { wch: 16 }, { wch: 16 }, { wch: 14 }, { wch: 14 }, { wch: 12 }, { wch: 12 }
			];

			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, 'Modelo');
			XLSX.writeFile(workbook, 'modelo_programacao.xlsx');
		};

	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];
		if (!file) return;
		const reader = new FileReader();
		reader.onload = (evt) => {
			const data = new Uint8Array(evt.target?.result as ArrayBuffer);
			const workbook = XLSX.read(data, { type: 'array' });
			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];
			const json = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
			setPendingRows(json as any[]);
			setShowConfirm(true);
		};
		reader.readAsArrayBuffer(file);
	};

		const handleConfirm = async (save: boolean) => {
			setShowConfirm(false);
			if (!pendingRows) return;
			if (save) {
				setIsSaving(true);
				try {
					// TODO: ajuste a URL da API conforme seu backend
					await fetch('/api/controltower/importar', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({ rows: pendingRows })
					});
				} catch (err) {
					alert('Erro ao salvar no banco!');
				}
				setIsSaving(false);
			}
			setImportedRows(pendingRows);
			setPendingRows(null);
		};

		// Helpers para formatar datas e horários vindos do Excel
		function excelDateToJSDate(serial: number) {
			// Excel date serial to JS Date (corrigido para não perder um dia e sem UTC)
			// Excel epoch: 1899-12-30
			const msPerDay = 24 * 60 * 60 * 1000;
			const excelEpoch = new Date(1899, 11, 30);
			// Arredonda para baixo para evitar frações de dia
			const date = new Date(excelEpoch.getTime() + Math.floor(serial) * msPerDay);
			return date;
		}

		function formatExcelDate(val: any) {
			if (typeof val === 'number') {
				const d = excelDateToJSDate(val);
				return d.toLocaleDateString('pt-BR');
			}
			if (typeof val === 'string' && /^\d{8}$/.test(val)) {
				// Ex: 20260216
				return val.replace(/(\d{4})(\d{2})(\d{2})/, '$3/$2/$1');
			}
			return val;
		}

		function formatExcelTime(val: any) {
			if (val == null || val === '') return '';
			if (typeof val === 'number' && Number.isFinite(val)) {
				// Excel stores time as fraction of day
				const normalized = ((val % 1) + 1) % 1;
				const totalSeconds = Math.round(normalized * 24 * 60 * 60);
				const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
				const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, '0');
				return `${hours}:${minutes}`;
			}
			if (typeof val === 'string') {
				const raw = val.trim().replace(',', '.');
				if (/^-?\d+(\.\d+)?$/.test(raw)) {
					const asNumber = Number(raw);
					if (Number.isFinite(asNumber)) return formatExcelTime(asNumber);
				}
				const match = raw.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
				if (match) {
					const h = String(Number(match[1])).padStart(2, '0');
					const m = match[2];
					return `${h}:${m}`;
				}
			}
			return val;
		}

		// Verificar se a data selecionada é hoje, ontem ou amanhã
		const isRecentDate = (date: Date | null): boolean => {
			if (!date) return false;
			const today = new Date();
			today.setHours(0, 0, 0, 0);
			const yesterday = new Date(today);
			yesterday.setDate(today.getDate() - 1);
			const tomorrow = new Date(today);
			tomorrow.setDate(today.getDate() + 1);
			
			const dateStr = date.toISOString().split('T')[0];
			const todayStr = today.toISOString().split('T')[0];
			const yesterdayStr = yesterday.toISOString().split('T')[0];
			const tomorrowStr = tomorrow.toISOString().split('T')[0];
			
			return dateStr === todayStr || dateStr === yesterdayStr || dateStr === tomorrowStr;
		};

		// Mesclar template de janelas com dados do banco (apenas quando solicitado)
		const getMergedRows = (rowsBase: any[] = importedRows, includeWindowTemplate: boolean = false): any[] => {
			const selectedDateStr = selectedDate ? selectedDate.toISOString().split('T')[0] : '';
			const horarios = getConfiguredHorarios(selectedDateStr);

			// Se não tem janelas configuradas no localStorage, usar as janelas já presentes no banco como base
			if (!includeWindowTemplate || horarios.length === 0) {
				// Filtrar apenas registros da data selecionada
				const rowsDaData = rowsBase.filter(row => {
					const rowDate = row.DATA && typeof row.DATA === 'string' && row.DATA.includes('T')
						? row.DATA.split('T')[0]
						: row.DATA;
					return !rowDate || rowDate === selectedDateStr;
				});
				return rowsDaData.sort((a, b) => {
					const aMin = janelaToMinutes(normalizeJanela(a.JANELA || a.janela));
					const bMin = janelaToMinutes(normalizeJanela(b.JANELA || b.janela));
					return aMin - bMin;
				});
			}

			const normalizedHorarios = horarios.map(normalizeJanela);
			const normalizedHorariosSet = new Set(normalizedHorarios);

			const template = horarios.map(horario => {
				const normalizedHorario = normalizeJanela(horario);
				const dadosSalvo = rowsBase.find(row => {
					const rowDate = row.DATA && typeof row.DATA === 'string' && row.DATA.includes('T')
						? row.DATA.split('T')[0]
						: row.DATA;
					const rowJanela = normalizeJanela(row.JANELA || row.janela);
					return rowJanela === normalizedHorario && rowDate === selectedDateStr;
				});

				if (dadosSalvo) {
					return dadosSalvo;
				}

				return {
					JANELA: horario,
					DATA: selectedDateStr,
					STATUS: 'Aguardando veículo'
				};
			});

			const extrasDoBanco = rowsBase
				.filter(row => {
					const rowDate = row.DATA && typeof row.DATA === 'string' && row.DATA.includes('T')
						? row.DATA.split('T')[0]
						: row.DATA;
					if (rowDate !== selectedDateStr) return false;
					const rowJanela = normalizeJanela(row.JANELA || row.janela);
					return !!rowJanela && !normalizedHorariosSet.has(rowJanela);
				})
				.sort((a, b) => {
					const aMin = janelaToMinutes(normalizeJanela(a.JANELA || a.janela));
					const bMin = janelaToMinutes(normalizeJanela(b.JANELA || b.janela));
					return aMin - bMin;
				});

			return [...template, ...extrasDoBanco].sort((a, b) => {
				const aMin = janelaToMinutes(normalizeJanela(a.JANELA || a.janela));
				const bMin = janelaToMinutes(normalizeJanela(b.JANELA || b.janela));
				return aMin - bMin;
			});
		};

		// Função para gerar viagens ativas a partir da programação
		const getViagensAtivas = (): Viagem[] => {
			const mergedRows = getMergedRows();
			const viagensAtivas: Viagem[] = [];

			// Log de debug para verificar dados
			console.log(`[DEBUG] Total de linhas em mergedRows: ${mergedRows.length}`);
			console.log(`[DEBUG] Primeira linha COMPLETA:`, mergedRows[0]);
			console.log(`[DEBUG] Campos disponíveis:`, Object.keys(mergedRows[0] || {}));
			console.log(`[VIAGENS ATIVAS] Total de veículos no monitoramento: ${veiculosMonitoramento.length}`);
			if (veiculosMonitoramento.length > 0) {
				console.log('[VIAGENS ATIVAS] Primeiros 3 veículos do monitoramento:', 
					veiculosMonitoramento.slice(0, 3).map(v => ({
						placa: v.placa || v.nm_placa,
						tempoParado: v.tempoParado,
						status: v.status
					}))
				);
			}

			mergedRows.forEach((row: any) => {
				const status = row.STATUS || row.status || '';
				console.log(`[DEBUG] Processando linha - Placa: ${row.CAVALO || row.cavalo}, Status: "${status}"`);
				
				// Filtrar apenas linhas que não devem aparecer no painel
				if (!status || status === 'Aguardando veículo' || status === 'CANCELADA') {
					console.log(`[DEBUG] ❌ Linha filtrada - Status: "${status}"`);
					return;
				}
				console.log(`[DEBUG] ✅ Linha aceita - Status: "${status}"`);


			const placaCavalo = row.CAVALO || row.cavalo || '';
			const placaCarreta = row.CARRETA || row.carreta || '';
			const placaCavaloNormalizada = normalizePlaca(placaCavalo);
			const placaCarretaNormalizada = normalizePlaca(placaCarreta);
			const janela = row.JANELA || row.janela || '';
			const data = row.DATA || row.data || '';
				   const cva = row.CVA || row.cva || '';
			const tipoMotorista = row.TIPO || row.tipo || 'Free';

			// Buscar informações do veículo no array veiculosVolks
			const veiculoInfo = veiculosVolks.find((v: any) => {
				const p = getPlacaValue(v);
				return normalizePlaca(p) === placaCavaloNormalizada;
			});

			// Buscar informações da carreta
			const carretaInfo = carretasDisponiveis.find((c: any) => {
				const p = c.placa || c.PLACA || '';
				return normalizePlaca(p) === placaCarretaNormalizada;
			});

			// Buscar dados de localização em tempo real do monitoramento
			const veiculoMonit = veiculosMonitoramento.find((v: any) => {
				const p = getPlacaValue(v);
				return normalizePlaca(p) === placaCavaloNormalizada;
			});

			// Log completo do veículo encontrado
			if (veiculoMonit) {
				console.log(`[DEBUG] Veículo ${placaCavalo} encontrado no monitoramento:`, {
					placa: veiculoMonit.placa || veiculoMonit.nm_placa,
					tempoParado: veiculoMonit.tempoParado,
					tempoParadoTipo: typeof veiculoMonit.tempoParado,
					status: veiculoMonit.status,
					sentidoRota: veiculoMonit.sentidoRota,
					objetoCompleto: veiculoMonit
				});
			} else {
				console.log(`[DEBUG] Veículo ${placaCavalo} NÃO encontrado no monitoramento`);
			}

			// ─── Verificar se a viagem já começou ───────────────────────────────
			// Extrai data e janela direto da string (evita shift de fuso horário)
			const viagemJaIniciou = (() => {
					const dataMatch = data.match(/(\d{4})-(\d{2})-(\d{2})/);
					const janelaMatch = janela.match(/(\d{1,2}):(\d{2})/);
					if (!dataMatch || !janelaMatch) return false;
					const [, ano, mes, dia] = dataMatch;
					const [, h, m] = janelaMatch;
					// Constrói datetime em horário LOCAL (para comparar com new Date())
					const janelaDatetime = new Date(Number(ano), Number(mes) - 1, Number(dia), Number(h), Number(m), 0);
					return janelaDatetime <= new Date();
				})();

				// Determinar sentido do veículo (ida = SBC->SJP, volta = SJP->SBC)
				// Só considera sentido real se a viagem já iniciou
				const sentidoVeiculo = (viagemJaIniciou && veiculoMonit?.sentidoRota) ? veiculoMonit.sentidoRota : 'ida';
				
				// Definir origem e destino ATUAL baseado no sentido (para cálculo de KM)
				// Origem da VIAGEM sempre é SBC, destino da VIAGEM sempre é SJP
				// Mas o trajeto ATUAL depende do sentido
				let origemAtualCoords = COORDS_VW_SBC;  // De onde saiu agora
				let destinoAtualCoords = COORDS_VW_SJP; // Para onde está indo agora
				let destinoAtualNome = 'Volkswagen SJP'; // Nome do destino atual
				
				if (sentidoVeiculo === 'volta') {
					// Quando está voltando: saiu de SJP e está indo para SBC
					origemAtualCoords = COORDS_VW_SJP;
					destinoAtualCoords = COORDS_VW_SBC;
					destinoAtualNome = 'Volkswagen SBC';
				}

				// Calcular progresso em tempo real
				let kmRealizado = 0;
				let kmRestante = DISTANCIA_TOTAL_ROTA;
				let kmTotal = DISTANCIA_TOTAL_ROTA; // Total muda se estiver voltando
				let cidadeAtual = '-';
				let statusAtual = viagemJaIniciou ? status : 'Aguardando partida';
				let tempoParado: string | undefined = undefined;
				let enderecoCompleto = '-';
				let latAtual: number | undefined = undefined;
				let lngAtual: number | undefined = undefined;
				const latNum = toCoordNumber(veiculoMonit?.latitude ?? veiculoMonit?.lat ?? veiculoMonit?.localizacao?.lat ?? veiculoMonit?.localizacao?.latitude);
				const lngNum = toCoordNumber(veiculoMonit?.longitude ?? veiculoMonit?.lng ?? veiculoMonit?.localizacao?.lng ?? veiculoMonit?.localizacao?.longitude);
				const hasCoords = latNum !== undefined && lngNum !== undefined;
				const enderecoMonitoramento = veiculoMonit?.localizacao?.endereco || veiculoMonit?.endereco || '-';

				if (hasCoords) {
					latAtual = latNum;
					lngAtual = lngNum;
				}

				if (veiculoMonit?.status) {
					statusAtual = veiculoMonit.status;
				}

				if (veiculoMonit?.poligono && veiculoMonit.poligono !== '-') {
					cidadeAtual = veiculoMonit.poligono;
					enderecoCompleto = veiculoMonit.poligono;
				} else if (enderecoMonitoramento && enderecoMonitoramento !== '-') {
					enderecoCompleto = enderecoMonitoramento;
					cidadeAtual = extrairCidade(enderecoMonitoramento);
				}

				// Só busca dados de GPS se a viagem já começou
				// (evita mostrar progresso de outra viagem que o veículo está finalizando)
				if (viagemJaIniciou && veiculoMonit && hasCoords) {
						// Calcular distância da origem ATUAL até a posição atual
						const distOrigem = calcularDistancia(origemAtualCoords.lat, origemAtualCoords.lng, latNum!, lngNum!);
						// Calcular distância da posição atual até o destino ATUAL
						const distDestino = calcularDistancia(latNum!, lngNum!, destinoAtualCoords.lat, destinoAtualCoords.lng);

						// Verificar se está no polígono de origem (ex: Volks Anchieta/SBC)
						const poligonoAtual = (veiculoMonit.poligono || '').toLowerCase();
						const estaNoPoligonoOrigem = (
							(sentidoVeiculo === 'ida' && (poligonoAtual.includes('anchieta') || poligonoAtual.includes('sbc')))
							|| (sentidoVeiculo === 'volta' && poligonoAtual.includes('sjp'))
						);

						if (sentidoVeiculo === 'volta') {
							// Na volta: já percorreu a ida completa (581) + o trajeto de volta até agora
							kmRealizado = DISTANCIA_TOTAL_ROTA + Math.round(distOrigem);
							kmTotal = DISTANCIA_TOTAL_ROTA * 2; // Viagem completa ida + volta
							if (estaNoPoligonoOrigem) {
								kmRestante = kmTotal - kmRealizado; // No polígono de origem da volta, restante é tudo que falta
							} else {
								kmRestante = Math.round(distDestino);
							}
							console.log(`[VOLTA] ${placaCavalo}:`, {
								distOrigem: Math.round(distOrigem),
								distDestino: Math.round(distDestino),
								kmRealizado,
								kmRestante,
								kmTotal,
								percentual: `${Math.round((kmRealizado/kmTotal)*100)}%`
							});
						} else {
							// Na ida: percorreu apenas a distância da origem até agora
							kmRealizado = Math.round(distOrigem);
							kmTotal = DISTANCIA_TOTAL_ROTA; // Apenas a ida
							if (estaNoPoligonoOrigem) {
								kmRestante = kmTotal; // No polígono de origem, restante é o total
							} else {
								kmRestante = Math.round(distDestino);
							}
							console.log(`[IDA] ${placaCavalo}:`, {
								distOrigem: Math.round(distOrigem),
								distDestino: Math.round(distDestino),
								kmRealizado,
								kmRestante,
								kmTotal,
								percentual: `${Math.round((kmRealizado/kmTotal)*100)}%`
							});
						}
						
						if (enderecoCompleto !== '-') {
							console.log('Posição atual:', enderecoCompleto);
						}
				}
				
				// Tempo parado do monitoramento (buscar fora do if de localização)
				// Vem em minutos, formatar para string
				// Só aplica se a viagem já começou
				if (viagemJaIniciou && veiculoMonit) {
					console.log(`[TEMPO PARADO DEBUG] ${placaCavalo}:`, {
						tempoParado: veiculoMonit.tempoParado,
						tipo: typeof veiculoMonit.tempoParado,
						nr_tempo_parado: veiculoMonit.nr_tempo_parado,
						dt_inicio_parada: veiculoMonit.dt_inicio_parada
					});
					
					// Tentar pegar de diferentes campos possíveis
					const tempoParadoValue = veiculoMonit.tempoParado ?? veiculoMonit.nr_tempo_parado;
					
					if (tempoParadoValue !== undefined && tempoParadoValue !== null && tempoParadoValue > 0) {
						tempoParado = formatarTempoParado(tempoParadoValue);
						console.log(`✅ Tempo parado para ${placaCavalo}:`, tempoParadoValue, 'minutos =>', tempoParado);
					} else {
						console.log(`❌ Sem tempo parado válido para ${placaCavalo}`);
					}
				}

				// Determinar horário de chegada: usar manual se existir, senão usar entrada no polígono (se aplicável)
				let horarioChegada = row.CHEGADA || row.chegada || '';
				
				// Se não tem chegada manual e o veículo está em polígono Volks Anchieta, usar horário de entrada no polígono
				if (!horarioChegada && veiculoMonit) {
					const poligonoAtual = (veiculoMonit.poligono || '').toLowerCase();
					const horarioEntradaPoligono = veiculoMonit.horarioEntradaPoligonoAtual;
					
					// Verificar se está em algum polígono da Volkswagen (Anchieta, SBC, etc)
					if ((poligonoAtual.includes('volks') || poligonoAtual.includes('anchieta') || poligonoAtual.includes('sbc')) 
						&& horarioEntradaPoligono) {
						horarioChegada = horarioEntradaPoligono;
						console.log(`[AUTO-CHEGADA] ${placaCavalo}: usando entrada em ${poligonoAtual} às ${horarioEntradaPoligono}`);
					}
				}

				// Montar objeto de viagem
				   const viagem: Viagem = {
					   origem: 'Volkswagen SBC',
					   prevInicio: formatarDataHora(`${data} ${janela}`),
					   inicioReal: horarioChegada ? formatarHorario(horarioChegada) : '-',
					   cva: cva || '-',
					   veiculo: {
						placaCavalo: placaCavalo || '-',
						placaCarreta: placaCarreta || '-',
						tipoCarreta: carretaInfo?.tipo || carretaInfo?.tipo_carreta || row['TIPO CARRETA'] || '-',
						id: veiculoInfo?.id || '-',
						rastreador: veiculoInfo?.cartao || '-',
						tipo: veiculoInfo?.tipo || 'Cavalo',
						modelo: veiculoInfo?.modelo || '-'
					},
					motorista: {
						   nome: row.FKS || row.cd_fks || 'A definir',
						tipo: tipoMotorista,
						telefone: '-'
					},
					progresso: {
						realizado: kmRealizado,
						total: kmTotal, // Muda baseado no sentido (ida = 581, volta = 1162)
						posicao: enderecoCompleto,
						cidade: cidadeAtual,
						restante: kmRestante,
						rota: 'Volkswagen SBC x Volkswagen SJP',
						status: statusAtual,
						temp: null,
						tempoParado: tempoParado,
						lat: latAtual,
						lng: lngAtual,
						destinoNome: destinoAtualNome // Destino ATUAL baseado no sentido (para onde está indo agora)
					},
					destino: {
						nome: 'Volkswagen SJP', // Destino FINAL da viagem (sempre SJP)
						   prevFim: calcularPrevChegada(data, janela, 10),
						transit: '-',
						totalPrev: '10h',
						chegada: row['CHEGADA SJP'] || '-'
					}
				};

				viagensAtivas.push(viagem);
			});

			return viagensAtivas;
		};

		const isStatusEmTransito = (statusRaw: string): boolean => {
			const status = String(statusRaw || '')
				.toLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '');

			return status.includes('transito') || status.includes('movimento') || status === 'em_movimento';
		};

		const traduzirStatusOperacional = (statusRaw: any): string => {
			if (!statusRaw) return '-';
			const statusNorm = normalizarTexto(statusRaw);

			if (statusNorm.includes('bolsao vw')) return 'Aguardando Descarga';
			if (statusNorm.includes('doca sjp')) return 'Descarregando';
			if (statusNorm.includes('ala 13') && statusNorm.includes('volks') && statusNorm.includes('anchieta')) return 'Em Coleta';
			if (statusNorm.includes('bolsao anchieta')) return 'Aguardando Coleta';

			return String(statusRaw);
		};

		const formatarDataColeta = (dataRaw: any): string => {
			if (!dataRaw) return '-';
			const raw = String(dataRaw);
			const matchIso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
			if (matchIso) return `${matchIso[3]}/${matchIso[2]}/${matchIso[1]}`;
			return raw;
		};

		const formatarDataHoraTransito = (valor: any): string => {
			if (!valor) return '-';
			const raw = String(valor).trim();
			const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/);
			if (iso) return `${iso[3]}/${iso[2]}/${iso[1]} ${iso[4]}:${iso[5]}`;
			return raw;
		};

		const formatarDataHoraParaInput = (valor: any): string => {
			if (!valor) return '';
			const date = new Date(valor);
			if (!isNaN(date.getTime())) {
				const yyyy = date.getFullYear();
				const mm = String(date.getMonth() + 1).padStart(2, '0');
				const dd = String(date.getDate()).padStart(2, '0');
				const hh = String(date.getHours()).padStart(2, '0');
				const min = String(date.getMinutes()).padStart(2, '0');
				return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
			}
			const raw = String(valor).trim();
			const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/);
			if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}T${iso[4]}:${iso[5]}`;
			return '';
		};

		const isCampoTransitoVazio = (valor: any): boolean => {
			if (valor == null) return true;
			const raw = String(valor).trim();
			return raw === '' || raw === '-';
		};

		const formatarKmPendenteDisplay = (valor: any): string => {
			if (valor == null || valor === '') return '-';
			const numero = Number(valor);
			if (!Number.isFinite(numero)) return String(valor);
			return `${Math.round(numero)} km`;
		};


		const extrairCidadeLocalizacao = (valor: any): string => {
			if (!valor) return '-';
			const raw = String(valor).trim();
			if (!raw) return '-';
			if (!raw.includes(',')) return raw;

			const partes = raw
				.split(',')
				.map((parte) => parte.trim())
				.filter(Boolean);

			if (partes.length <= 1) return raw;

			for (let index = 0; index < partes.length - 1; index += 1) {
				const atual = partes[index];
				const proxima = partes[index + 1];
				if (/^regi[aã]o/i.test(proxima) || /^[A-Z]{2}$/.test(proxima)) {
					return atual;
				}
			}

			const ufIndex = partes.findIndex((parte) => /^[A-Z]{2}$/.test(parte));
			if (ufIndex > 0) return partes[ufIndex - 1];

			return raw;
		};

		const formatarSituacaoVeiculoTransito = (statusRaw: any, tempoParadoRaw: any): string => {
			const statusNorm = normalizarTexto(statusRaw);
			const tempoMin = Number(tempoParadoRaw);

			if (statusNorm.includes('movimento') || statusNorm === 'em_movimento') return 'Rodando';
			if (statusNorm.includes('parado')) {
				if (Number.isFinite(tempoMin) && tempoMin > 0) return `Parado (${formatarTempoParado(tempoMin)})`;
				return 'Parado';
			}
			if (statusNorm.includes('fora_de_rota') || statusNorm.includes('fora de rota')) return 'Fora de rota';
			if (statusNorm.includes('problema_rastreador') || statusNorm.includes('problema rastreador')) return 'Problema rastreador';
			if (!statusRaw) return '-';
			return String(statusRaw);
		};

		const reconciliarStatusOperacionalComMonitoramento = (statusAtualRaw: any, vm: any): string => {
			const statusAtual = String(statusAtualRaw || '').trim();
			const statusAtualNorm = normalizarTexto(statusAtual);

			// Nunca sobrescreve estados finais/cancelados.
			if (statusAtualNorm === 'cancelada' || statusAtualNorm === 'finalizado') {
				return statusAtual || '-';
			}

			if (!vm) return statusAtual || '-';

			const pol = normalizarTexto(
				vm?.poligono || vm?.nm_poligono_atual || vm?.ultimoPoligono || vm?.ultimo_poligono || vm?.poligonoAtual || ''
			);
			const statusMon = normalizarTexto(vm?.status || vm?.ds_status || vm?.status_monitoramento || '');
			const sentido = normalizarTexto(vm?.sentidoRota || vm?.ds_sentido_rota || vm?.sentido || '');

			if (pol.includes('doca volks') || pol.includes('doca voks') || (pol.includes('doca') && pol.includes('sjp'))) return 'DOCA SJP';
			if (pol.includes('saguao volks sjp') || pol.includes('saguao voks sjp') || pol.includes('volks sjp') || pol.includes('voks sjp')) return 'BOLSÃO SJP';
			if (pol.includes('doca')) return 'DOCA';
			if (pol.includes('bolsao') || pol.includes('bolsão')) return 'BOLSÃO VW';

			if (statusMon.includes('movimento') || statusMon === 'em_movimento') {
				return (sentido.includes('volta') || sentido.includes('voltando')) ? 'EM TRANSITO SBC' : 'EM TRANSITO SJP';
			}

			return statusAtual || '-';
		};

		const getTransitoTableRows = () => {
			const rows = transitoAllRows
				.map((row: any) => {
					const placa = String(row.CAVALO || row.cavalo || '-');
					const placaNormalizada = normalizePlaca(placa);
					const veiculoMonit = veiculosMonitoramento.find((v: any) => normalizePlaca(getPlacaValue(v)) === placaNormalizada);
					const sentidoRota = (veiculoMonit?.sentidoRota || row.sentidoRota || 'desconhecido') as 'ida' | 'volta' | 'desconhecido';
					const statusOperacionalEfetivo = reconciliarStatusOperacionalComMonitoramento(row.STATUS || row.status || '-', veiculoMonit);

					const statusVeiculo = veiculoMonit
						? formatarSituacaoVeiculoTransito(
							veiculoMonit.status || veiculoMonit.ds_status || veiculoMonit.status_monitoramento,
							veiculoMonit.tempoParado ?? veiculoMonit.nr_tempo_parado
						)
						: '-';
					const problemaRastreadorTransito = normalizarTexto(statusVeiculo).includes('problema rastreador') || normalizarTexto(statusVeiculo).includes('problema_rastreador');

					const localizacaoAuto = extrairCidadeLocalizacao(
						veiculoMonit?.localizacao?.endereco ||
						veiculoMonit?.endereco ||
						veiculoMonit?.poligono ||
						'-'
					);

					// KM Pendente — distanciaRestante já é calculado pelo sentido no módulo de monitoramento
					const kmPendenteRaw = veiculoMonit?.distanciaRestante ?? veiculoMonit?.kmPendente ?? veiculoMonit?.km_pendente;
					const kmPendenteAuto = Number.isFinite(Number(kmPendenteRaw)) ? Number(kmPendenteRaw) : null;
					let kmPendenteCalculado: number | null = null;
					const latNum = toCoordNumber(veiculoMonit?.latitude ?? veiculoMonit?.lat ?? veiculoMonit?.localizacao?.lat ?? veiculoMonit?.localizacao?.latitude);
					const lngNum = toCoordNumber(veiculoMonit?.longitude ?? veiculoMonit?.lng ?? veiculoMonit?.localizacao?.lng ?? veiculoMonit?.localizacao?.longitude);
					if (latNum !== undefined && lngNum !== undefined) {
						let destinoAtualCoords = COORDS_VW_SJP;
						if (sentidoRota === 'volta') {
							destinoAtualCoords = COORDS_VW_SBC;
						}
						kmPendenteCalculado = Math.round(calcularDistancia(latNum, lngNum, destinoAtualCoords.lat, destinoAtualCoords.lng));
					}

					// Saída Planta Anchieta: DB > detectado via último polígono Anchieta no monitoramento
					const saidaPlantaDb = row['DT_SAIDA_PLANTA'] || null;
					const saidaPlantaManual = row['DT_SAIDA_PLANTA_MANUAL'] || null;
					const saidaPlantaMonit = !saidaPlantaDb
						? (veiculoMonit?.horarioSaidaOrigem || veiculoMonit?.horarioSaidaUltimoPoligono || null)
						: null;
					const saidaPlantaRaw = saidaPlantaManual || saidaPlantaDb || saidaPlantaMonit || null;

					const situacaoVeiculoManual = String(row['SITUACAO_VEICULO_MANUAL'] || '').trim();
					const localizacaoManual = String(row['LOCALIZACAO_MANUAL'] || '').trim();
					const kmPendenteManual = row['KM_PENDENTE_MANUAL'];
					const kmPendenteAutoDb = row['KM_PENDENTE_AUTO'];
					const situacaoVeiculoEfetiva = situacaoVeiculoManual || statusVeiculo || '-';
					const localizacaoEfetiva = localizacaoManual || String(localizacaoAuto || '-');
					const kmPendenteEfetivo = kmPendenteManual ?? kmPendenteAutoDb ?? kmPendenteAuto ?? kmPendenteCalculado;
					const kmPendente = formatarKmPendenteDisplay(kmPendenteEfetivo);
					const podeEditarTudo = problemaRastreadorTransito;
					const podeEditarSaidaPlanta = podeEditarTudo || !!saidaPlantaManual || !saidaPlantaRaw;
					const podeEditarSituacaoVeiculo = podeEditarTudo || !!situacaoVeiculoManual || isCampoTransitoVazio(statusVeiculo);
					const podeEditarLocalizacao = podeEditarTudo || !!localizacaoManual || isCampoTransitoVazio(localizacaoAuto);
					const podeEditarKmPendente = podeEditarTudo || kmPendenteManual != null || (kmPendenteAuto == null && kmPendenteCalculado == null);

					// Transit Time = Saída Planta + 10h
					let transitTime = '-';
					if (saidaPlantaRaw) {
						try {
							const dtSaida = new Date(saidaPlantaRaw);
							if (!isNaN(dtSaida.getTime())) {
								const dtTransit = new Date(dtSaida.getTime() + 10 * 60 * 60 * 1000);
								const dd = String(dtTransit.getDate()).padStart(2, '0');
								const mm = String(dtTransit.getMonth() + 1).padStart(2, '0');
								const yyyy = dtTransit.getFullYear();
								const hh = String(dtTransit.getHours()).padStart(2, '0');
								const min = String(dtTransit.getMinutes()).padStart(2, '0');
								transitTime = `${dd}/${mm}/${yyyy} ${hh}:${min}`;
							}
						} catch {}
					}

					// Observação
					const rowId: number = row['_id'] ?? row._id ?? 0;
					const observacao = row['OBS_TRANSITO'] || '';

					return {
						cva: String(row.CVA || row.cva || '-'),
						placa,
							velocidadeAtual: Number(veiculoMonit?.velocidade || veiculoMonit?.nr_velocidade || 60),
						dataColeta: formatarDataColeta(row.DATA || row.data || ''),
						hJanela: String(row.JANELA || row.janela || '-'),
						status: traduzirStatusOperacional(statusOperacionalEfetivo),
						saidaPlanta: saidaPlantaRaw ? formatarDataHoraTransito(saidaPlantaRaw) : '-',
						saidaPlantaRaw,
						saidaPlantaEditValue: formatarDataHoraParaInput(saidaPlantaRaw),
						podeEditarSaidaPlanta,
						transitTime,
						situacaoVeiculo: situacaoVeiculoEfetiva,
						situacaoVeiculoEditValue: situacaoVeiculoEfetiva === '-' ? '' : situacaoVeiculoEfetiva,
						podeEditarSituacaoVeiculo,
						localizacao: String(localizacaoEfetiva),
						localizacaoEditValue: localizacaoEfetiva === '-' ? '' : localizacaoEfetiva,
						podeEditarLocalizacao,
						kmPendente,
						kmPendenteEditValue: kmPendenteEfetivo == null ? '' : String(kmPendenteEfetivo),
						podeEditarKmPendente,
						observacao,
						_id: rowId,
						problemaRastreadorTransito,
						sentidoRota
					};
				})
				.sort((a: any, b: any) => janelaToMinutes(normalizeJanela(a.hJanela)) - janelaToMinutes(normalizeJanela(b.hJanela)));

			const rowsFiltradosSentido = sentidoTransito === 'todos'
				? rows
				: rows.filter((r: any) => r.sentidoRota === sentidoTransito);

			if (buscaCVA.trim() === '') return rowsFiltradosSentido;

			const busca = buscaCVA.trim().toLowerCase();
			return rowsFiltradosSentido.filter((r: any) =>
				r.cva.toLowerCase().includes(busca) ||
				r.placa.toLowerCase().includes(busca) ||
				r.localizacao.toLowerCase().includes(busca)
			);
		};

		const handleExportTransito = async () => {
			const transitoRows = getTransitoTableRows();

			const agora = new Date();
			const yyyy = agora.getFullYear();
			const mm = String(agora.getMonth() + 1).padStart(2, '0');
			const dd = String(agora.getDate()).padStart(2, '0');
			const hh = String(agora.getHours()).padStart(2, '0');
			const min = String(agora.getMinutes()).padStart(2, '0');

			const COLS = [
				{ key: 'CVA',                  width: 18 },
				{ key: 'Placa',                width: 12 },
				{ key: 'Data Coleta',           width: 16 },
				{ key: 'H. Janela',             width: 12 },
				{ key: 'Status',               width: 22 },
				{ key: 'Saída Planta Anchieta', width: 24 },
				{ key: 'Transit Time',          width: 20 },
				{ key: 'Situação Veículo',      width: 20 },
				{ key: 'Localização',           width: 28 },
				{ key: 'KM Pendente',           width: 14 },
				{ key: 'Observação',            width: 40 },
			];

			// Cor de fundo para cada Status
			const statusColor: Record<string, string> = {
				'trânsito': 'FF4FC3F7',
				'transito': 'FF4FC3F7',
				'aguardando descarga': 'FFFBBF24',
				'descarregando': 'FF86EFAC',
				'aguardando coleta': 'FF93C5FD',
				'em coleta': 'FF86EFAC',
				'programado': 'FFFDE68A',
				'problema rastreador': 'FFFCA5A5',
			};
			const getStatusFill = (s: string): ExcelJS.FillPattern => {
				const key = Object.keys(statusColor).find(k => s.toLowerCase().includes(k));
				return { type: 'pattern', pattern: 'solid', fgColor: { argb: key ? statusColor[key] : 'FFFFFFFF' } };
			};

			const HEADER_FILL_TEAL: ExcelJS.FillPattern   = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0891B2' } };
			const HEADER_FILL_YELLOW: ExcelJS.FillPattern = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFCA8A04' } };
			const HEADER_FONT = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
			const BORDER: Partial<ExcelJS.Borders> = {
				top:    { style: 'thin' as ExcelJS.BorderStyle },
				left:   { style: 'thin' as ExcelJS.BorderStyle },
				bottom: { style: 'thin' as ExcelJS.BorderStyle },
				right:  { style: 'thin' as ExcelJS.BorderStyle },
			};
			const ALIGN_CENTER: Partial<ExcelJS.Alignment> = { horizontal: 'center', vertical: 'middle' };

			const applyHeader = (ws: ExcelJS.Worksheet, fillStyle: ExcelJS.FillPattern) => {
				const hRow = ws.getRow(1);
				hRow.height = 22;
				COLS.forEach((col, i) => {
					const cell = hRow.getCell(i + 1);
					cell.value = col.key;
					cell.fill = fillStyle;
					cell.font = HEADER_FONT;
					cell.border = BORDER;
					cell.alignment = ALIGN_CENTER;
				});
				ws.columns = COLS.map(c => ({ width: c.width }));
				ws.autoFilter = { from: { row: 1, column: 1 }, to: { row: 1, column: COLS.length } };
			};

			const addDataRows = (ws: ExcelJS.Worksheet, data: Record<string, any>[]) => {
				data.forEach((rowData, ri) => {
					const row = ws.getRow(ri + 2);
					row.height = 18;
					COLS.forEach((col, ci) => {
						const cell = row.getCell(ci + 1);
						cell.value = rowData[col.key] ?? '';
						cell.border = BORDER;
						cell.alignment = { vertical: 'middle' };
						if (col.key === 'Status') {
							cell.fill = getStatusFill(String(rowData[col.key] ?? ''));
							cell.alignment = ALIGN_CENTER;
						} else if (col.key === 'KM Pendente') {
							cell.alignment = ALIGN_CENTER;
						}
					});
				});
			};

			const mapTransitoRow = (row: any): Record<string, any> => ({
				'CVA':                   row.cva,
				'Placa':                 row.placa,
				'Data Coleta':           row.dataColeta,
				'H. Janela':             row.hJanela,
				'Status':                traduzirStatusOperacional(row.status),
				'Saída Planta Anchieta': row.saidaPlanta,
				'Transit Time':          row.transitTime,
				'Situação Veículo':      row.situacaoVeiculo,
				'Localização':           row.localizacao,
				'KM Pendente':           row.kmPendente,
				'Observação':            row.observacao,
			});

			const wb = new ExcelJS.Workbook();
			wb.creator = 'Sistema FKS';
			wb.created = agora;

			// --- Aba 1: IDA ---
			const wsIda = wb.addWorksheet('Trânsito São José dos Pinhais', { properties: { tabColor: { argb: 'FF00B0D8' } } });
			applyHeader(wsIda, HEADER_FILL_TEAL);
			addDataRows(wsIda, transitoRows.filter((r: any) => r.sentidoRota === 'ida').map(mapTransitoRow));

			// --- Aba 2: VOLTA ---
			const wsVolta = wb.addWorksheet('Trânsito São Bernardo do Campo', { properties: { tabColor: { argb: 'FF00B0D8' } } });
			applyHeader(wsVolta, HEADER_FILL_TEAL);
			addDataRows(wsVolta, transitoRows.filter((r: any) => r.sentidoRota === 'volta').map(mapTransitoRow));

			// --- Aba 3: Histórico do Mês ---
			let historicoData: Record<string, any>[] = [];
			try {
				const resp = await fetch(`/api/controltower/listar-mes?ano=${yyyy}&mes=${agora.getMonth() + 1}`);
				const json = await resp.json();
				historicoData = (json.rows || []).map((row: any) => ({
					'CVA':                   row.CVA ?? '',
					'Placa':                 row.CAVALO ?? '',
					'Data Coleta':           row.DATA ? new Date(row.DATA).toLocaleDateString('pt-BR') : '',
					'H. Janela':             row.JANELA ?? '',
					'Status':                traduzirStatusOperacional(row.STATUS ?? ''),
					'Saída Planta Anchieta': row.DT_SAIDA_PLANTA_MANUAL
						? new Date(row.DT_SAIDA_PLANTA_MANUAL).toLocaleString('pt-BR')
						: row.DT_SAIDA_PLANTA
						? new Date(row.DT_SAIDA_PLANTA).toLocaleString('pt-BR')
						: '',
					'Transit Time':          '',
					'Situação Veículo':      row.SITUACAO_VEICULO_MANUAL ?? '',
					'Localização':           row.LOCALIZACAO_MANUAL ?? '',
					'KM Pendente':           row.KM_PENDENTE_MANUAL ?? row.KM_PENDENTE_AUTO ?? '',
					'Observação':            row.OBS_TRANSITO ?? '',
				}));
			} catch (_e) { /* exporta vazio */ }
			const wsHist = wb.addWorksheet('Histórico do Mês', { properties: { tabColor: { argb: 'FFFFD700' } } });
			applyHeader(wsHist, HEADER_FILL_YELLOW);
			addDataRows(wsHist, historicoData);

			// Gerar e baixar arquivo
			const buffer = await wb.xlsx.writeBuffer();
			const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = `controltower_transito_${yyyy}${mm}${dd}_${hh}${min}.xlsx`;
			a.click();
			URL.revokeObjectURL(url);
		};

	return (
		<div className="controltower-module">
			<div className="controltower-header-box ctower-transito-header-shell" style={{ display: 'flex', alignItems: 'center', gap: 22, paddingRight: 16 }}>
				<div className="ctower-header-title-wrap">
					<div className="ctower-header-title-line">
						<span className="controltower-header-icon">🗼</span>
						<span className="controltower-header-text">Control Tower</span>
					</div>
					<div className="ctower-header-subtitle">{viewMode === 'transito' ? 'Viagens em Trânsito' : 'Visão Geral das Viagens'}</div>
				</div>
				<div className="ctower-header-filters-inline" style={{ display: 'flex', alignItems: 'center', gap: 14, marginLeft: 14 }}>
					<div style={{ minWidth: 140, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
						<span style={{ fontSize: '0.82rem', fontWeight: 700, color: '#374151', marginBottom: 4, marginLeft: 2 }}>Data</span>
						<DatePicker
							selected={selectedDate}
							onChange={handleDateChange}
							dateFormat="dd/MM/yyyy"
							placeholderText="Filtrar por data"
							filterDate={isDateAvailable}
							isClearable
							showMonthDropdown
							showYearDropdown
							dropdownMode="select"
						/>
					</div>
					<div style={{ minWidth: 360, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
						<span style={{ fontSize: '0.95rem', fontWeight: 500, color: 'transparent', marginBottom: 2, marginLeft: 2 }}>.</span>
						<input
							type="text"
							placeholder={viewMode === 'transito' ? 'Buscar por CVA, placa, motorista, localização...' : 'Buscar por CVA'}
							value={buscaCVA}
							onChange={e => setBuscaCVA(e.target.value)}
							style={{
								width: 350,
								padding: '8px 12px',
								border: '1px solid #d1d5db',
								borderRadius: 8,
								fontSize: '0.9rem',
							}}
						/>
					</div>
				</div>
				<div style={{ flex: 1 }}></div>
				<div className="ctower-header-tabs" style={{ display: 'flex', gap: 8 }}>
					<button
						className="ctower-btn-programacao ctower-view-tab"
						style={viewMode === 'viagem' ? { opacity: 1 } : { opacity: 0.55 }}
						onClick={() => setViewMode('viagem')}
					>
						Por Viagem
					</button>
					<button
						className="ctower-btn-programacao ctower-view-tab"
						style={viewMode === 'transito' ? { opacity: 1, background: 'linear-gradient(90deg, #f97316 60%, #ea580c 100%)' } : { opacity: 0.55, background: 'linear-gradient(90deg, #f97316 60%, #ea580c 100%)' }}
						onClick={() => setViewMode('transito')}
					>
						Em Trânsito
					</button>
					<button
						className="ctower-btn-programacao ctower-view-tab"
						style={viewMode === 'programacao' ? { opacity: 1 } : { opacity: 0.55 }}
						onClick={() => setViewMode('programacao')}
					>
						Control Tower
					</button>
					<button
						className="ctower-btn-programacao ctower-view-tab"
						style={viewMode === 'sugestoes' ? { opacity: 1, background: 'linear-gradient(90deg, #0ea5e9 60%, #0284c7 100%)' } : { opacity: 0.55, background: 'linear-gradient(90deg, #0ea5e9 60%, #0284c7 100%)' }}
						onClick={() => {
							setViewMode('sugestoes');
							void carregarSugestoesVeiculos({ abrirModal: false, mostrarAlertaSemDados: false });
						}}
					>
						Programação
					</button>
				</div>
			</div>
				  
				   {viewMode === 'transito' ? (
					<div className="ctower-transito-page">
						{(() => {
							const rowsPerPage = 10;
							const transitoRows = getTransitoTableRows();

							const parseDateTimeBr = (rawValue: string): Date | null => {
								if (!rawValue || rawValue === '-') return null;
								const match = rawValue.match(/^(\d{2})\/(\d{2})\/(\d{4})\s(\d{2}):(\d{2})$/);
								if (!match) return null;
								const dt = new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]), Number(match[4]), Number(match[5]), 0);
								return isNaN(dt.getTime()) ? null : dt;
							};

							const getEtaInfo = (row: any): { key: 'no-prazo' | 'atencao' | 'atrasada'; label: string; extra?: string } => {
								const km = Number(row.kmPendenteEditValue);
								const velocidade = Number(row.velocidadeAtual || row.velocidade || row.velocidadeMedia || 60);
								if (Number.isFinite(km) && km >= 0 && Number.isFinite(velocidade) && velocidade > 0) {
									const horasEstimadas = km / velocidade;
									const etaDate = new Date(Date.now() + (horasEstimadas * 60 * 60 * 1000));
									const etaLabel = formatarEtaPrevista(etaDate);
									const transitDate = parseDateTimeBr(row.transitTime);
									if (transitDate) {
										const diffHours = (transitDate.getTime() - etaDate.getTime()) / (1000 * 60 * 60);
										if (diffHours < 0) return { key: 'atrasada', label: etaLabel };
										if (diffHours <= 2) return { key: 'atencao', label: etaLabel };
										return { key: 'no-prazo', label: etaLabel };
									}
									return { key: 'no-prazo', label: etaLabel };
								}

								return { key: 'atencao', label: '-' };
							};

							const statusOptions = Array.from(new Set(transitoRows.map(r => String(r.status || '-')))).sort();
							const situacaoOptions = Array.from(new Set(transitoRows.map(r => String(r.situacaoVeiculo || '-')))).sort();
							const localizacaoOptions = Array.from(new Set(transitoRows.map(r => String(r.localizacao || '-')))).sort();

							const rowsAfterFilters = transitoRows.filter((row: any) => {
								const eta = getEtaInfo(row);
								if (transitoQuickFilter !== 'todos' && eta.key !== transitoQuickFilter) return false;
								if (transitoStatusFilter !== 'todos' && String(row.status || '-') !== transitoStatusFilter) return false;
								if (transitoSituacaoFilter !== 'todos' && String(row.situacaoVeiculo || '-') !== transitoSituacaoFilter) return false;
								if (transitoLocalizacaoFilter !== 'todos' && String(row.localizacao || '-') !== transitoLocalizacaoFilter) return false;
								return true;
							});

							const totalEmTransito = transitoRows.length;
							const qtdNoPrazo = rowsAfterFilters.filter((row: any) => getEtaInfo(row).key === 'no-prazo').length;
							const qtdAtencao = rowsAfterFilters.filter((row: any) => getEtaInfo(row).key === 'atencao').length;
							const qtdAtrasada = rowsAfterFilters.filter((row: any) => getEtaInfo(row).key === 'atrasada').length;
							const kmPendenteTotal = rowsAfterFilters.reduce((acc: number, row: any) => {
								const km = Number(row.kmPendenteEditValue);
								return Number.isFinite(km) ? acc + km : acc;
							}, 0);
							const mediaHorasRestante = rowsAfterFilters.length > 0
								? rowsAfterFilters.reduce((acc: number, row: any) => {
									const km = Number(row.kmPendenteEditValue);
									if (!Number.isFinite(km)) return acc;
									return acc + (km / 55);
								}, 0) / rowsAfterFilters.length
								: 0;

							const totalPages = Math.max(1, Math.ceil(rowsAfterFilters.length / rowsPerPage));
							const currentPage = Math.min(transitoPage, totalPages);
							const startIdx = (currentPage - 1) * rowsPerPage;
							const endIdx = startIdx + rowsPerPage;
							const pagedRows = rowsAfterFilters.slice(startIdx, endIdx);
							const rangeStart = rowsAfterFilters.length === 0 ? 0 : startIdx + 1;
							const rangeEnd = Math.min(endIdx, rowsAfterFilters.length);

							const formatDuration = (hours: number): string => {
								if (!Number.isFinite(hours) || hours <= 0) return '0h 00m';
								const h = Math.floor(hours);
								const m = Math.round((hours - h) * 60);
								return `${h}h ${String(m).padStart(2, '0')}m`;
							};

							if (loadingTransito) {
								return <div className="ctower-transito-empty">Carregando registros em trânsito...</div>;
							}

							return (
								<>
									<div className="ctower-transito-kpi-grid">
										<div className="ctower-transito-kpi-card ctower-transito-kpi-card-blue">
											<div className="ctower-transito-kpi-title">Total em Trânsito</div>
											<div className="ctower-transito-kpi-value">{totalEmTransito}</div>
											<div className="ctower-transito-kpi-sub">viagens</div>
										</div>
										<div className="ctower-transito-kpi-card ctower-transito-kpi-card-green">
											<div className="ctower-transito-kpi-title">Dentro do Prazo</div>
											<div className="ctower-transito-kpi-value ctower-transito-kpi-ok">{qtdNoPrazo}</div>
											<div className="ctower-transito-kpi-sub">{totalEmTransito > 0 ? Math.round((qtdNoPrazo / totalEmTransito) * 100) : 0}%</div>
										</div>
										<div className="ctower-transito-kpi-card ctower-transito-kpi-card-amber">
											<div className="ctower-transito-kpi-title">Atenção</div>
											<div className="ctower-transito-kpi-value ctower-transito-kpi-warn">{qtdAtencao}</div>
											<div className="ctower-transito-kpi-sub">{totalEmTransito > 0 ? Math.round((qtdAtencao / totalEmTransito) * 100) : 0}%</div>
										</div>
										<div className="ctower-transito-kpi-card ctower-transito-kpi-card-red">
											<div className="ctower-transito-kpi-title">Atrasadas</div>
											<div className="ctower-transito-kpi-value ctower-transito-kpi-danger">{qtdAtrasada}</div>
											<div className="ctower-transito-kpi-sub">{totalEmTransito > 0 ? Math.round((qtdAtrasada / totalEmTransito) * 100) : 0}%</div>
										</div>
										<div className="ctower-transito-kpi-card">
											<div className="ctower-transito-kpi-title">KM Pendente</div>
											<div className="ctower-transito-kpi-value">{Math.round(kmPendenteTotal).toLocaleString('pt-BR')} km</div>
											<div className="ctower-transito-kpi-sub">Total a percorrer</div>
											<div className="ctower-transito-kpi-progress"><span style={{ width: `${Math.max(5, Math.min(100, Math.round((kmPendenteTotal / 3000) * 100)))}%` }} /></div>
										</div>
										<div className="ctower-transito-kpi-card">
											<div className="ctower-transito-kpi-title">Tempo Médio Restante</div>
											<div className="ctower-transito-kpi-value">{formatDuration(mediaHorasRestante)}</div>
											<div className="ctower-transito-kpi-sub">Média das viagens</div>
										</div>
									</div>

									<div className="ctower-transito-main-card">
										<div className="ctower-transito-toolbar">
											<div className="ctower-transito-toolbar-left">
												<span className="ctower-transito-toolbar-label">Filtros Rápidos:</span>
												{([
													{ key: 'todos', label: 'Todos', cls: 'all' },
													{ key: 'no-prazo', label: 'No Prazo', cls: 'ok' },
													{ key: 'atencao', label: 'Atenção', cls: 'warn' },
													{ key: 'atrasada', label: 'Atrasadas', cls: 'danger' },
												] as const).map((item) => (
													<button
														key={item.key}
														className={`ctower-transito-chip ${item.cls} ${transitoQuickFilter === item.key ? 'active' : ''}`}
														onClick={() => setTransitoQuickFilter(item.key)}
													>
														{item.label}
													</button>
												))}
											</div>
											<div className="ctower-transito-toolbar-right">
												<button
													type="button"
													className="ctower-transito-btn-secondary"
													style={{ background: 'linear-gradient(90deg, #0ea5e9 60%, #0284c7 100%)', color: '#fff', fontWeight: 600 }}
													onClick={async () => {
														try {
															const resp = await fetch('/api/monitoramento/reprocessar-viagens-retroativas', { method: 'POST' });
															const data = await resp.json();
															alert(data.ok ? `Retroativo processado! ${data.totalFinalizadas} viagens finalizadas.` : (data.message || 'Retroativo processado!'));
														} catch (err) {
															alert('Erro ao processar retroativo');
														}
													}}
												>
													Atualizar Retroativo
												</button>
												<button type="button" className="ctower-transito-btn-export" onClick={handleExportTransito}>Exportar</button>
											</div>
										</div>

										<div className="ctower-transito-select-row">
											<div className="ctower-transito-select-wrap">
												<label>Status</label>
												<select value={transitoStatusFilter} onChange={(e) => setTransitoStatusFilter(e.target.value)}>
													<option value="todos">Todos</option>
													{statusOptions.map((status) => <option key={status} value={status}>{status}</option>)}
												</select>
											</div>
											<div className="ctower-transito-select-wrap">
												<label>Situação Veículo</label>
												<select value={transitoSituacaoFilter} onChange={(e) => setTransitoSituacaoFilter(e.target.value)}>
													<option value="todos">Todos</option>
													{situacaoOptions.map((situacao) => <option key={situacao} value={situacao}>{situacao}</option>)}
												</select>
											</div>
											<div className="ctower-transito-select-wrap">
												<label>Localização</label>
												<select value={transitoLocalizacaoFilter} onChange={(e) => setTransitoLocalizacaoFilter(e.target.value)}>
													<option value="todos">Todas</option>
													{localizacaoOptions.map((local) => <option key={local} value={local}>{local}</option>)}
												</select>
											</div>
											<div className="ctower-transito-select-wrap">
												<label>Sentido</label>
												<select value={sentidoTransito} onChange={(e) => setSentidoTransito(e.target.value as 'todos' | 'ida' | 'volta')}>
													<option value="todos">Todos</option>
													<option value="ida">Ida</option>
													<option value="volta">Volta</option>
												</select>
											</div>
										</div>

										{rowsAfterFilters.length === 0 ? (
											<div className="ctower-transito-empty">Nenhum registro de trânsito para este filtro.</div>
										) : (
											<>
												<div className="ctower-transito-table-wrap">
													<table className="ctower-transito-table">
														<thead>
															<tr>
																<th>CVA</th>
																<th>Placa</th>
																<th>Data Coleta</th>
																<th>H. Janela</th>
																<th>Status</th>
																<th>Saída Planta Anchieta</th>
																<th>Trânsito</th>
																<th>Situação Veículo</th>
																<th>Localização</th>
																<th>KM Pendente</th>
																<th>ETA Prevista</th>
																<th>Observação</th>
																<th>Ações</th>
															</tr>
														</thead>
														<tbody>
															{pagedRows.map((row: any, idx: number) => {
																const etaInfo = getEtaInfo(row);
																const statusNorm = normalizarTexto(row.status);
																const situacaoNorm = normalizarTexto(row.situacaoVeiculo);
																const kmNum = Number(row.kmPendenteEditValue);
																const kmBarWidth = Number.isFinite(kmNum) ? Math.max(6, Math.min(100, Math.round((kmNum / 300) * 100))) : 0;
																const isFinalizada = statusNorm === 'finalizado';
																// Campos congelados
																const saidaPlanta = row.saidaPlanta || row.DT_SAIDA_PLANTA || '-';
																const transitTime = row.transitTime || '-';
																// Busca robusta para campos ETA Prevista e Chegada Real SJP (todas variantes)
																const getFieldValue = (...fields: string[]) => {
																	for (const f of fields) {
																		const v = row[f];
																		if (v && v !== '-') return v;
																	}
																	return '-';
																};

																const etaPrevista = getFieldValue('DT_ETA_PREVISTA', 'dt_eta_prevista', 'ETA_PREVISTA', 'eta_prevista', 'etaPrevista');
																const chegadaRealSJP = getFieldValue('DT_CHEGADA_REAL_SJP', 'dt_chegada_real_sjp', 'CHEGADA_REAL_SJP', 'chegada_real_sjp', 'chegadaRealSJP');
																return (
																	<tr key={`${row.cva}-${row.placa}-${startIdx + idx}`}>
																		<td><span className="ctower-transito-cva">🚚 {row.cva}</span></td>
																		<td>{row.placa}</td>
																		<td>{row.dataColeta}</td>
																		<td>{row.hJanela}</td>
																		<td>
																			<span className={`ctower-transito-status-badge ${(statusNorm.includes('bolsao') || statusNorm.includes('aguardando')) ? 'bolsao' : 'transito'}`}>
																				{isFinalizada ? 'Viagem finalizada' : row.status}
																			</span>
																		</td>
																		<td>{isFinalizada ? saidaPlanta : row.saidaPlanta}</td>
																		<td className="ctower-transito-transit">{isFinalizada ? transitTime : row.transitTime}</td>
																		<td>
																			<span className={`ctower-transito-situacao ${situacaoNorm.includes('rodando') ? 'rodando' : situacaoNorm.includes('problema') ? 'problema' : 'parado'}`}>
																				{isFinalizada ? 'Viagem finalizada' : row.situacaoVeiculo}
																			</span>
																		</td>
																		<td>📍 {isFinalizada ? 'Viagem finalizada' : row.localizacao}</td>
																		<td>
																			<div className="ctower-transito-km-cell">
																				<span className="ctower-transito-km">{isFinalizada ? 'Viagem finalizada' : row.kmPendente}</span>
																				{!isFinalizada && <div className="ctower-transito-km-bar"><span style={{ width: `${kmBarWidth}%` }} /></div>}
																			</div>
																		</td>
																		<td>
																			{isFinalizada ? (
																				<div>
																					<div><b>Previsto:</b> {formatarDataHora(etaPrevista)}</div>
																					<div><b>Real:</b> {formatarDataHora(chegadaRealSJP)}</div>
																				</div>
																			) : (
																				<>
																					<div>{row.transitTime}</div>
																					<div className={`ctower-transito-eta ${etaInfo.key}`}>{etaInfo.label}</div>
																				</>
																			)}
																		</td>
																		<td>
																			{isFinalizada ? '' : (
																				<input
																					type="text"
																					defaultValue={row.observacao}
																					placeholder="Digite uma observação"
																					style={{ width: '100%', minWidth: '180px' }}
																					onBlur={(e) => {
																						const nextValue = e.target.value.trim();
																						salvarTransitoUpdate(row._id, { obs_transito: nextValue }, { OBS_TRANSITO: nextValue });
																					}}
																				/>
																			)}
																		</td>
																		<td>⋮</td>
																	</tr>
																);
															})}
														</tbody>
													</table>
												</div>

												<div className="ctower-transito-pagination">
													<div className="ctower-transito-pagination-info">
														Mostrando {rangeStart} a {rangeEnd} de {rowsAfterFilters.length} registros
													</div>
													<div className="ctower-transito-pagination-controls">
														<button onClick={() => setTransitoPage(prev => Math.max(1, prev - 1))} disabled={currentPage <= 1}>‹</button>
														<span>{currentPage}</span>
														<button onClick={() => setTransitoPage(prev => Math.min(totalPages, prev + 1))} disabled={currentPage >= totalPages}>›</button>
													</div>
													<div className="ctower-transito-pagination-lines">
														<span>Linhas por página:</span>
														<select value="10" onChange={() => undefined}>
															<option value="10">10</option>
														</select>
													</div>
												</div>
											</>
										)}
									</div>
								</>
							);
						})()}
					</div>
				) : viewMode === 'sugestoes' ? (
					<div className="ctower-prog-section" style={{ padding: 16 }}>
						{/* Modais existentes */}
						{showWindowModal && (
							<div className="ctower-modal-bg">
								<div className="ctower-modal-box ctower-window-modal-box">
									<div className="ctower-modal-title">Configurar Janelas por Data</div>
									<div className="ctower-window-modal-content">
										<label className="ctower-window-label">Data</label>
										<input
											type="date"
											value={windowFormDate}
											onChange={e => handleWindowDateChange(e.target.value)}
											className="ctower-window-date-input"
										/>
										<label className="ctower-window-label">
											Horários das janelas
											{isLoadingWindowsFromNucci && <span style={{ marginLeft: 8, color: '#666', fontSize: '0.85em' }}>⏳ Carregando...</span>}
										</label>
										<textarea
											value={windowFormTimes}
											onChange={e => setWindowFormTimes(e.target.value)}
											placeholder="Um horário por linha (ex: 06:20)"
											className="ctower-window-times-textarea"
										/>
									</div>
									<div className="ctower-modal-actions">
										<button className="ctower-btn-nao" onClick={() => setShowWindowModal(false)} disabled={isSavingWindowSchedule}>Cancelar</button>
										<button className="ctower-btn-nao" onClick={handleClearWindowSchedule} disabled={isSavingWindowSchedule}>Limpar Data</button>
										<button className="ctower-btn-sim" onClick={handleSaveWindowSchedule} disabled={isSavingWindowSchedule}>{isSavingWindowSchedule ? 'Salvando...' : 'Salvar Janelas'}</button>
									</div>
								</div>
							</div>
						)}
						{showSugestoesModal && (
							<div className="ctower-modal-bg">
								<div className="ctower-modal-box" style={{ maxWidth: 980, width: '96%' }}>
									<div className="ctower-modal-title">Placas sugeridas pela regra</div>
									<div style={{ display: 'flex', gap: 8, marginBottom: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
										{(['voltando', 'patio', 'transito'] as const).map((cat) => {
											const count = sugestoesOpcoes.filter((o) => o.categoria === cat).length;
											const labels: Record<string, string> = { voltando: '↩ Voltando', patio: '🅿 No Pátio FKS', transito: '🔄 Em trânsito' };
											const colors: Record<string, string> = { voltando: '#2563eb', patio: '#16a34a', transito: '#d97706' };
											const active = filtroSugestoesModal === cat;
											return (
												<button
													key={cat}
													onClick={() => setFiltroSugestoesModal(cat)}
													style={{
														padding: '5px 14px',
														borderRadius: 20,
														border: `2px solid ${colors[cat]}`,
														background: active ? colors[cat] : '#fff',
														color: active ? '#fff' : colors[cat],
														fontWeight: 600,
														fontSize: '0.88rem',
														cursor: 'pointer',
														transition: 'all 0.15s'
													}}
												>
													{labels[cat]} ({count})
												</button>
											);
										})}
									</div>
									{(() => {
										const veiculosFiltrados = sugestoesOpcoes.filter((o) => o.categoria === filtroSugestoesModal);
										const catHeader: Record<string, string> = { voltando: '#dbeafe', patio: '#dcfce7', transito: '#fef3c7' };
										const catBorder: Record<string, string> = { voltando: '#93c5fd', patio: '#86efac', transito: '#fcd34d' };
										return veiculosFiltrados.length > 0 ? (
											<div style={{ marginBottom: 14 }}>
												<div style={{ fontSize: '0.82rem', fontWeight: 600, color: '#6b7280', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 1 }}>
													Veículos disponíveis nesta categoria
												</div>
												<div style={{ maxHeight: 150, overflowY: 'auto', border: `1px solid ${catBorder[filtroSugestoesModal]}`, borderRadius: 8 }}>
													<table className="ctower-excel-table" style={{ marginBottom: 0, fontSize: '0.85rem' }}>
														<thead>
															<tr style={{ background: catHeader[filtroSugestoesModal] }}>
																<th>Cavalo</th>
																<th>Status do Veículo</th>
																<th>Local do Veículo</th>
																<th>Distância (km)</th>
															</tr>
														</thead>
														<tbody>
															{veiculosFiltrados.map((v) => (
																<tr key={v.placa}>
																	<td style={{ fontWeight: 600 }}>{v.placa}</td>
																	<td>{v.statusVeiculo}</td>
																	<td
																		onClick={() => copiarLocalLatLong(v.localVeiculo)}
																		title="Clique para copiar o lat/long"
																		style={{ cursor: 'copy', textDecoration: 'underline', textDecorationStyle: 'dotted', maxWidth: 260, wordBreak: 'break-word' }}
																	>
																		{v.localVeiculo}
																	</td>
																	<td>{v.km}</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											</div>
										) : null;
									})()}
									<div style={{ maxHeight: 280, overflowY: 'auto', marginBottom: 12 }}>
										<table className="ctower-excel-table" style={{ marginBottom: 0 }}>
											<thead>
												<tr>
													<th>Janela</th>
													<th>Cavalo sugerido</th>
													<th>Status do veículo</th>
													<th>Local do veículo</th>
													<th>Distância (km)</th>
												</tr>
											</thead>
											<tbody>
												{sugestoesPreview.map((item, idx) => (
													<tr key={`${item.rowIdx}-${item.placa}-${idx}`}>
														<td>{item.horario}</td>
														<td>
															<select
																value={item.placa}
																onChange={(e) => handleAlterarPlacaSugestao(idx, e.target.value)}
																style={{
																	width: '100%',
																	minWidth: 140,
																	border: '1px solid #d1d5db',
																	borderRadius: 6,
																	padding: '6px 8px',
																	background: '#fff'
																}}
															>
																{sugestoesOpcoes
																	.filter((o) => o.categoria === filtroSugestoesModal)
																	.map((opt) => (
																		<option key={opt.placa} value={opt.placa}>{opt.placa}</option>
																	))}
															</select>
														</td>
														<td>{item.statusVeiculo}</td>
														<td
															onClick={() => copiarLocalLatLong(item.localVeiculo)}
															title="Clique para copiar o lat/long"
															style={{
																maxWidth: 300,
																whiteSpace: 'normal',
																wordBreak: 'break-word',
																cursor: 'copy',
																textDecoration: 'underline',
																textDecorationStyle: 'dotted'
															}}
														>
															{item.localVeiculo}
														</td>
														<td>{item.km}</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
									<div style={{ marginBottom: 8, color: '#374151', fontSize: '0.95rem', textAlign: 'center' }}>{copyLocalFeedback}</div>
									<div className="ctower-modal-actions">
										<button
											className="ctower-btn-nao"
											onClick={() => {
												setShowSugestoesModal(false);
												setSugestoesPreview([]);
												setSugestoesOpcoes([]);
												setCopyLocalFeedback('Clique no Local do veículo para copiar o lat/long.');
											}}
											disabled={savingSugestoes}
										>
											Cancelar
										</button>
										<button className="ctower-btn-sim" onClick={confirmarSugestoesVeiculos} disabled={savingSugestoes}>
											{savingSugestoes ? 'Salvando...' : 'Aplicar sugestões'}
										</button>
									</div>
								</div>
							</div>
						)}

						{(() => {
							const monitoramentoPorPlaca = new Map<string, any>();
							(veiculosMonitoramento || []).forEach((vm: any) => {
								const placaRaw = getPlacaValue(vm) || vm?.placa || vm?.nm_placa;
								const placaKey = normalizePlaca(placaRaw);
								if (placaKey) monitoramentoPorPlaca.set(placaKey, vm);
							});

							const rowsProgramacaoBase = (() => {
								const currentDateStr = selectedDate ? selectedDate.toISOString().split('T')[0] : '';
								const mergedMap = new Map<string, any>();

								[...programacaoRows, ...importedRows].forEach((row: any) => {
									const rowDate = row.DATA && typeof row.DATA === 'string' && row.DATA.includes('T') ? row.DATA.split('T')[0] : row.DATA;
									if (rowDate && rowDate !== currentDateStr) return;
									const rowJanela = normalizeJanela(row.JANELA || row.janela);
									if (!rowJanela) return;
									const key = `${rowDate || currentDateStr}_${rowJanela}`;
									const existing = mergedMap.get(key) || {};
									mergedMap.set(key, {
										...existing,
										...row,
										JANELA: row.JANELA || row.janela || existing.JANELA,
										DATA: row.DATA || existing.DATA || currentDateStr,
										STATUS: row.STATUS || row.status || existing.STATUS,
									});
								});

								return Array.from(mergedMap.values()).sort((a, b) => {
									const aMin = janelaToMinutes(normalizeJanela(a.JANELA || a.janela));
									const bMin = janelaToMinutes(normalizeJanela(b.JANELA || b.janela));
									return aMin - bMin;
								});
							})();
							const linhasProgramacao = getMergedRows(rowsProgramacaoBase, true);
							const totalProgramado = linhasProgramacao.length;
							const agendados = linhasProgramacao.filter((r: any) => String(r.CAVALO || '').trim()).length;
							const pendentes = Math.max(totalProgramado - agendados, 0);
							const conflitos = sugestoesOpcoes.filter((v) => String(v.statusVeiculo || '').toLowerCase().includes('fora')).length;

							const isVoltandoVm = (vm: any) => {
								const sentido = vm?.sentidoRota || vm?.ds_sentido_rota || vm?.sentido || '';
								const sentidoNormalizado = String(sentido).toLowerCase();
								return sentidoNormalizado === 'volta' || sentidoNormalizado.includes('volt');
							};

							const isVolksVm = (vm: any) => {
								const op = vm?.operacao || vm?.ds_operacao || '';
								return typeof op === 'string' && op.toLowerCase().includes('volks');
							};

							const hasProblemaRastreadorVm = (vm: any) => {
								const texto = String(
									vm?.status || vm?.ds_status || vm?.status_monitoramento || vm?.observacao || vm?.obs || ''
								).toLowerCase();
								return texto.includes('sem rastreador') || texto.includes('rastreador offline') || texto.includes('gps offline') || texto.includes('indisponivel') || texto.includes('inoperante') || texto.includes('problema rastreador');
							};

							const isEmPatioVm = (vm: any) => {
								const pol = String(vm?.poligono || vm?.nm_poligono_atual || vm?.ultimoPoligono || vm?.ultimo_poligono || vm?.poligonoAtual || '').toLowerCase();
								return pol.includes('patio fks') || pol.includes('pátio fks') || pol.includes('pateo fks');
							};

							const buildFallbackOpcoes = () => {
								const seen = new Set<string>();
								const fallback: Array<{ placa: string; km: number; statusVeiculo: string; localVeiculo: string; categoria: 'voltando' | 'patio' | 'transito' }> = [];

								(veiculosMonitoramento || []).forEach((vm: any) => {
									if (hasProblemaRastreadorVm(vm)) return;
									const placa = getPlacaValue(vm) || vm?.placa || vm?.nm_placa || '';
									const key = normalizePlaca(placa);
									if (!key || seen.has(key)) return;
									const lat = toCoordNumber(vm?.latitude ?? vm?.lat ?? vm?.localizacao?.lat ?? vm?.localizacao?.latitude);
									const lng = toCoordNumber(vm?.longitude ?? vm?.lng ?? vm?.localizacao?.lng ?? vm?.localizacao?.longitude);
									const localVeiculo = String(vm?.localizacao?.endereco || vm?.endereco || vm?.ds_endereco || vm?.localizacaoAtual || vm?.ultimaLocalizacao || 'Local não informado');
									const statusVeiculo = String(vm?.status || vm?.ds_status || vm?.status_monitoramento || 'Desconhecido');
									let categoria: 'voltando' | 'patio' | 'transito' = 'transito';
									if (isVoltandoVm(vm) && isVolksVm(vm)) categoria = 'voltando';
									else if (isEmPatioVm(vm)) categoria = 'patio';
									else if (isVoltandoVm(vm)) categoria = 'voltando';
									else if (String(statusVeiculo).toLowerCase().includes('movimento')) categoria = 'transito';
									else return;

									seen.add(key);
									fallback.push({
										placa,
										km: lat != null && lng != null ? Math.round(calcularDistancia(lat, lng, COORDS_VW_SBC.lat, COORDS_VW_SBC.lng)) : 0,
										statusVeiculo,
										localVeiculo,
										categoria,
									});
								});

								return fallback.sort((a, b) => a.km - b.km);
							};

							const sugestoesBaseVisiveis = sugestoesOpcoes.length > 0 ? sugestoesOpcoes : buildFallbackOpcoes();

							const topRowsRaw = sugestoesBaseVisiveis
								.filter((o) => o.categoria === filtroSugestoesModal)
								.map((v) => {
									const placaKey = normalizePlaca(v.placa);
									const vm = monitoramentoPorPlaca.get(placaKey);
									const motorista = vm?.motorista?.nome || vm?.motoristaNome || vm?.nm_motorista || vm?.motorista || '-';
									const fksMotorista = motorista !== '-' ? motorista : (vm?.fks || v.placa || '-');
									const janela = sugestoesPreview.find((s) => normalizePlaca(s.placa) === placaKey)?.horario || '-';
									const eta = janela !== '-' && selectedDate ? calcularPrevChegada(dateToKey(selectedDate), janela, 20) : '-';
									const localAtual = v.localVeiculo || vm?.localizacao?.endereco || '-';
									const statusTxt = String(v.statusVeiculo || '-');
									const lat = toCoordNumber(vm?.latitude ?? vm?.lat ?? vm?.localizacao?.lat ?? vm?.localizacao?.latitude);
									const lng = toCoordNumber(vm?.longitude ?? vm?.lng ?? vm?.localizacao?.lng ?? vm?.localizacao?.longitude);
									const coordsTexto = extrairLatLngDoTexto(localAtual);
									return {
										cva: v.placa,
										placa: v.placa,
										categoria: v.categoria,
										fksMotorista,
										statusTxt,
										eta,
										janela,
										localAtual,
										distancia: `${v.km} km`,
										mapLat: lat ?? coordsTexto?.lat,
										mapLng: lng ?? coordsTexto?.lng,
									};
								});

							const topRowsFiltered = topRowsRaw.filter((row) => {
								if (programacaoFiltroJanela !== 'todos' && row.janela !== programacaoFiltroJanela) return false;
								if (programacaoFiltroStatus !== 'todos' && row.statusTxt !== programacaoFiltroStatus) return false;
								if (programacaoFiltroFks !== 'todos' && row.fksMotorista !== programacaoFiltroFks) return false;
								return true;
							});

							const topPageSize = 5;
							const topTotalPages = Math.max(1, Math.ceil(topRowsFiltered.length / topPageSize));
							const topPage = Math.min(veiculosCategoriaPage, topTotalPages);
							const topStart = (topPage - 1) * topPageSize;
							const topRows = topRowsFiltered.slice(topStart, topStart + topPageSize);

							const programacaoPageSize = 7;
							const programacaoTotalPages = Math.max(1, Math.ceil(linhasProgramacao.length / programacaoPageSize));
							const programacaoPage = Math.min(programacaoSugestoesPage, programacaoTotalPages);
							const programacaoStart = (programacaoPage - 1) * programacaoPageSize;
							const programacaoRowsPaged = linhasProgramacao.slice(programacaoStart, programacaoStart + programacaoPageSize);
							const programacaoMostrandoInicio = linhasProgramacao.length === 0 ? 0 : programacaoStart + 1;
							const programacaoMostrandoFim = Math.min(programacaoStart + programacaoPageSize, linhasProgramacao.length);

								// Placas excluídas das sugestões inline:
								// 1. Usadas na janela do dia anterior
								const placasExcluidasOntem = new Set<string>(
									previousDayProgramacaoRows
										.filter((r: any) => String(r.CAVALO || '').trim())
										.map((r: any) => normalizePlaca(String(r.CAVALO || '')))
										.filter(Boolean)
								);
								// 2. Já atribuídas em janelas com status Previsto (hoje)
								const placasExcluidasPrevisto = new Set<string>(
									linhasProgramacao
										.filter((r: any) => normalizarTexto(r.STATUS || '').includes('previsto'))
										.map((r: any) => normalizePlaca(String(r.CAVALO || '')))
										.filter(Boolean)
								);
								// 3. Já atribuídas em outras janelas de hoje
								const placasJaAtribuidasHoje = new Set<string>(
									linhasProgramacao
										.filter((r: any) => String(r.CAVALO || '').trim())
										.map((r: any) => normalizePlaca(String(r.CAVALO || '')))
										.filter(Boolean)
								);
								// 1ª prioridade: veículos voltando
								const candidatosVoltando = sugestoesBaseVisiveis
									.filter((o) => o.categoria === 'voltando')
									.filter((o) => {
										const key = normalizePlaca(o.placa);
										if (placasExcluidasOntem.has(key) || placasExcluidasPrevisto.has(key) || placasJaAtribuidasHoje.has(key)) return false;
										const vm = monitoramentoPorPlaca.get(key);
										if (vm && isEmPatioVm(vm)) return false;
										return true;
									})
									.sort((a, b) => a.km - b.km)
									.map((o): { placa: string; km: number } => ({ placa: o.placa, km: o.km }));
								const placasVoltandoSet = new Set(candidatosVoltando.map((o) => normalizePlaca(o.placa)));
								// 2ª prioridade: veículos indo (sentido 'ida') — usados quando voltando se esgota
								const candidatosIndo: Array<{ placa: string; km: number }> = [];
								(veiculosMonitoramento || []).forEach((vm: any) => {
									if (hasProblemaRastreadorVm(vm)) return;
									if (!isVolksVm(vm)) return;
									if (isEmPatioVm(vm)) return;
									const placa = getPlacaValue(vm) || vm?.placa || vm?.nm_placa || '';
									const key = normalizePlaca(placa);
									if (!key) return;
									if (placasExcluidasOntem.has(key) || placasExcluidasPrevisto.has(key) || placasJaAtribuidasHoje.has(key)) return;
									if (placasVoltandoSet.has(key)) return;
									const sentido = String(vm?.sentidoRota || vm?.ds_sentido_rota || vm?.sentido || '').toLowerCase();
									if (!(sentido === 'ida' || sentido.startsWith('id') || sentido.includes('indo'))) return;
									const lat = toCoordNumber(vm?.latitude ?? vm?.lat ?? vm?.localizacao?.lat ?? vm?.localizacao?.latitude);
									const lng = toCoordNumber(vm?.longitude ?? vm?.lng ?? vm?.localizacao?.lng ?? vm?.localizacao?.longitude);
									candidatosIndo.push({ placa, km: lat != null && lng != null ? Math.round(calcularDistancia(lat, lng, COORDS_VW_SBC.lat, COORDS_VW_SBC.lng)) : 0 });
								});
								candidatosIndo.sort((a, b) => a.km - b.km);
								const candidatosInline: Array<{ placa: string; km: number }> = [...candidatosVoltando, ...candidatosIndo];
								// Parear: cada janela vazia recebe o próximo candidato disponível
								const sugestaoInlinePorJanela = new Map<string, { placa: string; km: number }>();
								let inlineCandIdx = 0;
								const placasUsadasInline = new Set<string>(placasJaAtribuidasHoje);
								linhasProgramacao
									.filter((r: any) => !String(r.CAVALO || '').trim())
									.forEach((row: any) => {
										const janela = normalizeJanela(row.JANELA || row.janela);
										if (!janela) return;
										while (inlineCandIdx < candidatosInline.length) {
											const cand = candidatosInline[inlineCandIdx++];
											const key = normalizePlaca(cand.placa);
											if (placasUsadasInline.has(key)) continue;
											placasUsadasInline.add(key);
											sugestaoInlinePorJanela.set(janela, { placa: cand.placa, km: cand.km });
											break;
										}
									});

							const janelaOptions = Array.from(new Set(topRowsRaw.map((r) => r.janela).filter((v) => v && v !== '-'))).sort();
							const statusOptions = Array.from(new Set(topRowsRaw.map((r) => r.statusTxt).filter(Boolean))).sort();
							const fksOptions = Array.from(new Set(topRowsRaw.map((r) => r.fksMotorista).filter(Boolean))).sort();
							const mapMarkers = topRowsFiltered
								.filter((row) => row.mapLat != null && row.mapLng != null)
								.map((row) => ({
									lat: row.mapLat as number,
									lng: row.mapLng as number,
									placa: row.placa,
									statusTxt: row.statusTxt,
									localAtual: row.localAtual,
									categoria: row.categoria,
								}));
							const upsertCampoProgramacaoLocal = (field: string, value: string, horario: string) => {
								const applyUpsert = (prevRows: any[]) => {
									const currentDateStr = selectedDate ? selectedDate.toISOString().split('T')[0] : '';
									const existingIndex = prevRows.findIndex((row) => {
										const rowDate = row.DATA && typeof row.DATA === 'string' && row.DATA.includes('T') ? row.DATA.split('T')[0] : row.DATA;
										const rowJanela = normalizeJanela(row.JANELA || row.janela);
										return rowJanela === normalizeJanela(horario) && rowDate === currentDateStr;
									});

									if (existingIndex >= 0) {
										const newRows = [...prevRows];
										newRows[existingIndex] = { ...newRows[existingIndex], [field]: value };
										return newRows;
									}

									return [
										...prevRows,
										{ JANELA: horario, DATA: currentDateStr, STATUS: 'Aguardando veículo', [field]: value }
									];
								};

								setImportedRows((prevRows) => applyUpsert(prevRows));
								setProgramacaoRows((prevRows) => applyUpsert(prevRows));
							};

							const salvarCampoProgramacao = async (field: string, value: string, horario: string) => {
								upsertCampoProgramacaoLocal(field, value, horario);
								try {
									await fetch('/api/controltower/programacao/salvar', {
										method: 'POST',
										headers: { 'Content-Type': 'application/json' },
										body: JSON.stringify({
											field,
											value,
											date: selectedDate ? selectedDate.toISOString().split('T')[0] : '',
											horario,
										}),
									});
								} catch (error) {
									console.error('Erro ao salvar campo da programação:', error);
								}
							};

							return (
								<div className="ctower-sug-v2-page">
									<div className="ctower-sug-v2-top-layout">
										<div className="ctower-sug-v2-top-main">
											<div className="ctower-sug-v2-stats compact">
												<div className="ctower-sug-v2-stat blue compact">
													<div className="ctower-sug-v2-stat-label">Total Programado</div>
													<div className="ctower-sug-v2-stat-value">{totalProgramado}</div>
													<div className="ctower-sug-v2-stat-sub">veículos</div>
												</div>
												<div className="ctower-sug-v2-stat green compact">
													<div className="ctower-sug-v2-stat-label">Agendados</div>
													<div className="ctower-sug-v2-stat-value">{agendados}</div>
													<div className="ctower-sug-v2-stat-sub">{totalProgramado ? `${((agendados / totalProgramado) * 100).toFixed(1)}%` : '0%'}</div>
												</div>
												<div className="ctower-sug-v2-stat yellow compact">
													<div className="ctower-sug-v2-stat-label">Pendentes</div>
													<div className="ctower-sug-v2-stat-value">{pendentes}</div>
													<div className="ctower-sug-v2-stat-sub">{totalProgramado ? `${((pendentes / totalProgramado) * 100).toFixed(1)}%` : '0%'}</div>
												</div>
												<div className="ctower-sug-v2-stat red compact">
													<div className="ctower-sug-v2-stat-label">Conflitos</div>
													<div className="ctower-sug-v2-stat-value">{conflitos}</div>
													<div className="ctower-sug-v2-stat-sub">{topRowsRaw.length ? `${((conflitos / topRowsRaw.length) * 100).toFixed(1)}%` : '0%'}</div>
												</div>
											</div>

											<div className="ctower-sug-v2-card ctower-sug-v2-card-tight">
										<div className="ctower-sug-v2-filters-row">
											<div className="ctower-sug-v2-chip-group">
												{(['voltando', 'patio', 'transito'] as const).map((cat) => {
													const count = sugestoesOpcoes.filter((o) => o.categoria === cat).length;
													const labelMap: Record<string, string> = { voltando: 'Voltando', patio: 'No Pátio FKS', transito: 'Em trânsito' };
													return (
														<button key={cat} className={`ctower-sug-v2-chip ${filtroSugestoesModal === cat ? 'active' : ''}`} onClick={() => { setFiltroSugestoesModal(cat); setVeiculosCategoriaPage(1); }}>
															{labelMap[cat]} ({count})
														</button>
													);
												})}
											</div>
											<div className="ctower-sug-v2-select-group">
												<select value={programacaoFiltroJanela} onChange={(e) => { setProgramacaoFiltroJanela(e.target.value); setVeiculosCategoriaPage(1); }}>
													<option value="todos">Todas as janelas</option>
													{janelaOptions.map((item) => <option key={item} value={item}>{item}</option>)}
												</select>
												<select value={programacaoFiltroStatus} onChange={(e) => { setProgramacaoFiltroStatus(e.target.value); setVeiculosCategoriaPage(1); }}>
													<option value="todos">Todos os status</option>
													{statusOptions.map((item) => <option key={item} value={item}>{item}</option>)}
												</select>
												<select value={programacaoFiltroFks} onChange={(e) => { setProgramacaoFiltroFks(e.target.value); setVeiculosCategoriaPage(1); }}>
													<option value="todos">Todos os FKS</option>
													{fksOptions.map((item) => <option key={item} value={item}>{item}</option>)}
												</select>
												<input type="text" value={selectedDate ? selectedDate.toLocaleDateString('pt-BR') : ''} readOnly />
												<button className="ctower-sug-v2-btn ghost" onClick={() => {
													setProgramacaoFiltroJanela('todos');
													setProgramacaoFiltroStatus('todos');
													setProgramacaoFiltroFks('todos');
												}}>Limpar Filtros</button>
												<button className="ctower-sug-v2-btn dark">Tabela</button>
											</div>
										</div>

												<div className="ctower-sug-v2-title">Veículos chegando nesta categoria</div>
												<div className="ctower-sug-v2-table-wrap compact">
													<table className="ctower-sug-v2-table compact">
												<thead>
													<tr>
														<th>CVA</th>
														<th>FKS / Motorista</th>
														<th>Status</th>
																<th>Placa</th>
																<th>Previsão Chegada</th>
														<th>Local Atual</th>
														<th>Distância</th>
													</tr>
												</thead>
												<tbody>
													{topRows.map((row, idx) => {
														const statusClass = row.statusTxt.toLowerCase().includes('fora') ? 'danger' : 'success';
														return (
															<tr key={`${row.placa}-${idx}`}>
																<td>{row.cva}</td>
																<td>{row.fksMotorista}</td>
																<td><span className={`ctower-sug-v2-badge ${statusClass}`}>{row.statusTxt}</span></td>
																		<td className="ctower-sug-v2-cell-local">{row.placa}</td>
																		<td>{row.eta}</td>
																<td className="ctower-sug-v2-link" onClick={() => copiarLocalLatLong(row.localAtual)}>{row.localAtual}</td>
																<td>{row.distancia}</td>
															</tr>
														);
													})}
												</tbody>
											</table>
										</div>

										<div className="ctower-sug-v2-pagination">
											<div>Mostrando {topRowsFiltered.length === 0 ? 0 : topStart + 1} a {Math.min(topStart + topPageSize, topRowsFiltered.length)} de {topRowsFiltered.length} registros</div>
											<div className="ctower-sug-v2-pagination-controls">
												<button onClick={() => setVeiculosCategoriaPage((prev) => Math.max(1, prev - 1))} disabled={topPage <= 1}>‹</button>
												<span>{topPage}</span>
												<button onClick={() => setVeiculosCategoriaPage((prev) => Math.min(topTotalPages, prev + 1))} disabled={topPage >= topTotalPages}>›</button>
											</div>
											<div className="ctower-sug-v2-lines">Linhas por página: <select value="5" onChange={() => undefined}><option value="5">5</option></select></div>
										</div>
									</div>
										</div>

										<div className="ctower-sug-v2-top-side">
											<div className="ctower-sug-v2-actions top-right">
												<button className="ctower-sug-v2-btn secondary" onClick={openWindowConfigModal}>Configurar Janelas</button>
												<button className="ctower-sug-v2-btn success" onClick={sugerirVeiculos} disabled={loadingSugestoes}>{loadingSugestoes ? 'Buscando...' : 'Sugerir Veículos'}</button>
												<button className="ctower-sug-v2-btn secondary" onClick={() => void carregarSugestoesVeiculos({ abrirModal: false, mostrarAlertaSemDados: true })} disabled={loadingSugestoes}>Atualizar Sugestões</button>
											</div>

											<div className="ctower-sug-v2-card ctower-sug-v2-map-card">
												<div className="ctower-sug-v2-map-header">
													<div className="ctower-sug-v2-title">Mapa de Localização</div>
													<button className="ctower-sug-v2-btn dark" onClick={handleDownloadTemplate}>Exportar</button>
												</div>
												<div className="ctower-sug-v2-map-shell">
													<MapContainer center={[-23.55, -46.63]} zoom={9} style={{ height: '100%', width: '100%' }}>
														<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap contributors" />
														<ProgramacaoMapAutoFit points={mapMarkers.map((item) => ({ lat: item.lat, lng: item.lng }))} />
														{mapMarkers.map((item) => {
															const color = item.categoria === 'patio' ? '#22c55e' : item.categoria === 'transito' ? '#f59e0b' : '#3b82f6';
															return (
																<CircleMarker key={`${item.placa}-${item.lat}-${item.lng}`} center={[item.lat, item.lng]} radius={8} pathOptions={{ color, fillColor: color, fillOpacity: 0.85, weight: 2 }}>
																	<Popup>
																		<div>
																			<strong>{item.placa}</strong>
																			<div>{item.statusTxt}</div>
																			<div>{item.localAtual}</div>
																		</div>
																	</Popup>
																</CircleMarker>
															);
														})}
													</MapContainer>
												</div>
												<div className="ctower-sug-v2-map-legend">
													<span><i className="ctower-sug-v2-dot patio" /> No Pátio FKS</span>
													<span><i className="ctower-sug-v2-dot voltando" /> Voltando</span>
													<span><i className="ctower-sug-v2-dot transito" /> Em trânsito</span>
												</div>
											</div>
										</div>
									</div>

									<div className="ctower-sug-v2-card">
										<div className="ctower-sug-v2-section-head">
											<div className="ctower-sug-v2-title">Programação das Janelas</div>
										</div>

										<div className="ctower-sug-v2-programacao-actions">
											<div className="ctower-sug-v2-tab-group">
												<button className="active">Janelas Disponíveis</button>
												<button>Janelas Ocupadas</button>
												<button>Minhas Programações</button>
											</div>
											<div className="ctower-sug-v2-programacao-right">
												<input type="text" value={selectedDate ? selectedDate.toLocaleDateString('pt-BR') : ''} readOnly />
												<button className="ctower-sug-v2-mini">‹</button>
												<button className="ctower-sug-v2-mini">Hoje</button>
												<button className="ctower-sug-v2-mini">›</button>
												<div className="ctower-sug-v2-tab-group small">
													<button className="active">Tabela</button>
													<button>Linha do tempo</button>
													<button>Calendário</button>
												</div>
											</div>
										</div>

										<datalist id="ctower-cavalos-options">
											{veiculosVolks.map((v: any) => {
												const placa = getPlacaValue(v);
												if (!placa) return null;
												return <option key={placa} value={placa} />;
											})}
										</datalist>
										<datalist id="ctower-carretas-options">
											{carretasDisponiveis.map((c: any) => {
												const placa = c.placa || c.PLACA || '';
												if (!placa) return null;
												return <option key={placa} value={placa} />;
											})}
										</datalist>

										<div className="ctower-sug-v2-table-wrap">
											<table className="ctower-sug-v2-table programacao">
												<thead>
													<tr>
														<th style={{ width: 36 }}>
															<input
																type="checkbox"
																title="Selecionar todos"
																checked={programacaoRowsPaged.length > 0 && programacaoRowsPaged.every((r: any) => {
																	const rKey = `${dateToKey(selectedDate)}_${r.JANELA || ''}`;
																	const rStatusRaw = String(r.STATUS || '').trim().toUpperCase();
																	const rAprovado = approvedWindowKeys.has(rKey) || rStatusRaw === 'PROGRAMADO' || rStatusRaw === 'AGENDADA';
																	return rAprovado || selectedProgramacaoRows.has(rKey);
																})}
																onChange={(e) => {
																	const newSet = new Set(selectedProgramacaoRows);
																	programacaoRowsPaged.forEach((r: any) => {
																		const rKey = `${dateToKey(selectedDate)}_${r.JANELA || ''}`;
																		const rStatusRaw = String(r.STATUS || '').trim().toUpperCase();
																		const rAprovado = approvedWindowKeys.has(rKey) || rStatusRaw === 'PROGRAMADO' || rStatusRaw === 'AGENDADA';
																		if (!rAprovado) {
																			if (e.target.checked) newSet.add(rKey);
																			else newSet.delete(rKey);
																		}
																	});
																	setSelectedProgramacaoRows(newSet);
																}}
															/>
														</th>
														<th>Data</th>
														<th>Janela</th>
														<th>CVA</th>
														<th>Cavalo</th>
														<th>KM</th>
														<th>Carreta</th>
														<th>FKS / Motorista</th>
														<th>Status</th>
													</tr>
												</thead>
												<tbody>
													{programacaoRowsPaged.map((row: any, idx: number) => {
														const horario = row.JANELA || '';
														const horarioNorm = normalizeJanela(horario);
														const rowDate = selectedDate ? selectedDate.toLocaleDateString('pt-BR') : '-';
														const cavaloSelecionado = row.CAVALO || '';
														const vm = cavaloSelecionado ? monitoramentoPorPlaca.get(normalizePlaca(cavaloSelecionado)) : null;
														const motorista = row.FKS || vm?.motorista?.nome || vm?.motoristaNome || '-';
															const rowKey = `${dateToKey(selectedDate)}_${horario}`;
															const statusRaw = String(row.STATUS || '').trim().toUpperCase();
															const aprovado = approvedWindowKeys.has(rowKey) || statusRaw === 'PROGRAMADO' || statusRaw === 'AGENDADA';
															const statusLabel = aprovado ? 'Programado' : 'Pendente';
															const sugestaoInline = !cavaloSelecionado && horarioNorm ? sugestaoInlinePorJanela.get(horarioNorm) : undefined;
														return (
															<tr key={`${horario}-${idx}`}>
																<td style={{ textAlign: 'center' }}>
																	{aprovado ? (
																		<span style={{ color: '#16a34a', fontWeight: 700 }}>✓</span>
																	) : (
																		<input
																			type="checkbox"
																			checked={selectedProgramacaoRows.has(rowKey)}
																			onChange={(e) => {
																				const newSet = new Set(selectedProgramacaoRows);
																				if (e.target.checked) newSet.add(rowKey);
																				else newSet.delete(rowKey);
																				setSelectedProgramacaoRows(newSet);
																			}}
																		/>
																	)}
																</td>
																<td>{idx === 0 ? rowDate : ''}</td>
																<td>{horario || '-'}</td>
																<td style={{ fontWeight: 600, color: '#1d4ed8' }}>{row.CVA || '-'}</td>
																<td>
																	<input
																		className="ctower-sug-v2-input"
																		type="text"
																		list="ctower-cavalos-options"
																		value={cavaloSelecionado}
																		placeholder={sugestaoInline ? sugestaoInline.placa : 'Digite ou selecione a placa'}
																		onChange={(e) => {
																			upsertCampoProgramacaoLocal('CAVALO', (e.currentTarget.value || '').toUpperCase(), horario);
																		}}
																		onBlur={(e) => {
																			const novoValor = (e.currentTarget.value || '').trim().toUpperCase();
																			void salvarCampoProgramacao('CAVALO', novoValor, horario);
																		}}
																	/>
																	{sugestaoInline && (
																		<div style={{ fontSize: '0.72rem', color: '#2563eb', fontWeight: 600, marginTop: 2, display: 'flex', alignItems: 'center', gap: 4 }}>
																			<span style={{ background: '#dbeafe', borderRadius: 3, padding: '1px 5px' }}>↩ Sugerido</span>
																			<span>{sugestaoInline.placa}</span>
																		</div>
																	)}
																</td>
																<td style={{ textAlign: 'center', fontWeight: 600, color: sugestaoInline ? '#2563eb' : '#9ca3af', fontSize: '0.85rem' }}>
																	{cavaloSelecionado
																		? ((() => {
																			const vmCav = monitoramentoPorPlaca.get(normalizePlaca(cavaloSelecionado));
																			const latC = toCoordNumber(vmCav?.latitude ?? vmCav?.lat ?? vmCav?.localizacao?.lat);
																			const lngC = toCoordNumber(vmCav?.longitude ?? vmCav?.lng ?? vmCav?.localizacao?.lng);
																			if (latC != null && lngC != null) return `${Math.round(calcularDistancia(latC, lngC, COORDS_VW_SBC.lat, COORDS_VW_SBC.lng))} km`;
																			return '-';
																		})())
																		: sugestaoInline ? `${sugestaoInline.km} km` : '-'
																	}
																</td>
																<td>
																	<input
																		className="ctower-sug-v2-input"
																		type="text"
																		list="ctower-carretas-options"
																		value={row.CARRETA || ''}
																		placeholder="Digite ou selecione a placa"
																		onChange={(e) => {
																			upsertCampoProgramacaoLocal('CARRETA', (e.currentTarget.value || '').toUpperCase(), horario);
																		}}
																		onBlur={(e) => {
																			const novoValor = (e.currentTarget.value || '').trim().toUpperCase();
																			void salvarCampoProgramacao('CARRETA', novoValor, horario);
																		}}
																	/>
																</td>
																<td>
																	<input
																		className="ctower-sug-v2-input"
																		type="text"
																		value={motorista === '-' ? '' : motorista}
																		placeholder="Digite FKS ou motorista"
																		onChange={(e) => {
																			upsertCampoProgramacaoLocal('FKS', e.currentTarget.value || '', horario);
																		}}
																		onBlur={(e) => {
																			const novoValor = (e.currentTarget.value || '').trim();
																			void salvarCampoProgramacao('FKS', novoValor, horario);
																		}}
																	/>
																</td>
																<td><span className={`ctower-sug-v2-badge ${aprovado ? 'success' : 'warning'}`}>{statusLabel}</span></td>
															</tr>
														);
													})}
												</tbody>
											</table>
										</div>

										<div className="ctower-sug-v2-pagination">
											<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
												<span>Mostrando {programacaoMostrandoInicio} a {programacaoMostrandoFim} de {linhasProgramacao.length} registros</span>
												{selectedProgramacaoRows.size > 0 && (
													<button
														className="ctower-sug-v2-row-btn success"
														disabled={isApprovingSelected}
														onClick={async () => {
															if (!selectedDate) return;
															setIsApprovingSelected(true);
															try {
																const dateStr = selectedDate.toISOString().split('T')[0];
																const rowsToApprove = linhasProgramacao.filter((r: any) => {
																	const k = `${dateStr}_${r.JANELA || ''}`;
																	return selectedProgramacaoRows.has(k);
																});

																// Evita rajada no backend/Nucci: salva e aprova linha a linha
																for (const row of rowsToApprove) {
																	const horarioRow = row.JANELA || '';
																	const motoristaRow = row.FKS || '';

																	await salvarCampoProgramacao('CAVALO', String(row.CAVALO || '').trim().toUpperCase(), horarioRow);
																	await salvarCampoProgramacao('CARRETA', String(row.CARRETA || '').trim().toUpperCase(), horarioRow);
																	await salvarCampoProgramacao('FKS', String(motoristaRow).trim(), horarioRow);

																	const resp = await fetch('/api/controltower/programacao/aprovar-janela', {
																		method: 'POST',
																		headers: { 'Content-Type': 'application/json' },
																		body: JSON.stringify({ date: dateStr, horario: horarioRow }),
																	});

																	if (!resp.ok) {
																		throw new Error('Falha ao aprovar janela.');
																	}
																}

																const newApproved = new Set(approvedWindowKeys);
																selectedProgramacaoRows.forEach((k) => newApproved.add(k));
																setApprovedWindowKeys(newApproved);
																setSelectedProgramacaoRows(new Set());

																const [rowsProgAtualizados, rowsCtAtualizados] = await Promise.all([
																	fetchProgramacaoRowsForTable(dateStr),
																	fetchRowsForTable(dateStr)
																]);
																setProgramacaoRows(rowsProgAtualizados);
																setImportedRows(rowsCtAtualizados);
															} finally {
																setIsApprovingSelected(false);
															}
														}}
													>
														{isApprovingSelected ? 'Aprovando...' : `Aprovar selecionadas (${selectedProgramacaoRows.size})`}
													</button>
												)}
											</div>
											<div className="ctower-sug-v2-pagination-controls">
												<button onClick={() => setProgramacaoSugestoesPage((prev) => Math.max(1, prev - 1))} disabled={programacaoPage <= 1}>‹</button>
												<span>{programacaoPage}</span>
												<button onClick={() => setProgramacaoSugestoesPage((prev) => Math.min(programacaoTotalPages, prev + 1))} disabled={programacaoPage >= programacaoTotalPages}>›</button>
											</div>
											<div className="ctower-sug-v2-lines">
												Página {programacaoPage} de {programacaoTotalPages}
												&nbsp;|&nbsp; Linhas por página: <select value="7" onChange={() => undefined}><option value="7">7</option></select>
											</div>
										</div>
									</div>
								</div>
							);
						})()}
					</div>
				) : viewMode === 'programacao' ? (
					<div className="ctower-excel-table-wrapper">
						{showConfirm && (
							<div className="ctower-modal-bg">
								<div className="ctower-modal-box">
									<div className="ctower-modal-title">Deseja salvar os dados importados no banco de dados?</div>
									<div className="ctower-modal-actions">
										<button className="ctower-btn-sim" onClick={() => handleConfirm(true)} disabled={isSaving}>Sim</button>
										<button className="ctower-btn-nao" onClick={() => handleConfirm(false)} disabled={isSaving}>Não</button>
									</div>
									{isSaving && <div className="ctower-modal-loading">Salvando...</div>}
								</div>
							</div>
						)}

						{/* ===== KPI CARDS ===== */}
						{(() => {
							const rowsToRender = getMergedRows();
							const emTransito = rowsToRender.filter((r: any) => {
								const st = normalizarTexto(r['STATUS'] || '');
								return st.startsWith('em transito');
							}).length;
							const bolsaoVW = rowsToRender.filter((r: any) => {
								const st = (r['STATUS'] || '').toUpperCase();
								return st.includes('BOLSÃO VW') || st.includes('BOLSAO VW');
							}).length;
							const atrasadas = rowsToRender.filter((r: any) => {
								const st = (r['STATUS'] || '').toUpperCase();
								return st === 'DOCA' || st.includes('ATRASO');
							}).length;
							const aguardando = rowsToRender.filter((r: any) => {
								const st = (r['STATUS'] || '').toUpperCase();
								return st.includes('AGUARDANDO');
							}).length;
							const finalizadas = rowsToRender.filter((r: any) => {
								const st = (r['STATUS'] || '').toUpperCase();
								return st === 'FINALIZADO';
							}).length;
							const total = rowsToRender.length || 1;
							const tempoMedio = '4h 28m';

							return (
								<div className="ctower-prog-kpi-grid">
									<div className="ctower-prog-kpi-card">
										<span className="ctower-prog-kpi-icon">🚗</span>
										<div className="ctower-prog-kpi-content">
											<div className="ctower-prog-kpi-value">{emTransito}</div>
											<div className="ctower-prog-kpi-label">Em Trânsito</div>
											<div className="ctower-prog-kpi-pct">{Math.round((emTransito / total) * 100)}%</div>
										</div>
									</div>
									<div className="ctower-prog-kpi-card">
										<span className="ctower-prog-kpi-icon">🅥</span>
										<div className="ctower-prog-kpi-content">
											<div className="ctower-prog-kpi-value">{bolsaoVW}</div>
											<div className="ctower-prog-kpi-label">Bolsão VW</div>
											<div className="ctower-prog-kpi-pct">{Math.round((bolsaoVW / total) * 100)}%</div>
										</div>
									</div>
									<div className="ctower-prog-kpi-card">
										<span className="ctower-prog-kpi-icon">⏳</span>
										<div className="ctower-prog-kpi-content">
											<div className="ctower-prog-kpi-value">{aguardando}</div>
											<div className="ctower-prog-kpi-label">Aguardando Veículo</div>
											<div className="ctower-prog-kpi-pct">{Math.round((aguardando / total) * 100)}%</div>
										</div>
									</div>
								</div>
							);
						})()}

						{/* ===== TOOLBAR COM FILTROS E AÇÕES ===== */}
						<div className="ctower-prog-toolbar">
							<div className="ctower-prog-toolbar-right">
								<button
									className="ctower-btn-importar"
									onClick={handleAtualizarStatusPorMonitoramento}
									style={{ background: 'linear-gradient(90deg, #f59e0b 60%, #d97706 100%)' }}
									title="Atualiza Status das linhas com CAVALO baseado na posição atual do veículo (DOCA/DOCA SJP, BOLSÃO VW/BOLSÃO SJP, EM TRANSITO SBC/SJP)"
								>
									🔄 Atualizar Status
								</button>
								<button
									className="ctower-btn-importar"
									onClick={handleSincronizarNucciManual}
									disabled={isSyncingNucciManual}
									style={{ background: 'linear-gradient(90deg, #0ea5e9 60%, #0284c7 100%)', opacity: isSyncingNucciManual ? 0.7 : 1 }}
									title="Busca contrato, CTE/manifesto e motorista na Nucci apenas quando solicitado"
								>
									{isSyncingNucciManual ? '🔄 Atualizando Nucci...' : '🛠️ Atualizar Dados Nucci'}
								</button>
								<button
									className="ctower-btn-importar"
									onClick={() => setShowCanceledRows(prev => !prev)}
									style={{ background: 'linear-gradient(90deg, #6b7280 60%, #4b5563 100%)' }}
								>
									{showCanceledRows ? '🫣 Ocultar Cancelados' : '👁️ Mostrar Cancelados'}
								</button>
								<button className="ctower-btn-importar" onClick={handleDownloadTemplate} style={{ background: "linear-gradient(90deg, #3b82f6 60%, #1d4ed8 100%)" }}>📥 Baixar Modelo</button>
								<button className="ctower-btn-importar" onClick={handleImportClick}>Importar Dados Antigos</button>
								<button className="ctower-btn-importar" style={{ background: "linear-gradient(90deg, #10b981 60%, #059669 100%)" }}>📤 Exportar</button>
								<input
									type="file"
									accept=".xlsx,.xls"
									ref={fileInputRef}
									style={{ display: 'none' }}
									onChange={handleFileChange}
								/>
							</div>
						</div>

						<table className="ctower-excel-table ctower-prog-table">
							<thead>
								<tr>
									{excelColumns.map((col, idx) => (
										<th key={idx}>{col}</th>
									))}
								</tr>
							</thead>
						<tbody>
						{(() => {
							const rowsToRender = getMergedRows();

							const parseWindowMinutes = (value: any): number => {
								const formatted = formatExcelTime(value);
								const match = String(formatted || '').match(/^(\d{1,2}):(\d{2})/);
								if (!match) return Number.MAX_SAFE_INTEGER;
								const h = Number(match[1]);
								const m = Number(match[2]);
								if (Number.isNaN(h) || Number.isNaN(m)) return Number.MAX_SAFE_INTEGER;
								return (h * 60) + m;
							};

							const isVoltandoMonitoramento = (vm: any) => {
								const sentido = normalizarTexto(vm?.sentidoRota || vm?.ds_sentido_rota || '');
								return sentido === 'volta' || sentido.includes('volt');
							};

							const isVolksMonitoramento = (vm: any) => {
								const op = normalizarTexto(vm?.operacao || vm?.ds_operacao || '');
								return op.includes('volks');
							};

							const mapearVeiculoComKmPrevisao = (vm: any) => {
								const lat = toCoordNumber(vm?.latitude ?? vm?.lat ?? vm?.localizacao?.lat ?? vm?.localizacao?.latitude);
								const lng = toCoordNumber(vm?.longitude ?? vm?.lng ?? vm?.localizacao?.lng ?? vm?.localizacao?.longitude);
								const placa = String(vm?.nm_placa || vm?.placa || vm?.placaCavalo || '').trim().toUpperCase();
								if (!placa || lat == null || lng == null) return null;
								const km = Math.round(calcularDistancia(lat, lng, COORDS_VW_SBC.lat, COORDS_VW_SBC.lng));
								const motorista = String(vm?.motorista || '').trim();
								return { placa, km, motorista };
							};

							const hasProblemaRastreadorPrevisao = (vm: any): boolean => {
								if (vm?.problemaRastreador === true || vm?.problema_rastreador === true) return true;
								const statusCode = normalizarTexto(vm?.status || vm?.ds_status || vm?.status_monitoramento || '');
								if (statusCode.includes('problema_rastreador') || statusCode.includes('problema rastreador')) return true;
								const rastreador = normalizarTexto(vm?.rastreador || vm?.ds_rastreador || vm?.tipo_rastreador || vm?.status_rastreador || '');
								const alerta = normalizarTexto(vm?.alerta || vm?.alertaRastreador || vm?.observacao || vm?.observacoes || vm?.motivo || '');
								const texto = `${rastreador} ${statusCode} ${alerta}`;
								const padroesProblema = ['sem rastreador', 'rastreador offline', 'gps offline', 'rastreador inoperante', 'rastreador indisponivel', 'defeito rastreador', 'rastreador com problema', 'problema rastreador'];
								return padroesProblema.some(p => texto.includes(p));
							};

							const isEmPatioFksPrevisao = (vm: any): boolean => {
								const pol = normalizarTexto(vm?.poligono || vm?.nm_poligono_atual || vm?.ultimoPoligono || vm?.ultimo_poligono || vm?.poligonoAtual || '');
								return pol.includes('patio fks') || pol.includes('pateo fks');
							};

							let candidatosPrevisao = (veiculosMonitoramento || [])
								.filter((vm: any) => isVoltandoMonitoramento(vm) && isVolksMonitoramento(vm) && !hasProblemaRastreadorPrevisao(vm) && !isEmPatioFksPrevisao(vm))
								.map(mapearVeiculoComKmPrevisao)
								.filter(Boolean)
								.sort((a: any, b: any) => a.km - b.km);

							if (candidatosPrevisao.length === 0) {
								candidatosPrevisao = (veiculosMonitoramento || [])
									.filter((vm: any) => isVoltandoMonitoramento(vm) && !hasProblemaRastreadorPrevisao(vm) && !isEmPatioFksPrevisao(vm))
									.map(mapearVeiculoComKmPrevisao)
									.filter(Boolean)
									.sort((a: any, b: any) => a.km - b.km);
							}

							const placasPrevisaoSet = new Set<string>();
							const candidatosLivres = candidatosPrevisao.filter((item: any) => {
								const placaKey = normalizePlaca(item.placa);
								if (!placaKey || placasPrevisaoSet.has(placaKey)) return false;
								placasPrevisaoSet.add(placaKey);
								return true;
							});

							const linhasAguardandoSemCavalo = rowsToRender
								.map((rowData: any, rowIdx: number) => ({ rowData, rowIdx }))
								.filter(({ rowData }) => {
									const statusNorm = normalizarTexto(rowData?.STATUS || 'Aguardando veículo');
									const cavalo = String(rowData?.CAVALO || '').trim();
									return (statusNorm.includes('aguardando') || statusNorm.includes('programado') || statusNorm.includes('agendada')) && !cavalo;
								})
								.sort((a, b) => parseWindowMinutes(a.rowData?.JANELA) - parseWindowMinutes(b.rowData?.JANELA));

							const previsaoPorLinha = new Map<number, { placa: string; km: number; motorista: string }>();
							linhasAguardandoSemCavalo.forEach((item, idx) => {
								const candidato = candidatosLivres[idx];
								if (!candidato) return;
								previsaoPorLinha.set(item.rowIdx, candidato);
							});

							const rowsToRenderComPrevisao = rowsToRender.map((rowData: any, rowIdx: number) => {
								const previsaoLinha = previsaoPorLinha.get(rowIdx);
								if (!previsaoLinha) return rowData;

								const statusOriginal = normalizarTexto(rowData?.STATUS || 'Aguardando veículo');
								const cavaloOriginal = String(rowData?.CAVALO || '').trim();
								const statusElegivel = statusOriginal.includes('aguardando') || statusOriginal.includes('programado') || statusOriginal.includes('agendada');
								if (!statusElegivel || cavaloOriginal) return rowData;

								return {
									...rowData,
									STATUS: 'Previsto',
									CAVALO: previsaoLinha.placa,
									_previsaoKm: previsaoLinha.km,
									_previsaoMotorista: previsaoLinha.motorista
								};
							});
							
							if (rowsToRenderComPrevisao.length > 0) {
								// Renderizar linhas mescladas (template + dados do banco) COM EDIÇÃO
									return rowsToRenderComPrevisao.map((rowData, rowIdx) => {
									const previsaoLinha = previsaoPorLinha.get(rowIdx);
									// cor condicional da linha
									const status = (rowData['STATUS'] || 'Aguardando veículo').toString();
									const statusNormalizado = normalizarTexto(status);
									const statusUpper = status.toUpperCase();
									const isCancelada = statusUpper === 'CANCELADA';
									if (!showCanceledRows && isCancelada) return null;

									// Detectar problema de rastreador para esta linha
									// Usa apenas flags explícitas — evita falso-positivo por comunicação desatualizada
									const cavaloPlaca = String(rowData['CAVALO'] || '').trim();
									const vmRow = cavaloPlaca
										? veiculosMonitoramento.find((v: any) => normalizePlaca(getPlacaValue(v)) === normalizePlaca(cavaloPlaca))
										: null;
									const hasProblemaRastreadorRow = (() => {
										if (!vmRow) return false;
										if (vmRow?.problemaRastreador === true || vmRow?.problema_rastreador === true) return true;
										const statusCode = normalizarTexto(vmRow.status || vmRow.ds_status || vmRow.status_monitoramento || '');
										if (statusCode === 'problema_rastreador' || statusCode.includes('problema_rastreador') || statusCode.includes('problema rastreador')) return true;
										const rastreador = normalizarTexto(vmRow.rastreador || vmRow.ds_rastreador || vmRow.tipo_rastreador || vmRow.status_rastreador || '');
										const alerta = normalizarTexto(vmRow.alerta || vmRow.alertaRastreador || vmRow.observacao || vmRow.observacoes || vmRow.motivo || '');
										const texto = `${rastreador} ${statusCode} ${alerta}`;
										const padroesProblema = ['problema rastreador','rastreador com problema','sem rastreador','rastreador offline','gps offline','rastreador inoperante','rastreador indisponivel','defeito rastreador'];
										return padroesProblema.some(p => texto.includes(p));
									})();
									let rowClass = '';
									if (normalizarTexto(statusUpper).startsWith('em transito')) rowClass = 'ctower-row-transito';
									else if (statusUpper === 'CANCELADA') rowClass = 'ctower-row-cancelada';
									else if (statusUpper === 'FINALIZADO') rowClass = 'ctower-row-finalizado';
									else if (statusUpper.includes('DOCA')) rowClass = 'ctower-row-doca';
									else if (statusUpper.includes('BOLSÃO VW') || statusUpper.includes('BOLSAO VW') || statusUpper.includes('BOLSÃO SJP') || statusUpper.includes('BOLSAO SJP')) rowClass = 'ctower-row-bolsaovw';
									
									const statusOptions = [
										'Aguardando veículo',
										'Previsto',
										'EM TRANSITO SBC',
										'EM TRANSITO SJP',
										'DOCA',
										'DOCA SJP',
										'BOLSÃO VW',
										'BOLSÃO SJP',
										'CANCELADA',
										'FINALIZADO'
									];
									const tipoOptions = ['Free', 'Agregado'];
									const horario = rowData['JANELA'] || '';
									
									// Feedback de salvamento para esta linha
									let saveIndicator: React.ReactElement | null = null;
									if (saveStatus && saveStatus.rowIdx === rowIdx) {
										if (saveStatus.status === 'saving') {
											saveIndicator = <span style={{ fontSize: '0.8rem', color: '#999', marginLeft: 8 }}>Salvando...</span>;
										} else if (saveStatus.status === 'success') {
											saveIndicator = <span style={{ fontSize: '0.8rem', color: '#4CAF50', marginLeft: 8 }}>✓ Salvo</span>;
										} else if (saveStatus.status === 'error') {
											saveIndicator = <span style={{ fontSize: '0.8rem', color: '#f44336', marginLeft: 8 }}>✗ Erro</span>;
										}
									}
									
									// Função para salvar automaticamente
									const handleAutoSave = async (field: string, newValue: string) => {
										const dataToSave = {
											field,
											value: newValue,
											date: selectedDate ? selectedDate.toISOString().split('T')[0] : '',
											horario
										};
										
										setSaveStatus({ rowIdx, status: 'saving' });
										try {
											const response = await fetch('/api/controltower/salvar', {
												method: 'POST',
												headers: { 'Content-Type': 'application/json' },
												body: JSON.stringify(dataToSave)
											});
											if (response.ok) {
												setSaveStatus({ rowIdx, status: 'success' });
											// Atualizar imediatamente o estado local, buscando pela JANELA E DATA
											const currentDateStr = selectedDate ? selectedDate.toISOString().split('T')[0] : '';
											setImportedRows(prevRows => {
												// Buscar se já existe uma linha com esta JANELA e ESTA DATA
												const existingIndex = prevRows.findIndex(row => {
													const rowDate = row.DATA && typeof row.DATA === 'string' && row.DATA.includes('T') ? row.DATA.split('T')[0] : row.DATA;
													return row.JANELA === horario && rowDate === currentDateStr;
												});
												
												if (existingIndex >= 0) {
													// Se existe, atualizar
													const newRows = [...prevRows];
													newRows[existingIndex] = {
														...newRows[existingIndex],
														[field]: newValue
													};
													return newRows;
												} else {
													// Se não existe, criar nova linha
													const newRow = {
														JANELA: horario,
														DATA: currentDateStr,
														STATUS: 'Aguardando veículo',
														[field]: newValue
													};
													return [...prevRows, newRow];
												}
												});
												setTimeout(() => setSaveStatus(null), 2000);
											} else {
												setSaveStatus({ rowIdx, status: 'error' });
												setTimeout(() => setSaveStatus(null), 3000);
											}
										} catch (err) {
											console.error('Erro ao salvar automaticamente:', err);
											setSaveStatus({ rowIdx, status: 'error' });
											setTimeout(() => setSaveStatus(null), 3000);
										}
									};
									
									return (
										<tr key={rowIdx} className={rowClass}>
											{excelColumns.map((col, colIdx) => {
												let value = rowData[col] || '';
												let editable = false;
												
												if (col === 'DATA' && value) {
													if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
														const [y, m, d] = value.split(/[T -]/);
														value = `${d}/${m}/${y}`;
													} else {
														value = formatExcelDate(value);
													}
												}
												
												if (col === 'DATA' && selectedDate && !value) {
													value = selectedDate.toLocaleDateString('pt-BR');
												}

												if (col === 'JANELA' || col === 'CHEGADA' || col === 'SAÍDA') {
													value = formatExcelTime(value);
												}
												
												// Preencher CAVALO com sugestão, se disponível
												if (col === 'CAVALO' && !value) {
													value = (previsaoLinha?.placa || veiculosSugeridos[rowIdx] || '').toString();
												}
												
												if (col !== 'DATA' && col !== 'JANELA') editable = true;
												
												return (
													<td key={colIdx}>
														{col === 'STATUS' ? (
															<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
																<select
																	value={status}
																	onChange={e => handleAutoSave('STATUS', e.target.value)}
																	className={`ctower-prog-badge ctower-prog-badge-${(() => {
																		const st = status.toUpperCase();
																		if (st.includes('AGUARDANDO')) return 'azul';
																		if (normalizarTexto(st).startsWith('em transito')) return 'verde';
																		if (st.includes('DOCA')) return 'amarelo';
																		if (st.includes('BOLSÃO VW') || st.includes('BOLSAO VW') || st.includes('BOLSÃO SJP') || st.includes('BOLSAO SJP')) return 'roxo';
																		if (st === 'CANCELADA') return 'vermelho';
																		if (st === 'FINALIZADO') return 'cinza';
																		return 'azul';
																	})()} ctower-status-select`}
																>
																	{statusOptions.map(opt => (
																		<option key={opt} value={opt}>{opt}</option>
																	))}
																</select>
																{saveIndicator}
															</div>
														) : col === 'TIPO' ? (
															isCancelada ? (
																<span>{value || 'Free'}</span>
															) : (
																<select
																	value={value || 'Free'}
																	onChange={e => handleAutoSave('TIPO', e.target.value)}
																	style={{
																		width: '100%',
																		border: 'none',
																		background: 'transparent',
																		textAlign: 'center',
																		fontSize: '12px',
																		fontWeight: 600,
																		padding: '4px 8px'
																	}}
																>
																	{tipoOptions.map(opt => (
																		<option key={opt} value={opt}>{opt}</option>
																	))}
																</select>
															)
														) : col === 'CAVALO' ? (
															isCancelada ? (
																<span>
																	{value}
																	{hasProblemaRastreadorRow && value && (
																		<span title="Veículo sem rastreador ou rastreador com problema" style={{ marginLeft: 4, color: '#f59e0b', fontSize: '13px', cursor: 'default' }}>⚠️</span>
																	)}
																</span>
															) : (
														   <div 
															   style={{ position: 'relative', width: '100%' }}
															   onMouseDown={(e) => e.stopPropagation()}
															   onClick={(e) => e.stopPropagation()}
														   >
															   {hasProblemaRastreadorRow && value && (
																   <span
																	   title="Veículo sem rastreador ou rastreador com problema"
																	   style={{ position: 'absolute', top: '-6px', right: '-4px', fontSize: '12px', zIndex: 1, cursor: 'default', lineHeight: 1 }}
																   >⚠️</span>
															   )}
															   <CreatableSelect
																   value={value ? { value: value, label: value } : null}
																   onChange={(option: any) => {
																	   handleAutoSave('CAVALO', option ? option.value : '');
																   }}
																   options={(() => {
																	   const opts = veiculosVolks
																		   .map((v, idx) => {
																			   const placa = v.nm_placa || v.placa || v.placaCavalo || '';
																			   return { value: placa, label: placa };
																		   })
																		   .filter(opt => opt.value && opt.value.trim() !== '');
																	   return opts;
																   })()}
																   placeholder="Cavalos"
																   isClearable
																   isSearchable
																   onMenuOpen={() => {
																	   setHoveredCavalo(null);
																   }}
																   menuPlacement="auto"
																   menuPortalTarget={menuPortalTarget || undefined}
																   menuPosition="fixed"
																   menuShouldBlockScroll={false}
																   components={{
																	   DropdownIndicator: ({ innerProps }: any) => {
																		   return (
																			   <div {...innerProps} style={{ display: 'flex', alignItems: 'center', padding: '0 6px' }}>
																				   <svg height="20" width="20" viewBox="0 0 20 20" style={{ display: 'inline-block', fill: 'currentColor', lineHeight: 1, stroke: 'currentColor', strokeWidth: 0 }}>
																					   <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
																				   </svg>
																			   </div>
																		   );
																	   }
																   }}
																   styles={{
																	   container: (base: any) => ({
																		   ...base,
																		minWidth: 170,
																		width: '100%',
																		maxWidth: 'none'
																	   }),
																	   control: (base: any, state: any) => ({
																		   ...base,
																		   border: '1px solid #ddd',
																		   background: '#fff',
																		   boxShadow: 'none',
																		   minHeight: '34px',
																		   cursor: 'pointer',
																		   '&:hover': { borderColor: '#aaa' },
																		   pointerEvents: 'auto'
																	   }),
																	   singleValue: (base: any) => ({
																		   ...base,
																		   textAlign: 'center',
																		fontSize: '12px',
																		   fontWeight: 600,
																		color: '#333',
																		overflow: 'visible',
																		textOverflow: 'clip',
																		maxWidth: '100%'
																	   }),
																	   placeholder: (base: any) => ({
																		   ...base,
																		   textAlign: 'center',
																		fontSize: '12px',
																		   color: '#999'
																	   }),
																	   input: (base: any) => ({
																		   ...base,
																		   textAlign: 'center',
																		fontSize: '12px'
																	   }),
																	   menu: (base: any) => ({
																		   ...base,
																		   zIndex: 99999,
																		fontSize: '12px',
																		   position: 'absolute',
																		   width: '100%',
																		   backgroundColor: 'white',
																		   boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
																		   border: '1px solid #ddd',
																		   borderRadius: '4px',
																		   marginTop: '2px'
																	   }),
																	   menuList: (base: any) => ({
																		   ...base,
																		   maxHeight: '200px',
																		   overflowY: 'auto',
																		   padding: '4px 0'
																	   }),
																	   menuPortal: (base: any) => ({
																		   ...base,
																		   zIndex: 99999
																	   }),
																	   option: (base: any, state: any) => ({
																		   ...base,
																		   textAlign: 'center',
																		fontSize: '12px',
																		   fontWeight: 600,
																		   backgroundColor: state.isFocused ? '#e3f2fd' : state.isSelected ? '#2196f3' : 'white',
																		   color: state.isSelected ? 'white' : '#333',
																		   cursor: 'pointer'
																	   })
																   }}
															   />
														   </div>
																)
													) : col === 'CARRETA' ? (
																isCancelada ? (
																	<span>{value}</span>
																) : (
															   <div 
															   style={{ position: 'relative', width: '100%' }}
															   onMouseDown={(e) => e.stopPropagation()}
															   onClick={(e) => e.stopPropagation()}
														   >
														   <CreatableSelect
															   value={value ? { value: value, label: value } : null}
															   onChange={(option: any) => {
																   handleAutoSave('CARRETA', option ? option.value : '');
															   }}
															   options={carretasDisponiveis.map((c, idx) => {
																   const placa = c.placa || c.PLACA || '';
																   const tipo = c.tipo || c.tipo_carreta || '';
																   return { value: placa, label: tipo ? `${placa} - ${tipo}` : placa };
															   })}
															   placeholder="Carretas"
															   isClearable
															   isSearchable
															   menuPlacement="auto"
															   menuPortalTarget={menuPortalTarget || undefined}
															   menuPosition="fixed"
															   menuShouldBlockScroll={false}
															   styles={{
																   container: (base: any) => ({
																	   ...base,
																	minWidth: 170,
																	width: '100%',
																	maxWidth: 'none'
																   }),
																   control: (base: any) => ({
																	   ...base,
																	   border: '1px solid #ddd',
																	   background: '#fff',
																	   boxShadow: 'none',
																	   minHeight: '34px',
																	   cursor: 'pointer',
																	   '&:hover': { borderColor: '#aaa' }
																   }),
																   singleValue: (base: any) => ({
																	   ...base,
																	   textAlign: 'center',
																	fontSize: '12px',
																	   fontWeight: 600,
																	color: '#333',
																	overflow: 'visible',
																	textOverflow: 'clip',
																	maxWidth: '100%'
																   }),
																   placeholder: (base: any) => ({
																	   ...base,
																	   textAlign: 'center',
																	fontSize: '12px',
																	   color: '#999'
																   }),
																   input: (base: any) => ({
																	   ...base,
																	   textAlign: 'center',
																	fontSize: '12px'
																   }),
																   menu: (base: any) => ({
																	   ...base,
																	   zIndex: 99999,
																	fontSize: '12px'
																   }),
																   menuPortal: (base: any) => ({
																	   ...base,
																	   zIndex: 99999
																   }),
																   option: (base: any, state: any) => ({
																	   ...base,
																	   textAlign: 'center',
																	fontSize: '12px',
																	   fontWeight: 600,
																	   backgroundColor: state.isFocused ? '#e3f2fd' : state.isSelected ? '#2196f3' : 'white',
																	   color: state.isSelected ? 'white' : '#333',
																	   cursor: 'pointer'
																   })
															   }}
															   />
														   </div>
															)
													) : (editable && (!isCancelada || col === 'STATUS')) ? (
															<input
																type="text"
																defaultValue={value}
																onBlur={e => handleAutoSave(col, e.target.value)}
																style={{ width: '100%', border: 'none', background: 'transparent', textAlign: 'center' }}
															/>
														) : (
															<span>{value}</span>
														)}
													</td>
												);
											})}
										</tr>
									);
								});
							} else {
								// Renderizar linhas padrão quando não há dados e não é data recente
								const horarios = getConfiguredHorarios(dateToKey(selectedDate));
								if (horarios.length === 0) {
									return (
										<tr>
											<td colSpan={excelColumns.length} style={{ textAlign: 'center', padding: '14px' }}>
												Nenhuma janela cadastrada para esta data. Use o botão "Configurar Janelas".
											</td>
										</tr>
									);
								}
								return horarios.map((horario, rowIdx) => {
									// Define a cor da linha conforme o status
									let status = rowStatuses[rowIdx] || 'Aguardando veículo';
												const isCancelada = (status || '').toUpperCase() === 'CANCELADA';
									if (!showCanceledRows && isCancelada) return null;
									let rowClass = '';
									if (normalizarTexto(status).startsWith('em transito')) rowClass = 'ctower-row-transito';
									else if (status === 'CANCELADA') rowClass = 'ctower-row-cancelada';
									else if (status === 'FINALIZADO') rowClass = 'ctower-row-finalizado';
									else if (status.includes('DOCA')) rowClass = 'ctower-row-doca';
									else if (status.includes('BOLSÃO VW') || status.includes('BOLSAO VW') || status.includes('BOLSÃO SJP') || status.includes('BOLSAO SJP')) rowClass = 'ctower-row-bolsaovw';
									const statusOptions = [
										'Aguardando veículo',
										'EM TRANSITO SBC',
										'EM TRANSITO SJP',
										'DOCA',
										'DOCA SJP',
										'BOLSÃO VW',
										'BOLSÃO SJP',
										'CANCELADA',
										'FINALIZADO'
									];
									const tipoOptions = ['Free', 'Agregado'];
									
									// Feedback de salvamento para esta linha
									let saveIndicator: React.ReactElement | null = null;
									if (saveStatus && saveStatus.rowIdx === rowIdx) {
										if (saveStatus.status === 'saving') {
											saveIndicator = <span style={{ fontSize: '0.8rem', color: '#999', marginLeft: 8 }}>Salvando...</span>;
										} else if (saveStatus.status === 'success') {
											saveIndicator = <span style={{ fontSize: '0.8rem', color: '#4CAF50', marginLeft: 8 }}>✓ Salvo</span>;
										} else if (saveStatus.status === 'error') {
											saveIndicator = <span style={{ fontSize: '0.8rem', color: '#f44336', marginLeft: 8 }}>✗ Erro</span>;
										}
									}

									const statusNormalizado = String(status || '')
										.trim()
										.toLowerCase()
										.normalize('NFD')
										.replace(/[\u0300-\u036f]/g, '');
									const isAguardando = statusNormalizado.includes('aguardando');

									const mapearVeiculoComKm = (vm: any) => {
										const lat = toCoordNumber(vm.latitude ?? vm.lat ?? vm.localizacao?.lat ?? vm.localizacao?.latitude);
										const lng = toCoordNumber(vm.longitude ?? vm.lng ?? vm.localizacao?.lng ?? vm.localizacao?.longitude);
										if (lat == null || lng == null) return null;
										const placa = vm.nm_placa || vm.placa || vm.placaCavalo || '';
										if (!placa) return null;
										const motorista = vm.motorista || '';
										const km = Math.round(calcularDistancia(lat, lng, COORDS_VW_SBC.lat, COORDS_VW_SBC.lng));
										return { placa, motorista, km };
									};

									const isVoltando = (vm: any) => {
										const sentido = vm.sentidoRota || vm.ds_sentido_rota || '';
										const sentidoNormalizado = String(sentido).toLowerCase();
										return sentidoNormalizado === 'volta' || sentidoNormalizado.includes('volt');
									};

									const isVolks = (vm: any) => {
										const op = vm.operacao || vm.ds_operacao || '';
										return typeof op === 'string' && op.toLowerCase().includes('volks');
									};

									// Veiculos da operacao Volks que estao voltando, ordenados por km de chegada em SBC
									let veiculosVoltandoProximos: any[] = [];
									if (isAguardando) {
										veiculosVoltandoProximos = veiculosMonitoramento
											.filter((vm: any) => isVoltando(vm) && isVolks(vm))
											.map(mapearVeiculoComKm)
											.filter(Boolean)
											.sort((a: any, b: any) => a.km - b.km);

										// Fallback: se operacao vier vazia no monitoramento, usa voltando independentemente da operacao
										if (veiculosVoltandoProximos.length === 0) {
											veiculosVoltandoProximos = veiculosMonitoramento
												.filter((vm: any) => isVoltando(vm))
												.map(mapearVeiculoComKm)
												.filter(Boolean)
												.sort((a: any, b: any) => a.km - b.km);
										}
									}
									const veiculosVoltandoTop = veiculosVoltandoProximos.slice(0, 5);
									const placasVoltandoTop = new Set(veiculosVoltandoTop.map((v: any) => v.placa));
									
									return (
										<tr key={rowIdx} className={rowClass}>
											{excelColumns.map((col, colIdx) => {
												let value = '';
												let editable = false;
												if (col === 'JANELA') value = horario;
												if (col === 'STATUS') value = status;
												if (col === 'DATA' && selectedDate) {
													value = selectedDate.toLocaleDateString('pt-BR');
												}
												// Preencher CAVALO com sugestão, se disponível
												// Dropdown pesquisável para Cavalo
												if (col === 'CAVALO') {
													editable = true;
													value = veiculosSugeridos[rowIdx] || '';
												}
												if (col !== 'DATA' && col !== 'JANELA') editable = true;

												// Função para salvar automaticamente
												const handleAutoSave = async (field: string, newValue: string) => {
													const dataToSave = {
														field,
														value: newValue,
														date: selectedDate ? selectedDate.toISOString().split('T')[0] : '',
														horario
													};
													
													setSaveStatus({ rowIdx, status: 'saving' });
													
													try {
														const response = await fetch('/api/controltower/salvar', {
															method: 'POST',
															headers: { 'Content-Type': 'application/json' },
															body: JSON.stringify(dataToSave)
														});
														
														if (response.ok) {
															setSaveStatus({ rowIdx, status: 'success' });														
														// Atualizar imediatamente o estado local, buscando pela JANELA E DATA
														const currentDateStr = selectedDate ? selectedDate.toISOString().split('T')[0] : '';
														setImportedRows(prevRows => {
															// Buscar se já existe uma linha com esta JANELA e ESTA DATA
															const existingIndex = prevRows.findIndex(row => {
																const rowDate = row.DATA && typeof row.DATA === 'string' && row.DATA.includes('T') ? row.DATA.split('T')[0] : row.DATA;
																return row.JANELA === horario && rowDate === currentDateStr;
															});
															
															if (existingIndex >= 0) {
																// Se existe, atualizar
																const newRows = [...prevRows];
																newRows[existingIndex] = {
																	...newRows[existingIndex],
																	[field]: newValue
																};
																return newRows;
															} else {
																// Se não existe, criar nova linha
																const newRow = {
																	JANELA: horario,
																	DATA: currentDateStr,
																	STATUS: 'Aguardando veículo',
																	[field]: newValue
																};
																return [...prevRows, newRow];
															}
														});
														setTimeout(() => setSaveStatus(null), 2000);
														} else {
															setSaveStatus({ rowIdx, status: 'error' });
															setTimeout(() => setSaveStatus(null), 3000);
														}
													} catch (err) {
														console.error('Erro ao salvar automaticamente:', err);
														setSaveStatus({ rowIdx, status: 'error' });
														setTimeout(() => setSaveStatus(null), 3000);
													}
												};

												return (
													<td key={colIdx}>
														{col === 'STATUS' ? (
															<div style={{ position: 'relative' }}>
																<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
																<select
																	value={status}
																	onChange={e => {
																		const newStatuses = [...rowStatuses];
																		newStatuses[rowIdx] = e.target.value;
																		setRowStatuses(newStatuses);
																		handleAutoSave('STATUS', e.target.value);
																	}}
																	style={{
																		width: '100%',
																		border: 'none',
																		background: 'transparent',
																		textAlign: 'center',
																		fontSize: '12px',
																		fontWeight: 600,
																		whiteSpace: 'normal',
																		overflow: 'visible',
																		padding: '4px 6px'
																	}}
																>
																	{statusOptions.map(opt => (
																		<option
																			key={opt}
																			value={opt}
																			style={{
																				whiteSpace: 'normal',
																				fontSize: '12px',
																				fontWeight: 600,
																				padding: '4px 8px',
																				minWidth: 180
																			}}
																		>{opt}</option>
																	))}
																</select>
																{colIdx === 0 && saveIndicator}
																</div>
																{isAguardando && veiculosVoltandoProximos.length > 0 && (
																	<div style={{ textAlign: 'center', marginTop: 3 }}>
																		<button
																			type="button"
																			className="ctower-btn-voltando"
																			onClick={() => setShowProximosRowIdx(showProximosRowIdx === rowIdx ? null : rowIdx)}
																		>
																			Ver proximos ({veiculosVoltandoProximos.length})
																		</button>
																		{showProximosRowIdx === rowIdx && (
																			<div className="ctower-proximos-popup">
																				<div className="ctower-proximos-title">Veiculos voltando mais proximos</div>
																				{veiculosVoltandoProximos.map((vp: any, idx: number) => (
																					<div key={`${vp.placa}-${idx}`} className="ctower-proximos-item">
																						<span className="ctower-proximos-rank">#{idx + 1}</span>
																						<span className="ctower-proximos-placa">{vp.placa}</span>
																						{vp.motorista ? <span className="ctower-proximos-motorista">{vp.motorista}</span> : null}
																						<span className="ctower-proximos-km">~{vp.km} km</span>
																					</div>
																				))}
																			</div>
																		)}
																	</div>
																)}
															</div>
														) : col === 'TIPO' ? (
															isCancelada ? (
																<span>{value || 'Free'}</span>
															) : (
																<select
																	defaultValue={value}
																	onChange={e => handleAutoSave('TIPO', e.target.value)}
																	style={{
																		width: '100%',
																		border: 'none',
																		background: 'transparent',
																		textAlign: 'center',
																		fontSize: '12px',
																		fontWeight: 600,
																		padding: '4px 8px'
																	}}
																>
																	{tipoOptions.map(opt => (
																		<option key={opt} value={opt}>{opt}</option>
																	))}
																</select>
															)
														) : col === 'CAVALO' ? (
															isCancelada ? (
																<span>{value}</span>
															) : (
																<div>
																	<select
																		value={value}
																		onChange={e => {
																			handleAutoSave('CAVALO', e.target.value);
																		}}
																		style={{
																			width: '100%',
																			border: 'none',
																			background: 'transparent',
																			textAlign: 'center',
																			fontSize: '12px',
																			fontWeight: 500,
																			padding: '4px 8px',
																			cursor: 'pointer'
																		}}
																	>
																		<option value="">— Selecione veículo —</option>
																		{isAguardando && veiculosVoltandoTop.length > 0 && (
																			<optgroup label="Mais próximos (Volks voltando)">
																				{veiculosVoltandoTop.map((vp: any, idx: number) => (
																					<option key={`${vp.placa}-prox-${idx}`} value={vp.placa}>
																						{`${vp.placa} (~${vp.km} km)`}
																					</option>
																				))}
																			</optgroup>
																		)}
																		{veiculosVolks
																			.filter((v: any) => {
																				const placa = v.nm_placa || v.placa || v.placaCavalo || '';
																				return placa && !placasVoltandoTop.has(placa);
																			})
																			.map((v, idx) => {
																				const placa = v.nm_placa || v.placa || v.placaCavalo || '';
																				return (
																					<option key={placa + idx} value={placa}>
																						{placa}
																					</option>
																				);
																			})}
																	</select>
																	{isAguardando && veiculosVoltandoTop.length > 0 && !value && (
																		<div style={{ fontSize: '10px', color: '#1d4ed8', marginTop: 3, textAlign: 'center', fontWeight: 600 }}>
																			Top {veiculosVoltandoTop.length} mais próximos já no topo
																		</div>
																	)}
																</div>
															)
														) : (editable && (!isCancelada || col === 'STATUS')) ? (
															<input
																type="text"
																defaultValue={value}
																onBlur={e => handleAutoSave(col, e.target.value)}
																style={{ width: '100%', border: 'none', background: 'transparent', textAlign: 'center' }}
															/>
														) : (
															<span>{value}</span>
														)}
													</td>
												);
											})}
										</tr>
									);
								});
							}
						})()}
					</tbody>
					</table>

					{/* ===== PAGINAÇÃO ===== */}
					{(() => {
						const rowsToRender = getMergedRows();
						const filteredRows = rowsToRender.filter((r: any) => {
							if (!showCanceledRows && (r['STATUS'] || '').toUpperCase() === 'CANCELADA') return false;
							return true;
						});
						const pageSize = 20;
						const totalPages = Math.max(1, Math.ceil(filteredRows.length / pageSize));
						const currentPage = 1;
						const startIdx = (currentPage - 1) * pageSize;
						const endIdx = Math.min(startIdx + pageSize, filteredRows.length);

						return (
							<div className="ctower-prog-pagination">
								<span className="ctower-prog-pagination-info">
									Mostrando {filteredRows.length > 0 ? startIdx + 1 : 0} a {endIdx} de {filteredRows.length} registros
								</span>
								<div className="ctower-prog-pagination-controls">
									<button className="ctower-prog-pagination-btn" disabled={currentPage === 1}>← Anterior</button>
									<span className="ctower-prog-pagination-page">{currentPage} de {totalPages}</span>
									<button className="ctower-prog-pagination-btn" disabled={currentPage === totalPages}>Próxima →</button>
								</div>
							</div>
						);
					})()}

				</div>
				) : (
				<div className="ctower-viagem-wrapper">
					{(() => {
						let viagensAtivas = getViagensAtivas();
						if (buscaCVA.trim() !== '') {
							const busca = buscaCVA.trim().toLowerCase();
							viagensAtivas = viagensAtivas.filter(v =>
								(v.cva || '').toLowerCase().includes(busca) ||
								(v.veiculo.placaCavalo || '').toLowerCase().includes(busca) ||
								(v.motorista.nome || '').toLowerCase().includes(busca)
							);
						}

						const totalKm = viagensAtivas.reduce((s, v) => s + v.progresso.realizado, 0);
						const mediaRestante = viagensAtivas.length > 0
							? Math.round(viagensAtivas.reduce((s, v) => s + v.progresso.restante, 0) / viagensAtivas.length)
							: 0;

						const parseTempoParadoEmMinutos = (tempo?: string): number => {
							if (!tempo || tempo === '-') return 0;
							const match = String(tempo).match(/(\d{1,2}):(\d{2})/);
							if (!match) return 0;
							return Number(match[1]) * 60 + Number(match[2]);
						};

						const foraRotaCount = viagensAtivas.filter(v => (v.progresso.status || '').toLowerCase().includes('fora')).length;
						const paradasProlongadasCount = viagensAtivas.filter(v => parseTempoParadoEmMinutos(v.progresso.tempoParado) > 30).length;
						const problemasRastreadorCount = viagensAtivas.filter(v => {
							const status = (v.progresso.status || '').toLowerCase();
							const rastreador = (v.veiculo.rastreador || '').toLowerCase();
							return status.includes('rastreador') || rastreador.includes('problema');
						}).length;
						const alertasCriticosCount = foraRotaCount + paradasProlongadasCount + problemasRastreadorCount;

						const metaDistancia = 1200;
						const distanciaPct = Math.max(0, Math.min(100, Math.round((totalKm / metaDistancia) * 100)));
						const entregasRealizadas = viagensAtivas.filter(v => {
							if (v.progresso.total <= 0) return false;
							return (v.progresso.realizado / v.progresso.total) >= 0.7;
						}).length;
						const metaEntregas = Math.max(8, viagensAtivas.length);
						const entregasPct = Math.max(0, Math.min(100, Math.round((entregasRealizadas / metaEntregas) * 100)));
						const otifPct = Math.max(0, Math.min(100, 95 - (foraRotaCount * 4) - (paradasProlongadasCount * 2)));

						const viagemParaMapa = viagensAtivas.find(v => {
							const placaSelecionadaNormalizada = normalizePlaca(v.veiculo.placaCavalo);
							const veiculoMonit = veiculosMonitoramento.find((item: any) => normalizePlaca(getPlacaValue(item)) === placaSelecionadaNormalizada);
							const lat = toCoordNumber(v.progresso.lat) ?? toCoordNumber(veiculoMonit?.latitude ?? veiculoMonit?.lat ?? veiculoMonit?.localizacao?.lat ?? veiculoMonit?.localizacao?.latitude);
							const lng = toCoordNumber(v.progresso.lng) ?? toCoordNumber(veiculoMonit?.longitude ?? veiculoMonit?.lng ?? veiculoMonit?.localizacao?.lng ?? veiculoMonit?.localizacao?.longitude);
							return lat !== undefined && lng !== undefined;
						});

						let mapaLat: number | undefined;
						let mapaLng: number | undefined;
						if (viagemParaMapa) {
							const placaSelecionadaNormalizada = normalizePlaca(viagemParaMapa.veiculo.placaCavalo);
							const veiculoMonit = veiculosMonitoramento.find((item: any) => normalizePlaca(getPlacaValue(item)) === placaSelecionadaNormalizada);
							mapaLat = toCoordNumber(viagemParaMapa.progresso.lat) ?? toCoordNumber(veiculoMonit?.latitude ?? veiculoMonit?.lat ?? veiculoMonit?.localizacao?.lat ?? veiculoMonit?.localizacao?.latitude);
							mapaLng = toCoordNumber(viagemParaMapa.progresso.lng) ?? toCoordNumber(veiculoMonit?.longitude ?? veiculoMonit?.lng ?? veiculoMonit?.localizacao?.lng ?? veiculoMonit?.localizacao?.longitude);
						}

						return (
							<>
								<div className="ctower-stats-row">
									<div className="ctower-stat-card ctower-stat-blue">
										<span className="ctower-stat-icon">🚚</span>
										<div>
											<div className="ctower-stat-value">{viagensAtivas.length}</div>
											<div className="ctower-stat-label">Viagens Ativas</div>
											<div className="ctower-stat-sub">Em andamento</div>
										</div>
									</div>
									<div className="ctower-stat-card ctower-stat-green">
										<span className="ctower-stat-icon">🛣️</span>
										<div>
											<div className="ctower-stat-value">{totalKm.toLocaleString('pt-BR')} km</div>
											<div className="ctower-stat-label">Distância Total</div>
											<div className="ctower-stat-sub">Total percorrido</div>
										</div>
									</div>
									<div className="ctower-stat-card ctower-stat-purple">
										<span className="ctower-stat-icon">⏱️</span>
										<div>
											<div className="ctower-stat-value">{mediaRestante} km</div>
											<div className="ctower-stat-label">Tempo Médio Restante</div>
											<div className="ctower-stat-sub">Média das viagens</div>
										</div>
									</div>
									<div className="ctower-stat-card ctower-stat-orange">
										<span className="ctower-stat-icon">🏁</span>
										<div>
											<div className="ctower-stat-value">{viagensAtivas.length}</div>
											<div className="ctower-stat-label">Entrega Prevista Hoje</div>
											<div className="ctower-stat-sub">Viagens</div>
										</div>
									</div>
								</div>

								<div className="ctower-viagem-main-grid">
									<div className="ctower-viagem-main-left">
										<div className="ctower-viagem-panel">
											<div className="ctower-viagem-panel-title">Viagens em Andamento</div>
											{viagensAtivas.length === 0 ? (
												<div className="ctower-viagem-empty">
													Nenhuma viagem ativa para este filtro.
												</div>
											) : (
												<div className="ctower-viagem-list">
													{viagensAtivas.map((v, idx) => {
														const percentual = v.progresso.total > 0
															? Math.max(0, Math.min(100, Math.round((v.progresso.realizado / v.progresso.total) * 100)))
															: 0;
														const isParado = !!v.progresso.tempoParado && v.progresso.tempoParado !== '-';
														const statusLabel = (v.progresso.status || '').replace(/_/g, ' ');
														const statusLower = statusLabel.toLowerCase();
														const statusClass = statusLower.includes('fora')
															? 'ctower-v2-badge-fora-rota'
															: isParado
																? 'ctower-v2-badge-parado'
																: statusLower.includes('movimento') || statusLower.includes('transito')
																	? 'ctower-v2-badge-movimento'
																	: 'ctower-v2-badge-default';

														return (
															<div className="ctower-v2-card" key={idx} onClick={() => { setViagemSelecionada(v); setAbaDetalhe('detalhes'); }}>
																<div className="ctower-v2-left">
																	<div className="ctower-v2-route">
																		<span>{v.origem}</span>
																		<span className="ctower-v2-route-arrow">→</span>
																		<span>{v.destino.nome}</span>
																	</div>
																	<div className="ctower-v2-tags">
																		<span className="ctower-v2-tag ctower-v2-tag-cva">CVA: {v.cva || '-'}</span>
																		<span className="ctower-v2-tag">Placa: {v.veiculo.placaCavalo || '-'}</span>
																		<span className="ctower-v2-tag">Tipo: {v.veiculo.tipoCarreta || '-'}</span>
																	</div>
																	<div className="ctower-v2-loc-row">
																		<span className="ctower-v2-location">📍 Posição: <b>{v.progresso.cidade || '-'}</b></span>
																		<span className={`ctower-v2-badge ${statusClass}`}>{statusLabel || 'Sem status'}</span>
																		{isParado && <span className="ctower-v2-badge ctower-v2-badge-parado">PARADO {v.progresso.tempoParado}</span>}
																		<span className="ctower-v2-prev">Prev. Chegada SJP: {v.destino.prevFim}</span>
																	</div>
																</div>

																<div className="ctower-v2-middle">
																	<div className="ctower-v2-prog-header">
																		<span>Progresso da viagem</span>
																		<span className="ctower-v2-pct">{percentual}%</span>
																	</div>
																	<div className="ctower-v2-bar-bg">
																		<div className="ctower-v2-bar-fg" style={{ width: `${percentual}%` }} />
																	</div>
																	<div className="ctower-v2-km">
																		<span>🗺️</span>
																		<span>{v.progresso.realizado} km de {v.progresso.total} km</span>
																	</div>
																</div>

																<div className="ctower-v2-right">
																	<div>
																		<div className="ctower-v2-right-label">Restante</div>
																		<div className="ctower-v2-right-value">{v.progresso.restante} km</div>
																	</div>
																	<div className="ctower-v2-driver-row">
																		<div>
																			<div className="ctower-v2-right-label">Motorista</div>
																			<div className="ctower-v2-driver-name">{v.motorista.nome || '-'}</div>
																		</div>
																		<span className="ctower-v2-person-icon">👤</span>
																	</div>
																	<div className="ctower-v2-expand">⌄</div>
																</div>
															</div>
														);
													})}
												</div>
											)}

											<div className="ctower-alert-cards-row">
												<div className="ctower-alert-card ctower-alert-critical">
													<div className="ctower-alert-title">Alertas Críticos</div>
													<div className="ctower-alert-value">{alertasCriticosCount}</div>
													<div className="ctower-alert-sub">Requerem atenção</div>
												</div>
												<div className="ctower-alert-card ctower-alert-fora-rota">
													<div className="ctower-alert-title">Fora de Rota</div>
													<div className="ctower-alert-value">{foraRotaCount}</div>
													<div className="ctower-alert-sub">Viagens</div>
												</div>
												<div className="ctower-alert-card ctower-alert-paradas">
													<div className="ctower-alert-title">Paradas Prolongadas</div>
													<div className="ctower-alert-value">{paradasProlongadasCount}</div>
													<div className="ctower-alert-sub">Mais de 30 min</div>
												</div>
												<div className="ctower-alert-card ctower-alert-rastreador">
													<div className="ctower-alert-title">Problemas de Rastreador</div>
													<div className="ctower-alert-value">{problemasRastreadorCount}</div>
													<div className="ctower-alert-sub">Viagem</div>
												</div>
											</div>
										</div>
									</div>

									<div className="ctower-viagem-main-right">
										<div className="ctower-side-panel">
											<div className="ctower-side-panel-head">
												<div className="ctower-side-panel-title">Mapa de Localização</div>
												<button
													type="button"
													className="ctower-map-expand-btn"
													onClick={() => {
														if (!viagemParaMapa) return;
														setViagemSelecionada(viagemParaMapa);
														setAbaDetalhe('posicoes');
													}}
												>
													Ver em Tela Cheia
												</button>
											</div>
											<div className="ctower-map-shell">
												{mapaLat !== undefined && mapaLng !== undefined && viagemParaMapa ? (
													<MiniMap
														lat={mapaLat}
														lng={mapaLng}
														placa={viagemParaMapa.veiculo.placaCavalo}
														width="100%"
														height={345}
														zoom={9}
														interactive={true}
													/>
												) : (
													<div className="ctower-map-empty">Sem coordenadas disponíveis para exibir o mapa.</div>
												)}
											</div>
											<div className="ctower-map-legend">
												<span><i className="ctower-dot ctower-dot-mov" />Em andamento</span>
												<span><i className="ctower-dot ctower-dot-stop" />Parado</span>
												<span><i className="ctower-dot ctower-dot-off" />Fora de Rota</span>
											</div>
										</div>

										<div className="ctower-side-panel">
											<div className="ctower-side-panel-title" style={{ marginBottom: 10 }}>Performance do Dia</div>
											<div className="ctower-perf-grid">
												<div className="ctower-perf-card">
													<div className="ctower-perf-title">Distância Percorrida</div>
													<div className="ctower-perf-number">{totalKm.toLocaleString('pt-BR')} km</div>
													<div className="ctower-perf-meta">Meta: {metaDistancia.toLocaleString('pt-BR')} km</div>
													<div className="ctower-perf-bar"><span style={{ width: `${distanciaPct}%` }} /></div>
													<div className="ctower-perf-pct">{distanciaPct}%</div>
												</div>
												<div className="ctower-perf-card">
													<div className="ctower-perf-title">Entregas Realizadas</div>
													<div className="ctower-perf-number">{entregasRealizadas}</div>
													<div className="ctower-perf-meta">Meta: {metaEntregas}</div>
													<div className="ctower-perf-bar"><span style={{ width: `${entregasPct}%` }} /></div>
													<div className="ctower-perf-pct">{entregasPct}%</div>
												</div>
												<div className="ctower-perf-card">
													<div className="ctower-perf-title">OTIF (No Prazo)</div>
													<div className="ctower-perf-number">{otifPct}%</div>
													<div className="ctower-perf-meta">Meta: 95%</div>
													<div className="ctower-perf-bar"><span style={{ width: `${otifPct}%` }} /></div>
													<div className="ctower-perf-pct">{otifPct}%</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="ctower-viagem-footer">
									<span>Última atualização: {new Date().toLocaleString('pt-BR')}</span>
									<span className="ctower-live-indicator">Ao vivo</span>
								</div>
							</>
						);
					})()}
				</div>
			)}
				{viagemSelecionada && (
					<div className="ctower-detail-overlay" onClick={() => setViagemSelecionada(null)}>
						<div className="ctower-detail-modal" onClick={(e) => e.stopPropagation()}>
							<div className="ctower-detail-tabs">
								<button className={`ctower-detail-tab ${abaDetalhe === 'detalhes' ? 'active' : ''}`} onClick={() => setAbaDetalhe('detalhes')}>Detalhes</button>
								<button className={`ctower-detail-tab ${abaDetalhe === 'posicoes' ? 'active' : ''}`} onClick={() => setAbaDetalhe('posicoes')}>Posições</button>
								<button className={`ctower-detail-tab ${abaDetalhe === 'eventos' ? 'active' : ''}`} onClick={() => setAbaDetalhe('eventos')}>Eventos</button>
								<button className={`ctower-detail-tab ${abaDetalhe === 'alertas' ? 'active' : ''}`} onClick={() => setAbaDetalhe('alertas')}>Alertas</button>
								<button className="ctower-detail-close" onClick={() => setViagemSelecionada(null)}>Fechar</button>
							</div>

							{abaDetalhe === 'detalhes' ? (
								<div className="ctower-detail-body">
									<div className="ctower-detail-grid">
										
										<div><strong>Cavalo</strong><p>{viagemSelecionada.veiculo.placaCavalo}</p></div>
										<div><strong>Carreta</strong><p>{viagemSelecionada.veiculo.placaCarreta || '-'}</p></div>
										<div><strong>Motorista</strong><p>{viagemSelecionada.motorista.nome}</p></div>
										<div><strong>Progresso</strong><p>{viagemSelecionada.progresso.realizado}km de {viagemSelecionada.progresso.total}km</p></div>
										<div><strong>CVA</strong><p>{viagemSelecionada.cva || '-'}</p></div>
									</div>	
									<table className="ctower-detail-table">
										<thead>
											<tr>
												<th>Tipo</th>
												<th>Referencia</th>
												<th>Chegada Prevista</th>
												<th>Chegada Realizada</th>
												<th>Saida Prevista</th>
												<th>Saida Realizada</th>												
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Inicio</td>
												<td>{viagemSelecionada.origem}</td>
												<td>{viagemSelecionada.prevInicio}</td>
												<td>{viagemSelecionada.inicioReal}</td>
												<td>{viagemSelecionada.prevInicio}</td>
												<td>{viagemSelecionada.inicioReal}</td>
												
											</tr>
											<tr>
												<td>Descarga</td>
												<td>{viagemSelecionada.destino.nome}</td>
												<td>{viagemSelecionada.destino.prevFim}</td>
												<td>{viagemSelecionada.destino.chegada}</td>
												<td>{viagemSelecionada.destino.prevFim}</td>
												<td>{viagemSelecionada.destino.chegada}</td>												
											</tr>
										</tbody>
									</table>
								</div>
							) : abaDetalhe === 'posicoes' ? (
								<div className="ctower-detail-body" style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr', gap: 16, alignItems: 'start' }}>
									<div>
										<div style={{ fontWeight: 700, marginBottom: 8, color: '#1f2937' }}>Mapa de Localização</div>
										{(() => {
											const placaSelecionadaNormalizada = normalizePlaca(viagemSelecionada.veiculo.placaCavalo);
											const veiculoMonitSelecionado = veiculosMonitoramento.find((v: any) => normalizePlaca(getPlacaValue(v)) === placaSelecionadaNormalizada);
											const latMonitoramento = toCoordNumber(viagemSelecionada.progresso.lat) ?? toCoordNumber(veiculoMonitSelecionado?.latitude ?? veiculoMonitSelecionado?.lat ?? veiculoMonitSelecionado?.localizacao?.lat ?? veiculoMonitSelecionado?.localizacao?.latitude);
											const lngMonitoramento = toCoordNumber(viagemSelecionada.progresso.lng) ?? toCoordNumber(veiculoMonitSelecionado?.longitude ?? veiculoMonitSelecionado?.lng ?? veiculoMonitSelecionado?.localizacao?.lng ?? veiculoMonitSelecionado?.localizacao?.longitude);
											const ultimoPontoTrilha = trajetoriaPontos.length > 0 ? trajetoriaPontos[trajetoriaPontos.length - 1] : null;
											const lat = latMonitoramento ?? ultimoPontoTrilha?.lat;
											const lng = lngMonitoramento ?? ultimoPontoTrilha?.lng;

											if (lat !== undefined && lng !== undefined) {
												return (
													<div>
														<MiniMap
															lat={lat}
															lng={lng}
															placa={viagemSelecionada.veiculo.placaCavalo}
															width="100%"
															height={420}
															zoom={14}
															interactive={true}
															trail={trajetoriaPontos}
														/>
														<div style={{ marginTop: 8, fontSize: '0.84rem', color: '#475569' }}>
															{loadingTrajetoria ? 'Carregando trajetória...' : `Trajetória registrada: ${trajetoriaPontos.length} pontos`}
														</div>
													</div>
												);
											}

											return (
												<div style={{ border: '1px solid #e5e7eb', borderRadius: 8, minHeight: 420, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b' }}>
													Sem coordenadas disponíveis para esta viagem.
												</div>
											);
										})()}
									</div>

									<div style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: 12, background: '#f8fafc' }}>
										<div style={{ fontWeight: 700, marginBottom: 10, color: '#1f2937' }}>Dados da Posição</div>
										<div style={{ display: 'grid', gap: 8, fontSize: '0.92rem', color: '#334155' }}>
											<div><strong>Cavalo:</strong> {viagemSelecionada.veiculo.placaCavalo}</div>
											<div><strong>Status:</strong> {viagemSelecionada.progresso.status || '-'}</div>
											<div><strong>Cidade:</strong> {viagemSelecionada.progresso.cidade || '-'}</div>
											<div><strong>Posição:</strong> {viagemSelecionada.progresso.posicao || '-'}</div>
											<div><strong>Pontos de trajetória:</strong> {trajetoriaPontos.length}</div>
											<div><strong>Coordenadas:</strong> {(() => {
												const placaSelecionadaNormalizada = normalizePlaca(viagemSelecionada.veiculo.placaCavalo);
												const veiculoMonitSelecionado = veiculosMonitoramento.find((v: any) => normalizePlaca(getPlacaValue(v)) === placaSelecionadaNormalizada);
												const ultimoPontoTrilha = trajetoriaPontos.length > 0 ? trajetoriaPontos[trajetoriaPontos.length - 1] : null;
												const lat = toCoordNumber(viagemSelecionada.progresso.lat) ?? toCoordNumber(veiculoMonitSelecionado?.latitude ?? veiculoMonitSelecionado?.lat ?? veiculoMonitSelecionado?.localizacao?.lat ?? veiculoMonitSelecionado?.localizacao?.latitude) ?? ultimoPontoTrilha?.lat;
												const lng = toCoordNumber(viagemSelecionada.progresso.lng) ?? toCoordNumber(veiculoMonitSelecionado?.longitude ?? veiculoMonitSelecionado?.lng ?? veiculoMonitSelecionado?.localizacao?.lng ?? veiculoMonitSelecionado?.localizacao?.longitude) ?? ultimoPontoTrilha?.lng;
												return lat !== undefined && lng !== undefined ? `${lat.toFixed(6)}, ${lng.toFixed(6)}` : '-';
											})()}</div>
											<div><strong>Atualização:</strong> {new Date().toLocaleString('pt-BR')}</div>
										</div>
									</div>
								</div>
							) : (
								<div className="ctower-detail-placeholder">
									Aba <strong>{abaDetalhe}</strong> pronta para receber os detalhes desta viagem.
								</div>
							)}
							
						</div>
					</div>
					)}
			</div>
		);
	};

	const VEICULOS_CATEGORIA_POR_PAGINA = 5;

	export default ControlTowerModule;